const messages = {
  sq: {
    message: {
      resetDisplayItemConfirm: 'A jeni i sigurt se deshironi te ndryshoni statusin e porosise?',
      closeAllOrdersDisplayConfirm: 'A jeni i sigurt se deshironi të mbyllni të gjitha porositë? Veprimi nuk mund te anulohet.',
      pendingOrders: 'Porosite ne pritje',
      noSearchResult: 'Kerkimi nuk ka rezultat.',
      restartMessage: 'POSTOM ristartohet pas...',
      login: 'Login',
      logout: 'Logout',
      details: 'Detajet',
      transferOrders: 'Transfero porositë',
      changeWaiter: 'Ndërro kamarierin',
      orderClosed: 'Porosia e mbyllur',
      startOfShift: 'Fillimi i ndërrimit',
      endOfShift: 'Mbarimi i ndërrimit',
      successfulStartOfShift: 'Fillimi i ndërrimit i sukseshëm.',
      successfulEndOfShift: 'Mbarimi i ndërrimit i sukseshëm.',
      scanQrCode: 'Skano QR kodin',
      confirmOrderTransfer: 'Ju lutem konfirmoni transferet e porosive',
      currentWaiter: 'Kamarieri aktual',
      newWaiter: 'Kamarieri i ri',
      changeWaiterMsg: 'Kërkesa juaj për të ndryshuar kamarierin është dërguar. Nëse kamarieri tjetër e pranon kërkesën, transferi do të realizohet.',
      orderCloseConfirmation: 'A jeni i sigurt se deshironi te kompletoni kete porosi?',
      serachSubjectOrFiscal: 'Kerko me subjekt/numër fiskal',
      validInvoiceWithoutStamp: 'Kjo faturë është e vlefshme pa vulë.',
      removeOrderMessage: 'Porosia nuk mund te anulohet sepse ka produkte.',
      freeTableMessage: 'Tavolina nuk mund të lirohet, ka porosi aktive.',
      closeOrderMessage: 'Porosia është e mbyllur. Nuk mund të shtoni artikuj në porosi.',
      closeOrderConfirmMessage: 'A jeni i sigurt se deshironi ta mbyllni porosine dhe te leshoni kuponin fiskal?',
      closeOrderConfirmMessageReservation: 'A eshte porosia e lidhur me kete rezervim?',
      printFiscalConfirm: 'A jeni i sigurt se deshironi te leshoni kuponin fiskal?',
      noProductMessage: 'Porosia është e zbrazët. Nuk mund të shtypni kupon fiskal.',
      noProductRetailMessage: 'Porosia është e zbrazët. Nuk mund të përfundoni shitjen.',
      chooseTotalDiscount: 'Zgjedhni zbritjen totale',
      chooseProdDiscount: 'Zgjedhni zbritjen per produkt',
      scanClientCard: 'Skeno kartelën e klientit',
      clientNotExist: 'Kartela nuk ekziston në bazën e të dhënave. Vendosni të dhënat e klientit për të krijuar',
      scanCardToApproveDamage: 'Skeno kartelen ose sheno PIN-in per te aprovuar demtimin',
      deliveryConfirmMessage: 'Jeni i sigurt se deshironi te kompletoni porosine delivery?',
      splitOrderMessage: 'Nuk mund të ndani të gjithë porosinë. Zgjidhni vetëm disa.',
      clientLeft: 'Klienti ka ikur.',
      houseCompliments: 'Nga shtepia',
      waitersMistake: 'Gabim nga kamarieri',
      finalizeGoodsReturn: 'A jeni i sigurt se dëshironi të finalizoni kthimin e mallit?',
      goodsReturnDifference: 'Diferenca e kthimit të mallit',
      noApproveAccess: 'Nuk keni të drejtë të bëni aprovimin!',
      noBarcode: 'nuk ka barkod',
      noCode: 'nuk ka kod',
      notInStock: 'nuk ka në stok!',
      stockValue: 'Ne stok gjenden vetem',
      noAdminPrivileges: 'Nuk keni privilegjet e administratorit!',
      finalizeCashOut: 'Jeni i sigurt se deshironi te finalizoni barazimin?',
      waiterCashedOut: 'Kamarieri u barazua.',
      approveExit: 'Aprovo mbylljen/minimizimin e programit',
      scanCardToExit: 'Skeno kartelen ose sheno PIN-in per te aprovuar veprimin',
      sendReport: 'Dërgo raportin',
      emailSent: 'Email është dërguar me sukses!',
      emailFailed: 'Email nuk është dërguar. Ju lutemi provoni përsëri.',
      invalidEmail: 'Email nuk eshte valid!',
      sending: 'Duke u derguar',
      device_mismatch: 'Porosia e njejtë është e hapur në një paisje tjetër.Ndryshimet e porosisë lejohen vetëm në atë paisje.',
      confirm_admin_changes: 'Cdo ndryshim i bere do te mbishkruaj ndryshimet qe i ka bere kamarieri nderkohe. Deshironi te vazhdoni?',
      DOCUMENTISCLOSED_CANNOTFINALIZE: 'Dokumenti nuk mund te finalizohet sepse eshte finalizuar me heret!',
      DOCUMENTISCLOSED_CANNOTSAVE: 'Produkti nuk mund te ruhet sepse dokumenti eshte finalizuar me heret!',
      scanCardToApproveFreePayment: 'Skeno kartelen ose sheno PIN-in per te aprovuar pa pagesen',
      productsUpdatedWithVat: 'TVSH u aplikua te te gjitha produktet',
      tablesUpdatedWithProduct: 'Produkti u aplikua te te gjitha tavolinat',
      chooseTemplate: 'Zgjedhni mesazhin!',
      cannotDeleteItem: 'Produkti nuk mund te fshihet nga porosia!',
      serviceClientFormError: 'Telefoni, emri i femiut dhe emri i prindit nuk mund te jene te zbrazet!',
      contiueWithService: 'Vazhdo me sherbimin?',
      CANNOTCHANGEDOCUMENTLESSLASTSTOCKRESET: 'Nuk mund te fshihet asnje ndryshim i stokut qe eshte realizuar para prerjes se fundit te stokut!',
      salesAmountChanged: 'Shuma e shitjes ka ndryshuar nderkohe.',
      menus: {
        productExists: 'Produkti ekziston në meny.',
        pleaseAddProduct: 'Ju lutem shtoni produkte në Meny.',
        cantBeEmpty: 'Meny e zbrazët nuk mund të ruhet.',
        confirmProdRemove: 'Jeni i sigurt se dëshironi te largoni produktin?',
        confirmRemove: 'Jeni i sigurt se dëshironi të fshini menyn?'
      },
      categories: {
        confirmDiscountChanges: 'Lirimet e produkteve te kesaj kategorie do te mbishkruhen. Deshironi te vazhdoni?',
        confirmRemove: 'Jeni i sigurt se dëshironi të fshini kategorinë?'
      },
      products: {
        confirmRemove: 'Jeni i sigurt se dëshironi të fshini produktin?',
        confirmIngredientsRemove: 'A deshironi te fshini perberesin e produktit?',
        addProductIngredients: 'Ju lutem shtoni perberesit e produktit, lista nuk mund te jete e zbrazet.',
        enabledHappyHour: 'Shfaq vetem me Happy Hour',
        cannotRemoveLastProduct: 'Perberesi i fundit nuk mund te fshihet pa e shtuar nje perberes tjeter!',
        productDeleteFailed: 'Produkti nuk mund te fshihet sepse perdoret si perberes ne produktet me poshte:'
      },
      tablePlan: {
        confirmRemove: 'Jeni i sigurt se deshironi te fshini planin?',
        successUpdate: 'Plani eshte perditesuar me sukses!'
      },
      stock: {
        confirmRemove: 'Jeni i sigurt se dëshironi te fshini ndryshimin e stokut?',
        confirmProdRemove: 'Jeni i sigurt se dëshironi te largoni produktin?',
        finalizePurchase: 'Dëshironi të finalizoni blerjen?',
        confirmStockReset: 'Dëshironi te finalizoni prerjen e stokut? Te dhenat nuk mund te ndryshohen pas kesaj!'
      },
      points: {
        confirmRemove: 'Jeni i sigurt se dëshironi te fshini pikën?'
      },
      purchases: {
        confirmRemove: 'Jeni i sigurt se dëshironi te fshini blerjen?',
        finalizePurchase: 'Dëshironi të finalizoni blerjen?'
      },
      printers: {
        confirmRemove: 'Jeni i sigurt se dëshironi te fshini printerin?',
        printingError: 'Porosia nuk është shtypur! Ju lutem sigurohuni që printeri është i lëshuar dhe është i lidhur me PC.Nëse prap nuk funksionon, ju lutem kontaktoni personin përgjegjës për printer dhe teknikë.'
      },
      units: {
        confirmRemove: 'Jeni i sigurt se dëshironi te fshini njësine?'
      },
      vats: {
        confirmRemove: 'Jeni i sigurt se deshironi te fshini normen tatimore?',
        vatRateExist: 'Kjo normë e TVSH ekziston'
      },
      users: {
        cannotChangeAdminRole: 'Nuk mund te ndryshoni rolin e administratorit!',
        notAdminUser: 'Nuk keni privilegje te administratorit per te fshire kete perdorues!',
        confirmRemove: 'Jeni i sigurt se deshironi te fshini perdoruesin?',
        nameNotNull: 'Emri nuk mund te jete i zbrazet!',
        pinNotNull: 'PIN nuk mund te jete i zbrazet!',
        roleNotNull: 'Roli nuk mund te jete i zbrazet!',
        personalNumberNotNull: 'Numri personal nuk mund te jete i zbrazet!',
        emailNotNull: 'Email nuk mund te jete i zbrazet!',
        setStaffLimit: 'Shenoni limitin e ushqimit per perdoruesin!'
      },
      vendors: {
        confirmRemove: 'Jeni i sigurt se deshironi te fshini furnitorin?'
      },
      config: {
        changeApplied: 'Ndryshimi është aplikuar. Kyçuni përsëri për të parë ndryshimin. Faleminderit',
        bankInfoMandatory: 'Banka dhe llogaria bankare duhet te jene te plotesuara!',
        chooseOperatingCountry: 'Duhet te zgjedhni shtetin ku operoni!'
      },
      vouchers: {
        confirmRemove: 'Jeni i sigurt se deshironi te fshini zbritjen?'
      },
      clients: {
        confirmRemove: 'Jeni i sigurt se deshironi te fshini klientin?'
      },
      validations: {
        cannotBeEmpty: 'Nuk mund të jetë e zbrazët!',
        notNullLettersAndNumbers: 'Nuk mund te jete e zbrazet dhe duhet te permbaje vetem numra dhe shkronja.',
        validNameAndFiscalNumber: 'Emri dhe Numri fiskal nuk mund te jene te zbrazet!',
        validProductNameAndTotal: 'Emri i Produktit dhe Totali nuk mund te jene te zbrazeta!',
        cannotBeNegativeValue: 'Nuk mund te jete vlere negative.',
        nameCannotBeEmpty: 'Emri nuk mund të jetë i zbrazët!',
        doserCannotBeNegativeValue: 'Dozeri duhet te jete me i madh se zero ose i zbrazet!'
      },
      expenses: {
        confirmCloseAndRemove: 'A jeni i sigurt qe deshironi ta mbyllni kete faqe? Te gjitha shpenzimet qe nuk jane ruajtur do te fshihen!'
      }
    },
    buttons: {
      splitCourse: 'Ndaj kursin',
      fiscalCopy: 'Fiskal kopje',
      continueWithoutCoupon: 'Vazhdo pa kupon',
      continueWithCoupon: 'Vazhdo me kupon',
      groupedOrders: 'Porosite e grupuara',
      changePayment: 'Ndrysho pagesen',
      save: 'Ruaj',
      saveDraft: 'Ruaj draft',
      cancel: 'Anulo',
      continue: 'Vazhdo',
      close: 'Mbyll',
      print: 'Printo',
      split: 'Ndaj',
      goBack: 'Kthehu',
      finalize: 'Finalizo',
      fiscal: 'Fiskal',
      notFiscal: 'Jo fiskal',
      finish: 'Përfundo',
      finishOptionalPrintTotal: 'Perfundo me kupon',
      qrCode: 'QR kodi',
      invoice: 'Faturë',
      filterDates: 'Filtro datat',
      generateReport: 'Gjenero raportin',
      add: 'Shto',
      addExpenses: 'Shto shpenzim',
      cashOut: 'Barazo',
      send: 'Dërgo',
      email: 'Email',
      refresh: 'Fresko',
      tryAgain: 'Provoni përsëri',
      refuse: 'Refuzo',
      changeClient: 'Ndrro klientin',
      menus: {
        addMenu: 'Shto meny',
        deleteMenu: 'Fshij meny',
        deletePriceList: 'Fshij cmimoren',
        addAllProducts: 'Shto te gjitha produktet',
        addPriceList: 'Shto cmimore'
      },
      categories: {
        addCategory: 'Shto kategori'
      },
      products: {
        addProduct: 'Shto produkt',
        export: 'Eksporto'
      },
      tablePlan: {
        addPlan: 'Shto plan',
        addTable: 'Shto tavolinë',
        deleteTable: 'Fshij tavolinë',
        addMultipleTables: 'Shto disa'
      },
      stock: {
        addProduct: 'Shto produkt'
      },
      points: {
        addPoint: 'Shto pikë',
        pointName: 'Emri i pikës'
      },
      printers: {
        addPrinter: 'Shto printer',
        printerName: 'Emri i printerit',
        printerPort: 'Porti i printerit',
        printerType: 'Tipi i printerit',
        fiscalPrinterType: 'Tipi i printerit fiskal',
        letterDimensions: 'Dimenzioni i letrës',
        dynamicPath: 'Pathi dinamik'
      },
      units: {
        addUnit: 'Shto njësi'
      },
      vats: {
        addVat: 'Shto TVSH',
        vatRate: 'Norma e TVSH'
      },
      users: {
        addUser: 'Shto përdorues'
      },
      vendors: {
        addVendor: 'Shto furnitorë',
        vendorName: 'Emri i furnitorit',
        chooseVendor: 'Zgjedh furnitorin'
      },
      locations: {
        addLocation: 'Shto lokacion'
      },
      clients: {
        addClient: 'Shto klient'
      },
      happyHours: {
        addHappyHour: 'Shto Happy Hour'
      },
      makers: {
        addMaker: 'Shto prodhues',
        makerName: 'Emri i prodhuesit',
        chooseMaker: 'Zgjedh prodhuesin'
      },
      displays: {
        addDisplay: 'Shto ekran',
        displayName: 'Emri'
      }
    },
    labels: {
      receivedBy: 'Pranuar nga',
      outgoingDocument: 'Dokument dales',
      displayControllerPermission: 'Kontrollues ekrani',
      advancedConfiguration: 'Konfigurimi i avancuar',
      productConfigurationType: 'Tipi i konfigurimit',
      reason: 'Arsye',
      required: 'Kjo fushë është e kërkuar',
      freePaymentWithFiscal: 'Pa pagese me fiskal',
      changePaymentMethodAllOrders: 'Ndrysho pagesen per te gjitha porosite',
      liveTickerAllOrders: 'Live ticker: të gjitha porositë',
      currencyExchange: 'Kembimi valutor',
      excludedVat: 'Perjashtuar TVSH',
      excludedVatCode: 'Kodi i perjashtimit nga TVSH',
      finished: 'E përfunduar',
      showAll: 'Shfaq të gjitha',
      expense: 'Shpenzim',
      freeTables: ' TE LIRA',
      reservationsArriving: 'Brenda 30 min',
      reservationClientPriority: 'Klient me prioritet',
      additionalInfo: 'Informata shtese',
      tablesWithoutReservations: 'Tavolina te lira',
      changeReservationStatus: 'Ndrysho statusin e rezervimit',
      reservationStatusUpdateFailed: 'Ndryshimi i statusit te rezervimit deshtoi!',
      reservationDeleteConfirmation: 'Deshironi te fshini rezervimin?',
      showed: 'Ka ardhur',
      notShowed: 'Nuk ka ardhur',
      clientAdditionalInfo: 'Informacione shtesë për klientin',
      newReservation: 'Rezervim i ri',
      numberPersons: 'Numri i personave',
      reservations: 'Rezervimet',
      totalWithoutDiscount: 'Totali para zbritjes',
      serviceFee: 'Tarife sherbimi',
      serviceFeeType: 'Tarife sherbimi %',
      serviceFeeAutomatic: 'Tarife sherbimi automatike',
      courseSpliter: 'Ndaj kursin',
      employeeTip: 'Bakshishi',
      deleteOrderPermission: 'Lejo fshirjen e porosive',
      orderDeleteConfirmation: 'Jeni te sigurt qe deshironi te fshini porosine?',
      delete: 'Fshij',
      avgPrice: 'Cmimi mesatar',
      sellPriceWithVAt: 'Cmimi i shitjes (me TVSH)',
      totalSellPriceWithVAt: 'Totali i cmimit te shitjes',
      clearCreateNew: 'Pastro / Krijo klient te ri',
      duePayment: 'Borxh',
      loanPermission: 'Aktivizo borxhet',
      minDate: 'Data e fillimit',
      maxDate: 'Data e mbarimit',
      numberOfOrders: 'Numri i porosive',
      selectedToPay: 'Per te paguar',
      paidProducts: 'Pagesat e pjesshme',
      ordersCount: 'Nr. i porosive',
      onlinePaymentProcessing: 'Duke procesuar ...',
      onlinePaymentCanceled: 'Anuluar/Deshtuar!',
      onlinePaymentSuccess: 'Sukses.',
      changePaymentMethod: 'Ndrysho pagesen',
      refreshIn: 'Refresh per',
      identifierCode: 'Kodi identifikues',
      writeDescription: 'Sheno pershkrimin',
      apiCode: 'API kodi',
      doNotPrint: 'Mos printo',
      calculatePrice: 'Kalkulo cmimin',
      actualPrice: 'Cmimi aktual',
      newPrice: 'Cmimi i ri',
      displayInInterval: 'Shfaq ne interval',
      ingredient: 'Shtojce',
      day: 'Dita',
      month: 'Muji',
      year: 'Viti',
      birthDate: 'Data e lindjes',
      pin: 'PIN',
      active: 'Aktiv',
      inactive: 'Joaktiv',
      activate: 'Aktivizo',
      activateDeductions: 'Aktivizoni zbritjet',
      order: 'Porosit',
      orders: 'Porositë',
      theOrder: 'Porosia',
      orderAndContinue: 'Porosit + Vazhdo',
      information: 'Informatë',
      printReceipt: 'Shtyp me fiskal',
      printWReceipt: 'Shtyp pa fiskal',
      clearOrder: 'Pastro porosinë',
      clearTable: 'Liro tavolinën',
      cancelOrder: 'Anulo porosinë',
      splitOrder: 'Ndaj porosinë',
      product: 'Produkti',
      products: 'Produktet',
      productType: 'Tipi i produktit',
      quantity: 'Sasia',
      total: 'Totali',
      totalAmount: 'Shuma totale',
      discount: 'Zbritje | Zbr.',
      discounts: 'Lirimet',
      price: 'Çmimi',
      phone: 'Telefoni',
      delivery: 'Delivery',
      takeAway: 'Me veti',
      inHouse: 'Ketu',
      table: 'Tavolina',
      tables: 'Tavolinat',
      amount: 'Shuma',
      waiter: 'Kamarieri',
      plan: 'Plani',
      free: 'E lire',
      open: 'Hapur',
      closed: 'Mbyllur',
      busy: 'E zene',
      status: 'Statusi',
      confirmation: 'Konfirmim',
      currentQuantity: 'Sasia aktuale',
      previousQuantity: 'Sasia e parafundit',
      difference: 'Diferenca',
      lastChange: 'Ndryshimi i fundit',
      date: 'Data',
      payment: 'Pagesa',
      collect: 'Inkaso',
      collected: 'Inkasuar',
      collection: 'Inkasimi',
      uncollected: 'Painkasuar',
      actions: 'Veprime',
      client: 'Klienti',
      deliveryClient: 'Delivery klienti',
      chooseEmployee: 'Zgjedhni punëtorin',
      business: 'Biznes',
      ngo: 'OJQ',
      search: 'Kërko',
      fiscalNumber: 'NUI',
      vatNumber: 'Numri i TVSH',
      businessNumber: 'Numbri i biznesit',
      registrationNumber: 'Numri i regjistrimit',
      name: 'Emri',
      address: 'Adresa',
      businessAddress: 'Adresa e biznesit',
      city: 'Qyteti',
      contactPerson: 'Kontakt personi',
      comment: 'Koment',
      email: 'Email',
      website: 'Website',
      contact: 'Kontakti',
      bank: 'Banka',
      bankAccount: 'Llogaria bankare',
      cash: 'kesh',
      code: 'Kodi',
      barcode: 'Barkodi',
      card: 'Kartelë',
      idCard: 'ID kartelë',
      seller: 'Shitës',
      buyer: 'Blerës',
      value: 'Vlera',
      valueWithVat: 'Vlera me TVSH',
      valueWithoutVat: 'Vlera pa TVSH',
      priceWithVat: 'Çmimi me TVSH',
      priceWithoutVat: 'Çmimi pa TVSH',
      vat: 'TVSH',
      chooseVat: 'Zgjedh TVSH',
      forPayment: 'Për pagesë',
      submitted: 'Dorëzoi',
      accept: 'Pranoj',
      from: 'Prej',
      to: 'Tek',
      until: 'Deri',
      fromTable: 'Prej tavolinës',
      toTable: 'Tek tavolina',
      staff: 'Staf',
      staffOrder: 'Porosit për staf',
      staffPrice: 'Çmimi për staf',
      damagedGoods: 'Dëmtim i mallit',
      damagedProduct: 'Produkt i dëmtuar',
      reportDamage: 'Raporto dëmtim',
      forFood: 'Per ushqim',
      chooseBank: 'Zgjedh bankë',
      chooseBanks: 'Zgjedh bankat',
      approveDamage: 'Aprovoni dëmtimin',
      chooseDate: 'Zgjedh datën',
      moneyChange: 'Kthimi',
      freeOfCharge: 'Pa pagesë',
      goodsReturn: 'Kthimi i mallit',
      return: 'Kthe',
      categories: 'Kategoritë',
      category: 'Kategoria',
      categoryType: 'Tipi i kategorisë',
      ranking: 'Renditja',
      autoRanking: 'Renditja automatike',
      rankingPrinter: 'Renditja printer',
      choose: 'Zgjedh',
      description: 'Përshkrimi',
      employee: 'Punëtori',
      user: 'Përdoruesi',
      vendor: 'Furnitori',
      time: 'Koha',
      paymentType: 'Tipi i pagesës',
      orderType: 'Tipi i porosisë',
      invoiceNumber: 'Nr. i faturës',
      document: 'Dokumenti',
      transfer: 'Transferi',
      start: 'Fillimi',
      end: 'Mbarimi',
      damages: 'Dëmtimet',
      expenses: 'Shpenzimet',
      totalSales: 'Shitje totale',
      mostSoldProd: 'Produkti më i shitur',
      mostSoldProdQuantity: 'Sasia produktit më të shitur',
      approvedBy: 'Aprovuar nga',
      clientName: 'Emri i klientit',
      clientCode: 'Kodi i klientit',
      clientCard: 'Kartela e klientit',
      cardNumber: 'Numri i kartelës',
      ordersNumber: 'Nr. i porosive',
      withDetails: 'Me detaje',
      clients: 'Klientët',
      type: 'Tipi',
      menuIcon: 'Ikona e menysë',
      addProduct: 'Shto produkt',
      addCategory: 'Shto kategori',
      authorizedPerson: 'Barazuesi',
      beginning: 'Starti',
      dailySales: 'Pazari ditorë',
      handedOver: 'Dorëzuar',
      kitchen: 'Kuzhinë',
      choosePrinter: 'Zgjedhe printerin/at',
      printer: 'Printer',
      bar: 'Shank',
      yes: 'Po',
      no: 'Jo',
      color: 'Ngjyra',
      receipt: 'kupon jo fiskal',
      menu: 'Meny',
      picture: 'Foto',
      chooseCategory: 'Zgjedh kategorinë',
      internalCode: 'Kodi',
      unit: 'Njësia',
      units: 'Njësitë',
      stockChange: 'Ndiko stokun',
      dynamicAmount: 'Pesha dinamike',
      simple: 'Thjeshtë',
      compound: 'Përbërë',
      combo: 'Kombo',
      comboQuantity: 'Kombo sasi',
      productsIngredients: 'Përbërësit e produktit',
      preSelected: 'Para-zgjedhun',
      preSelectedQuantity: 'Para-zgjedhun sasia',
      dynamic: 'Dinamike',
      recipe: 'Receta',
      default: 'Parazgjedhur',
      happyHour: 'Happy Hour',
      letter: 'Shkronja',
      number: 'Numri',
      lastMove: 'Lëvizja e fundit',
      addedRemovedQty: 'Sasia e shtuar/zvogëluar',
      draft: 'Draft',
      finalized: 'Finalizuar',
      view: 'Shiko',
      stock: 'Stoku',
      point: 'Pika',
      productAt: 'Produkti në ',
      choosePoint: 'Zgjedh pikën',
      ip: 'IP',
      rate: 'Norma',
      country: 'Shteti',
      currency: 'Valuta',
      uploadLogo: 'Ngarko logo (max. 2MB)',
      general: 'Gjenerale',
      port: 'Porti',
      other: 'Tjetër',
      level: 'Niveli',
      createdDate: 'Data e krijimit',
      role: 'Roli',
      personalNumber: 'Numri personal',
      dailyFoodLimit: 'Limiti per ushqim (ditore)',
      calculateDiscount: 'Kalkulo zbritjen',
      productsPrice: 'Çmimi i produktit',
      priceWithDiscount: 'Çmimi me zbritje',
      paid: 'Paguar',
      remaining: 'Mbetur',
      sum: 'Shuma',
      sale: 'Shitje',
      typesOfSales: 'Tipet e shitjeve',
      qtyAndValue: 'Sasia dhe vlera',
      days: 'Ditët',
      choosePaymentType: 'Zgjedh tipin e pagesës',
      lastCount: 'Prerja e fundit',
      purchaseDate: 'Data e blerjes',
      invoiceDate: 'Data e faturës',
      stateReason: 'Shëno arsye',
      today: 'Sot',
      yesterday: 'Dje',
      lastSevenDays: '7 ditët e fundit',
      lastThirtyDays: '30 ditët e fundit',
      emails: 'Email-at',
      notification: 'Njoftim',
      programQuantity: 'Sasia program',
      physicalQuantity: 'Sasia fizike',
      differencePurchasePrice: 'Diferenca cmimi blerjes',
      differenceSellPrice: 'Diferenca cmimi shitjes',
      percentage: 'Përqindja',
      filters: 'Filtrat',
      choosePeriod: 'Filtro Periudhë',
      language: 'Gjuha',
      startEnd: 'Fillimi/Mbarimi',
      pcs: 'Copë',
      createdBy: 'Krijuar nga',
      maker: 'Prodhuesi',
      addMaker: 'Shto sipas prodhuesit',
      makers: 'Prodhuesit',
      searchClient: 'Kerko klientin',
      raportiDitor: 'Raporti ditor',
      advance: 'Avansi',
      doser: 'Dozeri',
      canCashOut: 'Barazo',
      waiterAccess: 'Qasja e kamarierit',
      userAccess: 'Qasja e perdoruesit (jo Admin)',
      system: 'Sistemi',
      configOrder: 'Porosia',
      othersQuantity: 'Sasia tjeter',
      totalOrders: 'Nr. porosive',
      displayOnlyResetProducts: 'Shfaq vetem te numeruara',
      orderNumber: 'Porosia',
      employeeDeleted: 'Fshire nga',
      deletedDate: 'Data e fshirjes',
      show: 'Shfaq',
      inhouse: 'Ketu',
      takeaway: 'Me veti',
      fiscal: 'Fiskal',
      noFiscal: 'Jo fiskal',
      noPayment: 'Pa pagese',
      invoice: 'Fature',
      dailyDiscount: 'Ditore',
      aggregate: 'Ditore',
      salesman: 'Shites',
      display: 'Ekran',
      chooseDisplay: 'Zgjedh ekranin/at',
      displayOnlyInTheseDevices: 'Shfaq ne kete ekran ([0]) porosi vetem nga',
      clientDiscount: 'Zbritje',
      lock: 'Blloko',
      stockThreshold: 'Limiti i stokut',
      service: 'Sherbim',
      withTimer: 'Me ore',
      cardNumberOrTelephone: 'Numri i karteles ose telefonit',
      priceType: 'Tipi i cmimit',
      priceCalculation: 'Kalkulimi i cmimit',
      applyToTables: 'Apliko te tavolinat',
      receiptForAllOrders: 'Fature per te gjitha porosite',
      parent: 'Prindi',
      child: 'Femija',
      twilioFriendlyName: 'Numri/Emri',
      smsSucces: 'SMS u dergua me sukses.',
      SalesOrder: 'Shitje',
      StockChange: 'Ndryshim i stokut',
      StockReset: 'Prerje e stokut',
      VendorPurchase: 'Blerje',
      showProduct: 'Shfaq produkt',
      showCategory: 'Shfaq kategori',
      showMaker: 'Shfaq prodhues',
      showAllTableTotals: 'Shfaq totalin e te gjitheve (tavolinat)',
      regularInvoiceForAllOrders: 'Fatura e rregullt per te gjitha porosite',
      totalQuantity: 'Sasia totale',
      roles: {
        Admin: 'Admin',
        Waiter: 'Kamarier',
        Kamarier: 'Kamarier',
        Menaxher: 'Menaxher',
        Depoist: 'Depoist',
        Staf: 'Staf',
        Salesman: 'Shites',
        Display: 'Display'
      },
      approveFreePayment: 'Aprovo pa pagese',
      purchasePriceWithoutVat: 'Cmimi i blerjes (pa TVSH)',
      vendorName: 'Furnitori',
      totalWithouVat0: 'Total me TVSH 0%',
      totalWithoutVat8: 'Total pa TVSH (8%)',
      vatAmount8: 'Vlera e TVSH (8%)',
      totalWithoutVat18: 'Total pa TVSH (18%)',
      vatAmount18: 'Vlera e TVSH (18%)',
      applyToProducts: 'Apliko te produktet',
      sellPrice: 'Cmimi i shitjes',
      margin: 'Margjina',
      deliveryType: 'Tipi i delivery',
      totalCurrentPrice: 'Totali i cmimit aktual',
      configLabels: {
        hideDeliveryTotals: 'Fsheh totalin ne delivery',
        printerNameTicket: 'Emri i printerit ne tikete',
        cardPaymentFee: 'Tarifa e pageses me kartele',
        fiscalExtraMessage: 'Fiskal/Jo fiskal: teskt shtese',
        reservationDuration: 'Kohezgjatja e rezervimit (ore)',
        mobileHideTotal: 'PostomGo: fsheh totalin',
        courseSpliters: 'Ndarja e kurseve',
        waiterSelfHandouts: 'Kamarieri te vete-barazohet',
        liveTickerNoActions: 'Live ticker: blloko veprimet',
        chooseFiscalThermalPrinter: 'Zgjedh printerin termik per kupon fiskal',
        employeeClocktimeProductSales: 'Shfaq produktet e shitura ne printim te barazimit',
        searchClientCards: 'Shfaq "Kerko" te kartela e klientit',
        chooseGeneralPrinter: 'Zgjedhe printerin gjeneral',
        duplicatePrinter: 'Repliko printerin',
        duplicateGeneralPrinter: 'Repliko printerin gjeneral',
        chooseFiscalPrinter: 'Zgjedhe printerin fiskal',
        chooseInvoicePrinter: 'Zgjedhe printerin per faturen e rregullt',
        duplicateInvoicePrinter: 'Repliko printerin per faturen e rregullt',
        chooseCashOnPrinter: 'Zgjedhe printerin e barazimit',
        chooseFinalInvoicePrinter: 'Zgjedhe printerin per faturen perfundimtare',
        duplicateFinalInvoicePrinter: 'Repliko printerin per faturen perfundimtare',
        finalInvoiceQuantity: 'Numri i kopjeve per faturen perfundimtare',
        notRestaurant: 'Nuk eshte restoran/bar',
        allowNegativeStock: 'Lejo stokun me minus',
        fiscalConfirm: 'Konfirmim per kupon fiskal',
        defaultDelivery: 'Porosia delivery by default',
        manualFreeTable: 'Liro tavolinen manualisht',
        kitchenPrinter: 'Kuzhine/Printer',
        cardPayment: 'Pagese me kartele',
        directOrder: 'Porosi direkte',
        showTotalOnNonfiscal: 'Shfaq totalin ne printer jo-fiskal',
        orderTotalNonFiscalOptional: '(Opsionale) Shfaq totalin ne printer jo-fiskal',
        showCommentsOnNonfiscal: 'Shfaq komentet ne faturen jo-fiskale',
        orderNrOnFiscal: 'Numri i porosise ne kupon fiskal',
        fixedShift: 'Fillimi i ndrrimit me shume fikse',
        adminCashShift: 'Admini me startu ndrrimin me pare',
        orderToKitchenAfterPayment: 'Printo porosine ne kuzhine vetem pas pageses',
        returnToTableAfterOrder: 'Kthe te tavolinat pas porosise',
        logoutAfterOrder: 'Logout pas porosise',
        returnToTableAfterPayment: 'Kthe te tavolinat pas pageses',
        logoutAfterPayment: 'Logout pas pageses',
        managerCashOut: 'Menaxheri mund te barazoj kamarierat',
        dontIncludeCustomersIdinSale: 'Mos kalkulo ne pazar kartelen e klientit',
        approvalDamages: 'Dëmtimet me aprovim',
        mobilePos: 'Mobile POS',
        closeAutomatically: 'Mbyll automatikishit',
        transfers: 'Transferet',
        approveProgramClose: 'Mbyll programin vetem me konfirmim',
        codeAndMakers: 'Kodi dhe prodhuesi te produkti',
        enableMinimize: 'Aktivizo minimizimin e programit<br/> <small>(e vlefshme për pajisjen aktuale)</small>',
        liveTicker: 'Live ticker',
        liveTickerAllOrders: 'Live ticker: shfaq vetem porosite e kamarierit',
        liveTickerSalesmanAllOrders: 'Live ticker: shfaq vetem porosite e shitesit',
        handoutsCalculateCard: 'Kalkulo shitjet me banke ne barazim',
        autoStart: 'Auto start (vlen vetem per kete paisje)',
        printQuantityFromLeft: 'Sasia ne anen e majt (print)',
        disableOrderComments: 'Deaktivizo komentet ne porosi',
        freePaymentConfirm: 'Pa pagese me konfirmim',
        displays: 'Ekranat',
        onlyFiscal: 'Vetem fiskal',
        isService: 'Eshte sherbim',
        serviceClient: 'Lojerat per femije',
        directOnlyFiscal: 'Direkt fiskal'
      },
      reportsLabels: {
        salesTypeReport: 'Raporti i tipit të shitjeve',
        businessDayClose: 'Sipas mbylljes se dites'
      },
      weekdays: {
        monday: 'Hënë',
        tuesday: 'Martë',
        wednesday: 'Mërkurë',
        thursday: 'Enjte',
        friday: 'Premte',
        saturday: 'Shtunë',
        sunday: 'Diel'
      }
    },
    mainMenu: {
      reports: {
        tableTransfers: 'Transferet',
        name: 'Raportet',
        sales: 'Shitjet',
        productSales: 'Shitje produkt',
        hourlySales: 'Shitje sipas ores',
        purchases: 'Blerjet',
        stockChanges: 'Ndryshimi i stokut',
        handovers: 'Barazimet',
        waiterRankings: 'Rangimi i kamarierave',
        delivery: 'Delivery',
        ingredients: 'Perberesit',
        damages: 'Demtimet',
        clients: 'Klientet',
        startEndSalesDay: 'Fillimi/Mbarimi',
        categorySales: 'Shitje sipas kategorise',
        staff: 'Staf',
        salesByMaker: 'Shitjet sipas prodhuesit',
        deliveryClients: 'Delivery klientat',
        productByCompoundItemsSales: 'Shitja sipas shtojcave',
        salesBook: 'Libri i shitjes',
        purchaseBook: 'Libri i blerjes',
        regularInvoices: 'Faturat e rregullta',
        productSalesInterval: 'Shitje produkt interval',
        paymentMethods: 'Menyrat e pageses',
        vatSales: 'Shitjet sipas TVSH',
        purchaseProducts: 'Blerjet e produkteve',
        duePayments: 'Borxhet',
        returnedProducts: 'Malli i kthyer',
        reservations: 'Rezervimet'
      },
      menu: 'Meny',
      categories: 'Kategorite',
      products: 'Produktet',
      priceList: 'Cmimoret',
      floorPlan: 'Plani i tavolinave',
      stock: {
        name: 'Stoku',
        changeStock: 'Ndrysho stokun',
        stockCutoff: 'Prerja e stokut',
        inventoryLocations: 'Pikat',
        stockThreshold: 'Limiti i stokut',
        transactions: 'Transaksionet e produktit',
        transactionsPeriod: 'Transaksionet e produktit periudha'
      },
      purchases: 'Blerjet',
      config: {
        name: 'Konfigurimi',
        printers: 'Printerat',
        measuringUnits: 'Njesite',
        vat: 'TVSH',
        users: 'Perdoruesit',
        vendors: 'Furnitoret',
        discounts: 'Zbritjet',
        clients: 'Klientet',
        accessPoints: 'Lokacionet',
        makers: 'Prodhuesit',
        audit: 'Auditi',
        license: 'Licensat',
        displays: 'Ekranat',
        invoiceClients: 'Subjektet',
        reservationClients: 'Klientet e rezervimeve'
      }
    },
    exportFiles: {
      raporti_transfereve_tavolinave: 'raporti_transfereve_tavolinave',
      raporti_shitjeve: 'raporti_shitjeve',
      raporti_klientave: 'raporti_klientave',
      raporti_barazimeve: 'raporti_barazimeve',
      raporti_perberesave: 'raporti_perberesave',
      raporti_demtimeve: 'raporti_demtimeve',
      raporti_delivery: 'raporti_delivery',
      raporti_kamarierave: 'raporti_kamarierave',
      raporti_shitjeve_produkt_sipas_ores: 'raporti_shitjeve_produkt_sipas_ores',
      raporti_shitjeve_produkt: 'raporti_shitjeve_produkt',
      raporti_blerjeve: 'raporti_blerjeve',
      raporti_shitjeve_kategorise: 'raporti_shitjeve_kategorise',
      raporti_shitjeve_prodhuesit: 'raporti_shitjeve_prodhuesit',
      raporti_staf: 'raporti_staf',
      raporti_fillimit_mbarimit: 'raporti_fillimit_mbarimit',
      raporti_ndryshimit_stokut: 'raporti_ndryshimit_stokut',
      raporti_stokut: 'raporti_stokut',
      prerja_stokut: 'prerja_stokut',
      product_transactions: 'transakstionet_produktit',
      raporti_faturave_rregullta: 'raporti_faturave_rregullta',
      raporti_shitje_produkt_interval: 'raporti_shitje_produkt_interval',
      lista_produkteve: 'lista_produkteve',
      raporti_shitjeve_produkt_interval_ores: 'raporti_shitjeve_produkt_interval_ores',
      raporti_shitjeve_menyres_pageses: 'raporti_shitjeve_menyres_pageses',
      raporti_shitjeve_tvsh: 'raporti_shitjeve_tvsh',
      raporti_blerjeve_produktet: 'raporti_blerjeve_produktet',
      raporti_borxhit: 'raporti_borxhit',
      raporti_kthimit_mallit: 'raporti_kthimit_mallit',
      raporti_rezervimeve: 'raporti_rezervimeve',
      auditimi: 'auditimi'
    },
    licenseMessages: {
      LICENSESUCCESS: 'Licensa u aktivizua me sukses.',
      INVALIDSIGNATURE: 'Licensa eshte ndryshuar, nuk eshte valide!',
      INVALIDLICENCETOTHISDEVICE: 'Licensa nuk eshte valide per kete paisje!',
      INVALIDLICENCE: 'Licensa ka skaduar!',
      LICENCECONVERTERROR: 'Teskti i licenses eshte nrsyhuar, licensa nuk eshte valide!',
      NOLICENSEFOUND: 'Kjo paisje nuk eshte e licencuar! Ju lutem kontakto STOM LLC +383 46 333 444!',
      licenseWarning: 'Licensa e programit skadon edhe |daysLicenseExpire| dite, me daten |expireDate|. ' +
        'Ju lutem qe te ri- aktivizoni licensen me kohe, per te vazhduar perdorimin e programit pas dates se skadimit te licenses. ' +
        'Per ri- aktivizim, kontaktoni STOM shpk ne +383 49 313 526'
    }
  },
  sq_al: {
    message: {
      resetDisplayItemConfirm: 'A jeni i sigurt se deshironi te ndryshoni statusin e porosise?',
      closeAllOrdersDisplayConfirm: 'A jeni i sigurt se deshironi të mbyllni të gjitha porositë? Veprimi nuk mund te anulohet.',
      pendingOrders: 'Porosite ne pritje',
      noSearchResult: 'Kerkimi nuk ka rezultat.',
      restartMessage: 'POSTOM ristartohet pas...',
      login: 'Login',
      logout: 'Logout',
      details: 'Detajet',
      transferOrders: 'Transfero porositë',
      changeWaiter: 'Ndërro kamarierin',
      orderClosed: 'Porosia e mbyllur',
      startOfShift: 'Fillimi i ndërrimit',
      endOfShift: 'Mbarimi i ndërrimit',
      successfulStartOfShift: 'Fillimi i ndërrimit i sukseshëm.',
      successfulEndOfShift: 'Mbarimi i ndërrimit i sukseshëm.',
      scanQrCode: 'Skano QR kodin',
      confirmOrderTransfer: 'Ju lutem konfirmoni transferimin e porosive',
      currentWaiter: 'Kamarieri aktual',
      newWaiter: 'Kamarieri i ri',
      changeWaiterMsg: 'Kërkesa juaj për të ndryshuar kamarierin është dërguar. Nëse kamarieri tjetër e pranon kërkesën, transferimi do të realizohet.',
      orderCloseConfirmation: 'A jeni i sigurt se deshironi te kompletoni kete porosi?',
      serachSubjectOrFiscal: 'Kerko me subjekt/numër fiskal',
      validInvoiceWithoutStamp: 'Kjo faturë është e vlefshme pa vulë.',
      removeOrderMessage: 'Porosia nuk mund te anulohet sepse ka produkte.',
      freeTableMessage: 'Tavolina nuk mund të lirohet, ka porosi aktive.',
      closeOrderMessage: 'Porosia është e mbyllur. Nuk mund të shtoni artikuj në porosi.',
      closeOrderConfirmMessage: 'A jeni i sigurt se deshironi ta mbyllni porosine dhe te leshoni kuponin fiskal?',
      closeOrderConfirmMessageReservation: 'A eshte porosia e lidhur me kete rezervim?',
      printFiscalConfirm: 'A jeni i sigurt se deshironi te leshoni kuponin fiskal?',
      noProductMessage: 'Porosia është e zbrazët. Nuk mund të shtypni kupon fiskal.',
      noProductRetailMessage: 'Porosia është e zbrazët. Nuk mund të përfundoni shitjen.',
      chooseTotalDiscount: 'Zgjidhni zbritjen totale',
      chooseProdDiscount: 'Zgjidhni zbritjen per produkt',
      scanClientCard: 'Skeno kartelën e klientit',
      clientNotExist: 'Kartela nuk ekziston në bazën e të dhënave. Vendosni të dhënat e klientit për të krijuar',
      scanCardToApproveDamage: 'Skeno kartelen ose sheno PIN-in per te aprovuar demtimin',
      deliveryConfirmMessage: 'Jeni i sigurt se deshironi te kompletoni porosine delivery?',
      splitOrderMessage: 'Nuk mund të ndani të gjithë porosinë. Zgjidhni vetëm disa.',
      clientLeft: 'Klienti ka ikur.',
      houseCompliments: 'Nga shtepia',
      waitersMistake: 'Gabim nga kamarieri',
      finalizeGoodsReturn: 'A jeni i sigurt se dëshironi të finalizoni kthimin e mallit?',
      goodsReturnDifference: 'Diferenca e kthimit të mallit',
      noApproveAccess: 'Nuk keni të drejtë të bëni aprovimin!',
      noBarcode: 'nuk ka barkod',
      noCode: 'nuk ka kod',
      notInStock: 'nuk ka në Inventar!',
      stockValue: 'Ne Inventar gjenden vetem',
      noAdminPrivileges: 'Nuk keni privilegjet e administratorit!',
      finalizeCashOut: 'Jeni i sigurt se deshironi te finalizoni Mbylljen e Turnit?',
      waiterCashedOut: 'Kamarieri Mbylli Turnin.',
      approveExit: 'Aprovo mbylljen/minimizimin e programit',
      scanCardToExit: 'Skeno kartelen ose sheno PIN-in per te aprovuar veprimin',
      sendReport: 'Dërgo raportin',
      emailSent: 'Email është dërguar me sukses!',
      emailFailed: 'Email nuk është dërguar. Ju lutemi provoni përsëri.',
      invalidEmail: 'Email nuk eshte valid!',
      sending: 'Duke u derguar',
      device_mismatch: 'Porosia e njejtë është e hapur në një paisje tjetër.Ndryshimet e porosisë lejohen vetëm në atë paisje.',
      confirm_admin_changes: 'Cdo ndryshim i bere do te mbishkruaj ndryshimet qe i ka bere kamarieri nderkohe. Deshironi te vazhdoni?',
      DOCUMENTISCLOSED_CANNOTFINALIZE: 'Dokumenti nuk mund te finalizohet sepse eshte finalizuar me heret!',
      DOCUMENTISCLOSED_CANNOTSAVE: 'Produkti nuk mund te ruhet sepse dokumenti eshte finalizuar me heret!',
      scanCardToApproveFreePayment: 'Skeno kartelen ose sheno PIN-in per te aprovuar pa pagesen',
      productsUpdatedWithVat: 'TVSH u aplikua te te gjitha produktet',
      tablesUpdatedWithProduct: 'Produkti u aplikua te te gjitha tavolinat',
      chooseTemplate: 'Zgjidhni mesazhin!',
      cannotDeleteItem: 'Produkti nuk mund te fshihet nga porosia!',
      serviceClientFormError: 'Telefoni, emri i femiut dhe emri i prindit nuk mund te jene te zbrazet!',
      contiueWithService: 'Vazhdo me sherbimin?',
      CANNOTCHANGEDOCUMENTLESSLASTSTOCKRESET: 'Nuk mund te fshihet asnje ndryshim i Inventarit qe eshte realizuar para gjendjes se fundit te Inventarit!',
      salesAmountChanged: 'Shuma e shitjes ka ndryshuar nderkohe.',
      menus: {
        productExists: 'Produkti ekziston në menu.',
        pleaseAddProduct: 'Ju lutem shtoni produkte në menu.',
        cantBeEmpty: 'Menu e zbrazët nuk mund të ruhet.',
        confirmProdRemove: 'Jeni i sigurt se dëshironi te largoni produktin?',
        confirmRemove: 'Jeni i sigurt se dëshironi të fshini menun?'
      },
      categories: {
        confirmDiscountChanges: 'Zbritjet e produkteve te kesaj kategorie do te mbishkruhen. Deshironi te vazhdoni?',
        confirmRemove: 'Jeni i sigurt se dëshironi të fshini kategorinë?'
      },
      products: {
        confirmRemove: 'Jeni i sigurt se dëshironi të fshini produktin?',
        confirmIngredientsRemove: 'A deshironi te fshini perberesin e produktit?',
        addProductIngredients: 'Ju lutem shtoni perberesit e produktit, lista nuk mund te jete e zbrazet.',
        enabledHappyHour: 'Shfaq vetem me Happy Hour',
        cannotRemoveLastProduct: 'Perberesi i fundit nuk mund te fshihet pa e shtuar nje perberes tjeter!',
        productDeleteFailed: 'Produkti nuk mund te fshihet sepse perdoret si perberes ne produktet me poshte:'
      },
      tablePlan: {
        confirmRemove: 'Jeni i sigurt se deshironi te fshini planin?',
        successUpdate: 'Plani eshte perditesuar me sukses!'
      },
      stock: {
        confirmRemove: 'Jeni i sigurt se dëshironi te fshini ndryshimin e Inventarit?',
        confirmProdRemove: 'Jeni i sigurt se dëshironi te largoni produktin?',
        finalizePurchase: 'Dëshironi të finalizoni blerjen?',
        confirmStockReset: 'Dëshironi te finalizoni gjendjen e Inventarit? Te dhenat nuk mund te ndryshohen pas kesaj!'
      },
      points: {
        confirmRemove: 'Jeni i sigurt se dëshironi te fshini pikën?'
      },
      purchases: {
        confirmRemove: 'Jeni i sigurt se dëshironi te fshini blerjen?',
        finalizePurchase: 'Dëshironi të finalizoni blerjen?'
      },
      printers: {
        confirmRemove: 'Jeni i sigurt se dëshironi te fshini printerin?',
        printingError: 'Porosia nuk është shtypur! Ju lutem sigurohuni që printeri është i lëshuar dhe është i lidhur me PC.Nëse prap nuk funksionon, ju lutem kontaktoni personin përgjegjës për printer dhe teknikë.'
      },
      units: {
        confirmRemove: 'Jeni i sigurt se dëshironi te fshini njësine?'
      },
      vats: {
        confirmRemove: 'Jeni i sigurt se deshironi te fshini normen tatimore?',
        vatRateExist: 'Kjo normë e TVSH ekziston'
      },
      users: {
        cannotChangeAdminRole: 'Nuk mund te ndryshoni rolin e administratorit!',
        notAdminUser: 'Nuk keni privilegje te administratorit per te fshire kete perdorues!',
        confirmRemove: 'Jeni i sigurt se deshironi te fshini perdoruesin?',
        nameNotNull: 'Emri nuk mund te jete i zbrazet!',
        pinNotNull: 'PIN nuk mund te jete i zbrazet!',
        roleNotNull: 'Roli nuk mund te jete i zbrazet!',
        personalNumberNotNull: 'Numri personal nuk mund te jete i zbrazet!',
        emailNotNull: 'Email nuk mund te jete i zbrazet!',
        setStaffLimit: 'Shenoni limitin e ushqimit per perdoruesin!'
      },
      vendors: {
        confirmRemove: 'Jeni i sigurt se deshironi te fshini furnitorin?'
      },
      config: {
        changeApplied: 'Ndryshimi është aplikuar. Kyçuni përsëri për të parë ndryshimin. Faleminderit',
        bankInfoMandatory: 'Banka dhe llogaria bankare duhet te jene te plotesuara!',
        chooseOperatingCountry: 'Duhet te zgjidhni shtetin ku operoni!'
      },
      vouchers: {
        confirmRemove: 'Jeni i sigurt se deshironi te fshini zbritjen?'
      },
      clients: {
        confirmRemove: 'Jeni i sigurt se deshironi te fshini klientin?'
      },
      validations: {
        cannotBeEmpty: 'Nuk mund të jetë e zbrazët!',
        notNullLettersAndNumbers: 'Nuk mund te jete e zbrazet dhe duhet te permbaje vetem numra dhe shkronja.',
        validNameAndFiscalNumber: 'Emri dhe Numri fiskal nuk mund te jene te zbrazet!',
        validProductNameAndTotal: 'Emri i Produktit dhe Totali nuk mund te jene te zbrazeta!',
        cannotBeNegativeValue: 'Nuk mund te jete vlere negative.',
        nameCannotBeEmpty: 'Emri nuk mund të jetë i zbrazët!',
        doserCannotBeNegativeValue: 'Dozeri duhet te jete me i madh se zero ose i zbrazet!'
      },
      expenses: {
        confirmCloseAndRemove: 'A jeni i sigurt qe deshironi ta mbyllni kete faqe? Te gjitha shpenzimet qe nuk jane ruajtur do te fshihen!'
      }
    },
    buttons: {
      splitCourse: 'Ndaj kursin',
      fiscalCopy: 'Fiskal kopje',
      continueWithoutCoupon: 'Vazhdo pa kupon',
      continueWithCoupon: 'Vazhdo me kupon',
      groupedOrders: 'Porosite e grupuara',
      changePayment: 'Ndrysho pagesen',
      save: 'Ruaj',
      saveDraft: 'Ruaj draft',
      cancel: 'Anulo',
      continue: 'Vazhdo',
      close: 'Mbyll',
      print: 'Printo',
      split: 'Ndaj',
      goBack: 'Kthehu',
      finalize: 'Finalizo',
      fiscal: 'Fiskal',
      notFiscal: 'Jo fiskal',
      finish: 'Përfundo',
      finishOptionalPrintTotal: 'Perfundo me kupon',
      qrCode: 'QR kodi',
      invoice: 'Faturë',
      filterDates: 'Filtro datat',
      generateReport: 'Gjenero raportin',
      add: 'Shto',
      addExpenses: 'Shto shpenzim',
      cashOut: 'Mbyll Turnin',
      send: 'Dërgo',
      email: 'Email',
      refresh: 'Fresko',
      tryAgain: 'Provoni përsëri',
      refuse: 'Refuzo',
      changeClient: 'Ndrro klientin',
      menus: {
        addMenu: 'Shto menu',
        deleteMenu: 'Fshij menu',
        deletePriceList: 'Fshij listen e cmimeve',
        addAllProducts: 'Shto te gjitha produktet',
        addPriceList: 'Shto listen e Cmimeve'
      },
      categories: {
        addCategory: 'Shto kategori'
      },
      products: {
        addProduct: 'Shto produkt',
        export: 'Eksporto'
      },
      tablePlan: {
        addPlan: 'Shto plan',
        addTable: 'Shto tavolinë',
        deleteTable: 'Fshij tavolinë',
        addMultipleTables: 'Shto disa'
      },
      stock: {
        addProduct: 'Shto produkt'
      },
      points: {
        addPoint: 'Shto pikë',
        pointName: 'Emri i pikës'
      },
      printers: {
        addPrinter: 'Shto printer',
        printerName: 'Emri i printerit',
        printerPort: 'Porti i printerit',
        printerType: 'Tipi i printerit',
        fiscalPrinterType: 'Tipi i printerit fiskal',
        letterDimensions: 'Dimenzioni i letrës',
        dynamicPath: 'Pathi dinamik'
      },
      units: {
        addUnit: 'Shto njësi'
      },
      vats: {
        addVat: 'Shto TVSH',
        vatRate: 'Norma e TVSH'
      },
      users: {
        addUser: 'Shto përdorues'
      },
      vendors: {
        addVendor: 'Shto furnitorë',
        vendorName: 'Emri i furnitorit',
        chooseVendor: 'Zgjidh furnitorin'
      },
      locations: {
        addLocation: 'Shto vendndodhje'
      },
      clients: {
        addClient: 'Shto klient'
      },
      happyHours: {
        addHappyHour: 'Shto Happy Hour'
      },
      makers: {
        addMaker: 'Shto prodhues',
        makerName: 'Emri i prodhuesit',
        chooseMaker: 'Zgjidh prodhuesin'
      },
      displays: {
        addDisplay: 'Shto ekran',
        displayName: 'Emri'
      }
    },
    labels: {
      receivedBy: 'Pranuar nga',
      outgoingDocument: 'Dokument dales',
      displayControllerPermission: 'Kontrollues ekrani',
      advancedConfiguration: 'Konfigurimi i avancuar',
      productConfigurationType: 'Tipi i konfigurimit',
      reason: 'Arsye',
      required: 'Kjo fushë është e kërkuar',
      freePaymentWithFiscal: 'Pa pagese me fiskal',
      changePaymentMethodAllOrders: 'Ndrysho pagesen per te gjitha porosite',
      liveTickerAllOrders: 'Live ticker: të gjitha porositë',
      currencyExchange: 'Kembimi valutor',
      excludedVat: 'Perjashtuar TVSH',
      excludedVatCode: 'Kodi i perjashtimit nga TVSH',
      finished: 'Përfunduar',
      showAll: 'Shfaq të gjitha',
      expense: 'Shpenzim',
      freeTables: ' TE LIRA',
      reservationsArriving: 'Brenda 30 min',
      reservationClientPriority: 'Klient me prioritet',
      additionalInfo: 'Informata shtese',
      tablesWithoutReservations: 'Tavolina te lira',
      changeReservationStatus: 'Ndrysho statusin e rezervimit',
      reservationStatusUpdateFailed: 'Ndryshimi i statusit te rezervimit deshtoi!',
      reservationDeleteConfirmation: 'Deshironi te fshini rezervimin?',
      showed: 'Ka ardhur',
      notShowed: 'Nuk ka ardhur',
      clientAdditionalInfo: 'Informacione shtesë për klientin',
      newReservation: 'Rezervim i ri',
      numberPersons: 'Numri i personave',
      reservations: 'Rezervimet',
      totalWithoutDiscount: 'Totali para zbritjes',
      serviceFee: 'Tarife sherbimi',
      serviceFeeType: 'Tarife sherbimi %',
      serviceFeeAutomatic: 'Tarife sherbimi automatike',
      courseSpliter: 'Ndaj kursin',
      employeeTip: 'Bakshishi',
      deleteOrderPermission: 'Lejo fshirjen e porosive',
      orderDeleteConfirmation: 'Jeni te sigurt qe deshironi te fshini porosine?',
      delete: 'Fshij',
      avgPrice: 'Cmimi mesatar',
      sellPriceWithVAt: 'Cmimi i shitjes (me TVSH)',
      totalSellPriceWithVAt: 'Totali i cmimit te shitjes',
      clearCreateNew: 'Pastro / Krijo klient te ri',
      duePayment: 'Borxh',
      loanPermission: 'Aktivizo borxhet',
      minDate: 'Data e fillimit',
      maxDate: 'Data e mbarimit',
      numberOfOrders: 'Numri i porosive',
      selectedToPay: 'Per te paguar',
      paidProducts: 'Pagesat e pjesshme',
      ordersCount: 'Nr. i porosive',
      onlinePaymentProcessing: 'Duke procesuar ...',
      onlinePaymentCanceled: 'Anuluar/Deshtuar!',
      onlinePaymentSuccess: 'Sukses.',
      changePaymentMethod: 'Ndrysho pagesen',
      refreshIn: 'Refresh per',
      identifierCode: 'Kodi identifikues',
      writeDescription: 'Sheno pershkrimin',
      apiCode: 'API kodi',
      doNotPrint: 'Mos printo',
      calculatePrice: 'Kalkulo cmimin',
      actualPrice: 'Cmimi aktual',
      newPrice: 'Cmimi i ri',
      displayInInterval: 'Shfaq ne interval',
      ingredient: 'Shtojce',
      day: 'Dita',
      month: 'Muji',
      year: 'Viti',
      birthDate: 'Data e lindjes',
      pin: 'PIN',
      active: 'Aktiv',
      inactive: 'Joaktiv',
      activate: 'Aktivizo',
      activateDeductions: 'Aktivizoni zbritjet',
      order: 'Porosit',
      orders: 'Porositë',
      theOrder: 'Porosia',
      orderAndContinue: 'Porosit + Vazhdo',
      information: 'Informatë',
      printReceipt: 'Shtyp me fiskal',
      printWReceipt: 'Shtyp pa fiskal',
      clearOrder: 'Pastro porosinë',
      clearTable: 'Liro tavolinën',
      cancelOrder: 'Anulo porosinë',
      splitOrder: 'Ndaj porosinë',
      product: 'Produkti',
      products: 'Produktet',
      productType: 'Tipi i produktit',
      quantity: 'Sasia',
      total: 'Totali',
      totalAmount: 'Shuma totale',
      discount: 'Zbritje | Zbr.',
      discounts: 'Zbritjet',
      price: 'Çmimi',
      phone: 'Telefoni',
      delivery: 'Delivery',
      takeAway: 'Me vete',
      inHouse: 'Ketu',
      table: 'Tavolina',
      tables: 'Tavolinat',
      amount: 'Shuma',
      waiter: 'Kamarieri',
      plan: 'Plani',
      free: 'E lire',
      open: 'Hapur',
      closed: 'Mbyllur',
      busy: 'E zene',
      status: 'Statusi',
      confirmation: 'Konfirmim',
      currentQuantity: 'Sasia aktuale',
      previousQuantity: 'Sasia e parafundit',
      difference: 'Diferenca',
      lastChange: 'Ndryshimi i fundit',
      date: 'Data',
      payment: 'Pagesa',
      collect: 'Arketo',
      collected: 'Arketuar',
      collection: 'Arketimi',
      uncollected: 'Pa-Arketuar',
      actions: 'Veprime',
      client: 'Klienti',
      deliveryClient: 'Delivery klienti',
      chooseEmployee: 'Zgjidhni punëtorin',
      business: 'Biznes',
      ngo: 'OJQ',
      search: 'Kërko',
      fiscalNumber: 'NUI',
      vatNumber: 'Numri i TVSH',
      businessNumber: 'Numbri i biznesit',
      registrationNumber: 'Numri i regjistrimit',
      name: 'Emri',
      address: 'Adresa',
      businessAddress: 'Adresa e biznesit',
      city: 'Qyteti',
      contactPerson: 'Kontakt personi',
      comment: 'Koment',
      email: 'Email',
      website: 'Website',
      contact: 'Kontakti',
      bank: 'Banka',
      bankAccount: 'Llogaria bankare',
      cash: 'kesh',
      code: 'Kodi',
      barcode: 'Barkodi',
      card: 'Kartelë',
      idCard: 'ID kartelë',
      seller: 'Shitës',
      buyer: 'Blerës',
      value: 'Vlera',
      valueWithVat: 'Vlera me TVSH',
      valueWithoutVat: 'Vlera pa TVSH',
      priceWithVat: 'Çmimi me TVSH',
      priceWithoutVat: 'Çmimi pa TVSH',
      vat: 'TVSH',
      chooseVat: 'Zgjidh TVSH',
      forPayment: 'Për pagesë',
      submitted: 'Dorëzoi',
      accept: 'Pranoj',
      from: 'Prej',
      to: 'Tek',
      until: 'Deri',
      fromTable: 'Prej tavolinës',
      toTable: 'Tek tavolina',
      staff: 'Staf',
      staffOrder: 'Porosit për staf',
      staffPrice: 'Çmimi për staf',
      damagedGoods: 'Dëmtim i mallit',
      damagedProduct: 'Produkt i dëmtuar',
      reportDamage: 'Raporto dëmtim',
      forFood: 'Per ushqim',
      chooseBank: 'Zgjidh bankë',
      chooseBanks: 'Zgjidh bankat',
      approveDamage: 'Aprovoni dëmtimin',
      chooseDate: 'Zgjidh datën',
      moneyChange: 'Kthimi',
      freeOfCharge: 'Pa pagesë',
      goodsReturn: 'Kthimi i mallit',
      return: 'Kthe',
      categories: 'Kategoritë',
      category: 'Kategoria',
      categoryType: 'Tipi i kategorisë',
      ranking: 'Renditja',
      autoRanking: 'Renditja automatike',
      rankingPrinter: 'Renditja printer',
      choose: 'Zgjidh',
      description: 'Përshkrimi',
      employee: 'Punëtori',
      user: 'Përdoruesi',
      vendor: 'Furnitori',
      time: 'Koha',
      paymentType: 'Tipi i pagesës',
      orderType: 'Tipi i porosisë',
      invoiceNumber: 'Nr. i faturës',
      document: 'Dokumenti',
      transfer: 'Transferimi',
      start: 'Fillimi',
      end: 'Mbarimi',
      damages: 'Dëmtimet',
      expenses: 'Shpenzimet',
      totalSales: 'Shitje totale',
      mostSoldProd: 'Produkti më i shitur',
      mostSoldProdQuantity: 'Sasia produktit më të shitur',
      approvedBy: 'Aprovuar nga',
      clientName: 'Emri i klientit',
      clientCode: 'Kodi i klientit',
      clientCard: 'Kartela e klientit',
      cardNumber: 'Numri i kartelës',
      ordersNumber: 'Nr. i porosive',
      withDetails: 'Me detaje',
      clients: 'Klientët',
      type: 'Tipi',
      menuIcon: 'Ikona e menusë',
      addProduct: 'Shto produkt',
      addCategory: 'Shto kategori',
      authorizedPerson: 'Personi i Autorizuar',
      beginning: 'Starti',
      dailySales: 'Xhiro ditore',
      handedOver: 'Dorëzuar',
      kitchen: 'Kuzhinë',
      choosePrinter: 'Zgjidh printerin/at',
      printer: 'Printer',
      bar: 'Shank',
      yes: 'Po',
      no: 'Jo',
      color: 'Ngjyra',
      receipt: 'kupon jo fiskal',
      menu: 'Menu',
      picture: 'Foto',
      chooseCategory: 'Zgjidh kategorinë',
      internalCode: 'Kodi',
      unit: 'Njësia',
      units: 'Njësitë',
      stockChange: 'Ndiko stokun',
      dynamicAmount: 'Pesha dinamike',
      simple: 'Thjeshtë',
      compound: 'Përbërë',
      combo: 'Kombo',
      comboQuantity: 'Kombo sasi',
      productsIngredients: 'Përbërësit e produktit',
      preSelected: 'Para-zgjedhur',
      preSelectedQuantity: 'Para-zgjedhur sasia',
      dynamic: 'Dinamike',
      recipe: 'Receta',
      default: 'Parazgjedhur',
      happyHour: 'Happy Hour',
      letter: 'Shkronja',
      number: 'Numri',
      lastMove: 'Lëvizja e fundit',
      addedRemovedQty: 'Sasia e shtuar/zvogëluar',
      draft: 'Draft',
      finalized: 'Finalizuar',
      view: 'Shiko',
      stock: 'Inventari',
      point: 'Pika',
      productAt: 'Produkti në ',
      choosePoint: 'Zgjedh pikën',
      ip: 'IP',
      rate: 'Norma',
      country: 'Shteti',
      currency: 'Valuta',
      uploadLogo: 'Ngarko logo (max. 2MB)',
      general: 'Gjenerale',
      port: 'Porti',
      other: 'Tjetër',
      level: 'Niveli',
      createdDate: 'Data e krijimit',
      role: 'Roli',
      personalNumber: 'Numri personal',
      dailyFoodLimit: 'Limiti per ushqim (ditore)',
      calculateDiscount: 'Kalkulo zbritjen',
      productsPrice: 'Çmimi i produktit',
      priceWithDiscount: 'Çmimi me zbritje',
      paid: 'Paguar',
      remaining: 'Mbetur',
      sum: 'Shuma',
      sale: 'Shitje',
      typesOfSales: 'Tipet e shitjeve',
      qtyAndValue: 'Sasia dhe vlera',
      days: 'Ditët',
      choosePaymentType: 'Zgjedh tipin e pagesës',
      lastCount: 'Prerja e fundit',
      purchaseDate: 'Data e blerjes',
      invoiceDate: 'Data e faturës',
      stateReason: 'Shëno arsye',
      today: 'Sot',
      yesterday: 'Dje',
      lastSevenDays: '7 ditët e fundit',
      lastThirtyDays: '30 ditët e fundit',
      emails: 'Email-at',
      notification: 'Njoftim',
      programQuantity: 'Sasia program',
      physicalQuantity: 'Sasia fizike',
      differencePurchasePrice: 'Diferenca cmimi blerjes',
      differenceSellPrice: 'Diferenca cmimi shitjes',
      percentage: 'Përqindja',
      filters: 'Filtrat',
      choosePeriod: 'Filtro Periudhë',
      language: 'Gjuha',
      startEnd: 'Fillimi/Mbarimi',
      pcs: 'Copë',
      createdBy: 'Krijuar nga',
      maker: 'Prodhuesi',
      addMaker: 'Shto sipas prodhuesit',
      makers: 'Prodhuesit',
      searchClient: 'Kerko klientin',
      raportiDitor: 'Raporti ditor',
      advance: 'Avansi',
      doser: 'Dozeri',
      canCashOut: 'Mbyll Turnin',
      waiterAccess: 'Aksesi i kamarierit',
      userAccess: 'Aksesi i perdoruesit (jo Admin)',
      system: 'Sistemi',
      configOrder: 'Porosia',
      othersQuantity: 'Sasia tjeter',
      totalOrders: 'Nr. porosive',
      displayOnlyResetProducts: 'Shfaq vetem te numeruara',
      orderNumber: 'Porosia',
      employeeDeleted: 'Fshire nga',
      deletedDate: 'Data e fshirjes',
      show: 'Shfaq',
      inhouse: 'Ketu',
      takeaway: 'Me vete',
      fiscal: 'Fiskal',
      noFiscal: 'Jo fiskal',
      noPayment: 'Pa pagese',
      invoice: 'Fature',
      dailyDiscount: 'Ditore',
      aggregate: 'Ditore',
      salesman: 'Shites',
      display: 'Ekran',
      chooseDisplay: 'Zgjedh ekranin/at',
      displayOnlyInTheseDevices: 'Shfaq ne kete ekran ([0]) porosi vetem nga',
      clientDiscount: 'Zbritje',
      lock: 'Blloko',
      stockThreshold: 'Limiti i Inventarit',
      service: 'Sherbim',
      withTimer: 'Me ore',
      cardNumberOrTelephone: 'Numri i karteles ose telefonit',
      priceType: 'Tipi i cmimit',
      priceCalculation: 'Kalkulimi i cmimit',
      applyToTables: 'Apliko te tavolinat',
      receiptForAllOrders: 'Fature per te gjitha porosite',
      parent: 'Prindi',
      child: 'Femija',
      twilioFriendlyName: 'Numri/Emri',
      smsSucces: 'SMS u dergua me sukses.',
      SalesOrder: 'Shitje',
      StockChange: 'Ndryshim i Inventarit',
      StockReset: 'Gjendja e Inventarit',
      VendorPurchase: 'Blerje',
      showProduct: 'Shfaq produkt',
      showCategory: 'Shfaq kategori',
      showMaker: 'Shfaq prodhues',
      showAllTableTotals: 'Shfaq totalin e te gjitheve (tavolinat)',
      regularInvoiceForAllOrders: 'Fatura e rregullt per te gjitha porosite',
      totalQuantity: 'Sasia totale',
      roles: {
        Admin: 'Admin',
        Waiter: 'Kamarier',
        Kamarier: 'Kamarier',
        Menaxher: 'Menaxher',
        Depoist: 'Depoist',
        Staf: 'Staf',
        Salesman: 'Shites',
        Display: 'Display'
      },
      approveFreePayment: 'Aprovo pa pagese',
      purchasePriceWithoutVat: 'Cmimi i blerjes (pa TVSH)',
      vendorName: 'Furnitori',
      totalWithouVat0: 'Total me TVSH 0%',
      totalWithoutVat8: 'Total pa TVSH (8%)',
      vatAmount8: 'Vlera e TVSH (8%)',
      totalWithoutVat18: 'Total pa TVSH (18%)',
      vatAmount18: 'Vlera e TVSH (18%)',
      applyToProducts: 'Apliko te produktet',
      sellPrice: 'Cmimi i shitjes',
      margin: 'Margjina',
      deliveryType: 'Tipi i delivery',
      totalCurrentPrice: 'Totali i cmimit aktual',
      configLabels: {
        hideDeliveryTotals: 'Fsheh totalin ne delivery',
        printerNameTicket: 'Emri i printerit ne tikete',
        cardPaymentFee: 'Tarifa e pageses me kartele',
        fiscalExtraMessage: 'Fiskal/Jo fiskal: tekst shtese',
        reservationDuration: 'Kohezgjatja e rezervimit (ore)',
        mobileHideTotal: 'PostomGo: fsheh totalin',
        courseSpliters: 'Ndarja e kurseve',
        waiterSelfHandouts: 'Kamarieri te mbylle turnin',
        liveTickerNoActions: 'Live ticker: blloko veprimet',
        chooseFiscalThermalPrinter: 'Zgjedh printerin termik per kupon fiskal',
        employeeClocktimeProductSales: 'Shfaq produktet e shitura ne printim te Mbylljes se Turnit',
        searchClientCards: 'Shfaq "Kerko" te kartela e klientit',
        chooseGeneralPrinter: 'Zgjedh printerin gjeneral',
        duplicatePrinter: 'Repliko printerin',
        duplicateGeneralPrinter: 'Repliko printerin gjeneral',
        chooseFiscalPrinter: 'Zgjedh printerin fiskal',
        chooseInvoicePrinter: 'Zgjedh printerin per faturen e rregullt',
        duplicateInvoicePrinter: 'Repliko printerin per faturen e rregullt',
        chooseCashOnPrinter: 'Zgjedh printerin e Mbylljes se Turnit',
        chooseFinalInvoicePrinter: 'Zgjedh printerin per faturen perfundimtare',
        duplicateFinalInvoicePrinter: 'Repliko printerin per faturen perfundimtare',
        finalInvoiceQuantity: 'Numri i kopjeve per faturen perfundimtare',
        notRestaurant: 'Nuk eshte restoran/bar',
        allowNegativeStock: 'Lejo inventar me minus',
        fiscalConfirm: 'Konfirmim per kupon fiskal',
        defaultDelivery: 'Porosia delivery by default',
        manualFreeTable: 'Liro tavolinen manualisht',
        kitchenPrinter: 'Kuzhine/Printer',
        cardPayment: 'Pagese me kartele',
        directOrder: 'Porosi direkte',
        showTotalOnNonfiscal: 'Shfaq totalin ne printer jo-fiskal',
        orderTotalNonFiscalOptional: '(Opsionale) Shfaq totalin ne printer jo-fiskal',
        showCommentsOnNonfiscal: 'Shfaq komentet ne faturen jo-fiskale',
        orderNrOnFiscal: 'Numri i porosise ne kupon fiskal',
        fixedShift: 'Fillimi i ndrrimit me shume fikse',
        adminCashShift: 'Admini me startu ndrrimin me pare',
        orderToKitchenAfterPayment: 'Printo porosine ne kuzhine vetem pas pageses',
        returnToTableAfterOrder: 'Kthe te tavolinat pas porosise',
        logoutAfterOrder: 'Logout pas porosise',
        returnToTableAfterPayment: 'Kthe te tavolinat pas pageses',
        logoutAfterPayment: 'Logout pas pageses',
        managerCashOut: 'Menaxheri mund te Mbylli Turnin per kamarierin',
        dontIncludeCustomersIdinSale: 'Mos kalkulo ne Xhiro kartelen e klientit',
        approvalDamages: 'Dëmtimet me aprovim',
        mobilePos: 'Mobile POS',
        closeAutomatically: 'Mbyll automatikishit',
        transfers: 'Transferimet',
        approveProgramClose: 'Mbyll programin vetem me konfirmim',
        codeAndMakers: 'Kodi dhe prodhuesi te produkti',
        enableMinimize: 'Aktivizo minimizimin e programit<br/> <small>(e vlefshme për pajisjen aktuale)</small>',
        liveTicker: 'Live ticker',
        liveTickerAllOrders: 'Live ticker: shfaq vetem porosite e kamarierit',
        liveTickerSalesmanAllOrders: 'Live ticker: shfaq vetem porosite e shitesit',
        handoutsCalculateCard: 'Kalkulo shitjet me banke ne Mbylljen e Turnit',
        autoStart: 'Auto start (vlen vetem per kete paisje)',
        printQuantityFromLeft: 'Sasia në anën e majtë (print)',
        disableOrderComments: 'Çaktivizo komentet ne porosi',
        freePaymentConfirm: 'Pa pagese me konfirmim',
        displays: 'Ekranet',
        onlyFiscal: 'Vetem fiskal',
        isService: 'Eshte sherbim',
        serviceClient: 'Lojerat per femije',
        directOnlyFiscal: 'Direkt fiskal'
      },
      reportsLabels: {
        salesTypeReport: 'Raporti i tipit të shitjeve',
        businessDayClose: 'Sipas mbylljes se dites'
      },
      weekdays: {
        monday: 'Hënë',
        tuesday: 'Martë',
        wednesday: 'Mërkurë',
        thursday: 'Enjte',
        friday: 'Premte',
        saturday: 'Shtunë',
        sunday: 'Diel'
      }
    },
    mainMenu: {
      reports: {
        tableTransfers: 'Transferet',
        name: 'Raportet',
        sales: 'Shitjet',
        productSales: 'Shitje produkt',
        hourlySales: 'Shitje sipas ores',
        purchases: 'Blerjet',
        stockChanges: 'Ndryshimi i Inventarit',
        handovers: 'Mbylljet e Turnit',
        waiterRankings: 'Rangimi i kamarierave',
        delivery: 'Delivery',
        ingredients: 'Perberesit',
        damages: 'Demtimet',
        clients: 'Klientet',
        startEndSalesDay: 'Fillimi/Mbarimi',
        categorySales: 'Shitje sipas kategorise',
        staff: 'Staf',
        salesByMaker: 'Shitjet sipas prodhuesit',
        deliveryClients: 'Delivery klientat',
        productByCompoundItemsSales: 'Shitja sipas shtojcave',
        salesBook: 'Libri i shitjes',
        purchaseBook: 'Libri i blerjes',
        regularInvoices: 'Faturat e rregullta',
        productSalesInterval: 'Intervali i Shitjes se produktit',
        paymentMethods: 'menurat e pageses',
        vatSales: 'Shitjet sipas TVSH',
        purchaseProducts: 'Blerjet e produkteve',
        duePayments: 'Borxhet',
        returnedProducts: 'Malli i kthyer',
        reservations: 'Rezervimet'
      },
      menu: 'Menu',
      categories: 'Kategorite',
      products: 'Produktet',
      priceList: 'Lista e Cmimeve',
      floorPlan: 'Plani i tavolinave',
      stock: {
        name: 'Stoku',
        changeStock: 'Ndrysho Inventarin',
        stockCutoff: 'Gjendja e Inventarit',
        inventoryLocations: 'Pikat',
        stockThreshold: 'Limiti i Inventarit',
        transactions: 'Transaksionet e produktit',
        transactionsPeriod: 'Transaksionet e produktit periudha'
      },
      purchases: 'Blerjet',
      config: {
        name: 'Konfigurimi',
        printers: 'Printerat',
        measuringUnits: 'Njesite',
        vat: 'TVSH',
        users: 'Perdoruesit',
        vendors: 'Furnitoret',
        discounts: 'Zbritjet',
        clients: 'Klientet',
        accessPoints: 'Vendndodhjet',
        makers: 'Prodhuesit',
        audit: 'Auditi',
        license: 'Licensat',
        displays: 'Ekranet',
        invoiceClients: 'Subjektet',
        reservationClients: 'Klientet e rezervimeve'
      }
    },
    exportFiles: {
      raporti_transfereve_tavolinave: 'raporti_transfereve_tavolinave',
      raporti_shitjeve: 'raporti_shitjeve',
      raporti_klientave: 'raporti_klientave',
      raporti_barazimeve: 'raporti_Mbylljeve te Turnit',
      raporti_perberesave: 'raporti_perberesave',
      raporti_demtimeve: 'raporti_demtimeve',
      raporti_delivery: 'raporti_delivery',
      raporti_kamarierave: 'raporti_kamarierave',
      raporti_shitjeve_produkt_sipas_ores: 'raporti_shitjeve_produkt_sipas_ores',
      raporti_shitjeve_produkt: 'raporti_shitjeve_produkt',
      raporti_blerjeve: 'raporti_blerjeve',
      raporti_shitjeve_kategorise: 'raporti_shitjeve_kategorise',
      raporti_shitjeve_prodhuesit: 'raporti_shitjeve_prodhuesit',
      raporti_staf: 'raporti_staf',
      raporti_fillimit_mbarimit: 'raporti_fillimit_mbarimit',
      raporti_ndryshimit_Inventarit: 'raporti_ndryshimit_Inventarit',
      raporti_Inventarit: 'raporti_Inventarit',
      gjendja_Inventarit: 'gjendja_Inventarit',
      product_transactions: 'transakstionet_produktit',
      raporti_faturave_rregullta: 'raporti_faturave_rregullta',
      raporti_shitje_produkt_interval: 'raporti_shitje_produkt_interval',
      lista_produkteve: 'lista_produkteve',
      raporti_shitjeve_produkt_interval_ores: 'raporti_shitjeve_produkt_interval_ores',
      raporti_shitjeve_menyres_pageses: 'raporti_shitjeve_menyres_pageses',
      raporti_shitjeve_tvsh: 'raporti_shitjeve_tvsh',
      raporti_blerjeve_produktet: 'raporti_blerjeve_produktet',
      raporti_borxhit: 'raporti_borxhit',
      raporti_kthimit_mallit: 'raporti_kthimit_mallit',
      raporti_rezervimeve: 'raporti_rezervimeve',
      raporti_auditimit: 'raporti_auditimit'
    },
    licenseMessages: {
      LICENSESUCCESS: 'Licensa u aktivizua me sukses.',
      INVALIDSIGNATURE: 'Licensa eshte ndryshuar, nuk eshte valide!',
      INVALIDLICENCETOTHISDEVICE: 'Licensa nuk eshte valide per kete paisje!',
      INVALIDLICENCE: 'Licensa ka skaduar!',
      LICENCECONVERTERROR: 'Teksti i licenses eshte nrsyhuar, licensa nuk eshte valide!',
      NOLICENSEFOUND: 'Kjo paisje nuk eshte e licencuar! Ju lutem kontakto STOM LLC +383 46 333 444!',
      licenseWarning: 'Licensa e programit skadon edhe |daysLicenseExpire| dite, me daten |expireDate|. ' +
        'Ju lutem qe te ri- aktivizoni licensen me kohe, per te vazhduar perdorimin e programit pas dates se skadimit te licenses. ' +
        'Per ri- aktivizim, kontaktoni STOM shpk ne +383 49 313 526'
    }
  },
  en: {
    message: {
      resetDisplayItemConfirm: 'Are you sure you want to change the order status?',
      closeAllOrdersDisplayConfirm: 'Are you sure you want to close all orders? This action cannot be undone.',
      pendingOrders: 'Pending orders',
      noSearchResult: 'No search result.',
      restartMessage: 'POSTOM will restart in...',
      login: 'Login',
      logout: 'Logout',
      details: 'Details',
      transferOrders: 'Transfer orders',
      changeWaiter: 'Change waiter',
      orderClosed: 'Closed order',
      startOfShift: 'Start of shift',
      endOfShift: 'End of shift',
      successfulStartOfShift: 'Successful start of shift.',
      successfulEndOfShift: 'Successful end of shift.',
      scanQrCode: 'Scan QR code',
      confirmOrderTransfer: 'Please confirm the transfer of orders',
      currentWaiter: 'Current Waiter',
      newWaiter: 'New Waiter',
      changeWaiterMsg: 'Your request to change the waiter is sent. If the other waiter accepts it, the transfer will be applied.',
      orderCloseConfirmation: 'Are you sure you want to complete this order?',
      serachSubjectOrFiscal: 'Search with the subject/fiscal number',
      validInvoiceWithoutStamp: 'This invoice is valid without a stamp.',
      removeOrderMessage: 'The order cannot be cancelled because there are active products.',
      // removeOrderRetailMessage: 'The order cannot be cancelled because there are active products.',
      freeTableMessage: 'The table cannot be freed because it has an active order.',
      closeOrderMessage: 'The order is closed. You cannot add any more products.',
      closeOrderConfirmMessage: 'Are you sure you want to close the order and print a fiscal receipt?',
      closeOrderConfirmMessageReservation: 'Is the order linked with this reservation?',
      printFiscalConfirm: 'Are you sure you want to print a fiscal receipt?',
      noProductMessage: 'The order is empty. You cannot print a fiscal receipt.',
      noProductRetailMessage: 'The order is empty. You cannot complete the sale.',
      chooseTotalDiscount: 'Please choose the total discount',
      chooseProdDiscount: 'Please choose a discount for the product',
      scanClientCard: 'Scan client card',
      clientNotExist: 'The card does not exist in the database. Enter customer data to create',
      scanCardToApproveDamage: 'Scan the card or enter your PIN to approve the damage',
      deliveryConfirmMessage: 'Are you sure you want to complete delivery order?',
      splitOrderMessage: 'You cannot divide the whole order. Please choose a few products.',
      clientLeft: 'The client has left.',
      houseCompliments: 'Compliments of the house',
      waitersMistake: 'Waiter\'s mistake',
      finalizeGoodsReturn: 'A jeni i sigurt se deshironi te finalizoni kthimin e mallit?',
      goodsReturnDifference: 'The difference in amount from the returned goods',
      noApproveAccess: 'You do not have the rights to approve this action',
      noBarcode: 'no barcode',
      noCode: 'no code',
      notInStock: 'has run out of stock!',
      stockValue: 'There are only',
      noAdminPrivileges: 'You have no admin privileges!',
      finalizeCashOut: 'Are you sure you want to cash out?',
      waiterCashedOut: 'The waiter has been cashed out.',
      approveExit: 'Close application with approval',
      scanCardToExit: 'Scan code to approve',
      sendReport: 'Send report',
      emailSent: 'Email has been sent successfully!',
      emailFailed: 'There was an error trying to send your email. Please try again.',
      invalidEmail: 'Email not valid!',
      sending: 'Sending',
      device_mismatch: 'The same order is opened in another device. Changes to the order are allowed only on that device.',
      confirm_admin_changes: 'Every change made will overide the changes made by the waiter in the meantime. Do you want to continue?',
      DOCUMENTISCLOSED_CANNOTFINALIZE: 'Document cannot be finalized because it already finalized!',
      DOCUMENTISCLOSED_CANNOTSAVE: 'The product cannot be saved because the document is already finalized!',
      scanCardToApproveFreePayment: 'Scan the card or enter your PIN to approve free of charge payment',
      productsUpdatedWithVat: 'VAT applied to all products',
      tablesUpdatedWithProduct: 'Product applied to all tables',
      chooseTemplate: 'Choose template!',
      cannotDeleteItem: 'The product cannot be removed from the order!',
      serviceClientFormError: 'Phone number, child name and parent name cannot be empty!',
      contiueWithService: 'Continue with service?',
      CANNOTCHANGEDOCUMENTLESSLASTSTOCKRESET: 'Cannot delete stock change that was finalized before the last stock reset!',
      salesAmountChanged: 'Sales amount has changed in the meantime.',
      menus: {
        productExists: 'The product already exists on the menu.',
        pleaseAddProduct: 'Please add products on the menu',
        cantBeEmpty: 'You cannot save an empty menu.',
        confirmProdRemove: 'Are you sure you want to remove a product?',
        confirmRemove: 'Are you sure you want to delete menu?'
      },
      categories: {
        confirmDiscountChanges: 'The discounts for these products will be re-written. Continue?',
        confirmRemove: 'Are you sure you want to delete category? '
      },
      products: {
        confirmRemove: 'Are you sure you want to delete product?',
        confirmIngredientsRemove: 'Delete the product ingredient?',
        addProductIngredients: 'Please add the product ingredients. The list cannot be empty.',
        enabledHappyHour: 'Show Happy hour enabled',
        cannotRemoveLastProduct: 'Last ingredient cannot be deleted before adding another ingredient!',
        productDeleteFailed: 'The product cannot be deleted because it is being used as an ingridient in the products below:'
      },
      tablePlan: {
        confirmRemove: 'Are you sure you want to delete table plan?',
        successUpdate: 'The plan has been successfully updated!'
      },
      stock: {
        confirmRemove: 'Are you sure you want to delete stock change?',
        confirmProdRemove: 'Are you sure you want to remove a product?',
        finalizePurchase: 'Finalize the purchase?',
        confirmStockReset: 'Finalize the stock changes? The data cannot be changed after this.'
      },
      points: {
        confirmRemove: 'Are you sure you want to delete the point?'
      },
      purchases: {
        confirmRemove: 'Are you sure you want to delete purchase?',
        finalizePurchase: 'Finalize the purchase?'
      },
      printers: {
        confirmRemove: 'Are you sure you want to delete the printer?',
        printingError: 'The order was not printed! Please make sure the printer is turned on and connected to the PC. If it still does not work, please contact the person responsible for the printer and other devices.'
      },
      units: {
        confirmRemove: 'Are you sure you want to delete the unit?'
      },
      vats: {
        confirmRemove: 'Are you sure you want to delete the VAT rate?',
        vatRateExist: 'VAT rate exists'
      },
      users: {
        cannotChangeAdminRole: 'You cannot change the role of the administrator!',
        notAdminUser: 'Deleting users is allowed only for Administrators.',
        confirmRemove: 'Are you sure you want to delete user?',
        nameNotNull: 'Please enter the name!',
        pinNotNull: 'Please enter the PIN!',
        roleNotNull: 'Please enter the position!',
        personalNumberNotNull: 'Please enter the ID number!',
        emailNotNull: 'Please enter the email!',
        setStaffLimit: 'Please set a food limit for the user!'
      },
      vendors: {
        confirmRemove: 'Are you sure you want to delete vendor?'
      },
      config: {
        // changeApplied: 'The change is applied. Sign-out and log-in again to view the change. Thank you!',
        changeApplied: 'Please login again to apply changes.',
        bankInfoMandatory: 'The bank and bank account fields are mandatory.',
        chooseOperatingCountry: 'Please select the country of operation'
      },
      vouchers: {
        confirmRemove: 'Are you sure you want to delete voucher?'
      },
      clients: {
        confirmRemove: 'Are you sure you want to delete the client?'
      },
      validations: {
        cannotBeEmpty: 'Cannot be empty!',
        notNullLettersAndNumbers: 'Cannot be empty and must contain only letters and numbers.',
        validNameAndFiscalNumber: 'Name and fiscal number cannot be empty!',
        validProductNameAndTotal: 'Name and product\'s total cannot be empty!',
        cannotBeNegativeValue: 'Cannot be negative value.',
        nameCannotBeEmpty: 'Name cannot be empty!',
        doserCannotBeNegativeValue: 'Doser needs to be grater then zero or empty!'
      },
      expenses: {
        confirmCloseAndRemove: 'A jeni i sigurt qe deshironi ta mbyllni kete faqe? Te gjitha shpenzimet qe nuk jane ruajtur do te fshihen!'
      }
    },
    buttons: {
      splitCourse: 'Split course',
      fiscalCopy: 'Fiscal copy',
      continueWithoutCoupon: 'Continue without coupon',
      continueWithCoupon: 'Continue with coupon',
      groupedOrders: 'Grouped orders',
      changePayment: 'Change payment',
      save: 'Save',
      saveDraft: 'Save draft',
      cancel: 'Cancel',
      continue: 'Continue',
      close: 'Close',
      print: 'Print',
      split: 'Split',
      goBack: 'Back',
      finalize: 'Finalize',
      order: 'Order',
      orders: 'Orders',
      fiscal: 'Fiscal',
      notFiscal: 'Not fiscal',
      finish: 'Finish',
      finishOptionalPrintTotal: 'Finish with receipt',
      qrCode: 'QR code',
      invoice: 'Invoice',
      filterDates: 'Filter dates',
      generateReport: 'Generate report',
      add: 'Add',
      addExpenses: 'Add expenses',
      cashOut: 'Cash out',
      send: 'Send',
      email: 'Email',
      refresh: 'Refresh',
      tryAgain: 'Try again',
      refuse: 'Refuse',
      changeClient: 'Change client',
      menus: {
        addMenu: 'Add menu',
        deleteMenu: 'Delete menu',
        deletePriceList: 'Delete price list',
        addAllProducts: 'Add all products',
        addPriceList: 'Add price list'
      },
      categories: {
        addCategory: 'Add category'
      },
      products: {
        addProduct: 'Add product',
        export: 'Export'
      },
      tablePlan: {
        addPlan: 'Add plan',
        addTable: 'Add table',
        deleteTable: 'Delete table',
        addMultipleTables: 'Add multiple'
      },
      stock: {
        addProduct: 'Add product'
      },
      points: {
        addPoint: 'Add point',
        pointName: 'Point name'
      },
      printers: {
        addPrinter: 'Add printer',
        printerName: 'Printer name',
        printerPort: 'Printer port',
        printerType: 'Printer type',
        fiscalPrinterType: 'Fiscal printer type',
        letterDimensions: 'Letter dimensions',
        dynamicPath: 'Dynamic path'
      },
      units: {
        addUnit: 'Add unit'
      },
      vats: {
        addVat: 'Add VAT',
        vatRate: 'VAT rate'
      },
      users: {
        addUser: 'Add user'
      },
      vendors: {
        addVendor: 'Add vendor',
        vendorName: 'Vendor name',
        chooseVendor: 'Choose vendor'
      },
      locations: {
        addLocation: 'Add location'
      },
      clients: {
        addClient: 'Add client'
      },
      happyHours: {
        addHappyHour: 'Add Happy Hour'
      },
      makers: {
        addMaker: 'Add maker',
        makerName: 'Name of maker',
        chooseMaker: 'Choose maker'
      },
      displays: {
        addDisplay: 'Add display',
        displayName: 'Name'
      }
    },
    labels: {
      receivedBy: 'Pranuar nga',
      outgoingDocument: 'Dokument dales',
      displayControllerPermission: 'Display controller',
      advancedConfiguration: 'Advanced configuration',
      productConfigurationType: 'Product configuration type',
      reason: 'Reason',
      required: 'This field is required',
      freePaymentWithFiscal: 'Free payment with fiscal',
      changePaymentMethodAllOrders: 'Change payment for all orders',
      liveTickerAllOrders: 'Live ticker: all orders',
      currencyExchange: 'Currency exchange',
      excludedVat: 'Excluded from VAT',
      excludedVatCode: 'Excluded from VAT code',
      finished: 'Finished',
      showAll: 'Show all',
      expense: 'Expense',
      freeTables: ' OPEN',
      reservationsArriving: 'In 30 min',
      reservationClientPriority: 'Client with priority',
      additionalInfo: 'Additional info',
      tablesWithoutReservations: 'Free tables',
      changeReservationStatus: 'Change reservation status',
      reservationStatusUpdateFailed: 'Failed to update reservation status!',
      reservationDeleteConfirmation: 'Are you sure you want to delete the reservation?',
      showed: 'Showed',
      notShowed: 'Did not show',
      clientAdditionalInfo: 'Client additional info',
      newReservation: 'New reservation',
      numberPersons: 'Number of persons',
      reservations: 'Reservations',
      totalWithoutDiscount: 'Total before discount',
      serviceFee: 'Service fee',
      serviceFeeType: 'Service fee type',
      serviceFeeAutomatic: 'Service fee automatic',
      courseSpliter: 'Split course',
      employeeTip: 'Tip',
      deleteOrderPermission: 'Delete order permission',
      orderDeleteConfirmation: 'Are you sure you want to delete the order?',
      delete: 'Delete',
      avgPrice: 'Average price',
      sellPriceWithVAt: 'Selling price (with VAT)',
      totalSellPriceWithVAt: 'Total selling price',
      clearCreateNew: 'Clear / Create new client',
      duePayment: 'Due payment',
      loanPermission: 'Due payments permission',
      minDate: 'Start date',
      maxDate: 'End date',
      numberOfOrders: 'Number of orders',
      selectedToPay: 'To pay',
      paidProducts: 'Partial payments',
      ordersCount: 'No. of orders',
      onlinePaymentProcessing: 'Processing ...',
      onlinePaymentCanceled: 'Canceled/Failed!',
      onlinePaymentSuccess: 'Success.',
      changePaymentMethod: 'Change payment',
      refreshIn: 'Refresh in',
      identifierCode: 'Identifier code',
      writeDescription: 'Write comment',
      apiCode: 'API code',
      doNotPrint: 'Do not print',
      calculatePrice: 'Calculate price',
      actualPrice: 'Actual price',
      newPrice: 'New price',
      displayInInterval: 'Display in interval',
      ingredient: 'Ingredient',
      day: 'Day',
      month: 'Month',
      year: 'Year',
      birthDate: 'Date of birth',
      pin: 'PIN',
      active: 'Active',
      inactive: 'Inactive',
      activate: 'Activate',
      activateDeductions: 'Activate deductions',
      order: 'Order',
      orders: 'Orders',
      theOrder: 'Order',
      orderAndContinue: 'Order + Continue',
      information: 'Information',
      printReceipt: 'Print receipt',
      printWReceipt: 'Print w/o receipt',
      clearOrder: 'Clear order',
      clearTable: 'Clear table',
      cancelOrder: 'Cancel order',
      splitOrder: 'Split order',
      product: 'Product',
      products: 'Products',
      productType: 'Product type',
      quantity: 'Quantity',
      total: 'Total',
      totalAmount: 'Total amount',
      discount: 'Discount | Disc.',
      discounts: 'Discounts',
      price: 'Price',
      phone: 'Phone',
      delivery: 'Delivery',
      takeAway: 'Take away',
      inHouse: 'In house',
      table: 'Table',
      tables: 'Tables',
      amount: 'Amount',
      waiter: 'Waiter',
      plan: 'Plan',
      free: 'Free',
      open: 'Open',
      closed: 'Closed',
      busy: 'Busy',
      status: 'Status',
      confirmation: 'Confirmation',
      currentQuantity: 'Current quantity',
      previousQuantity: 'Previous quantity',
      difference: 'Difference',
      lastChange: 'Last change',
      date: 'Date',
      payment: 'Payment',
      collect: 'Collect',
      collected: 'Collected',
      collection: 'Collection',
      uncollected: 'Not collected',
      actions: 'Actions',
      client: 'Client',
      deliveryClient: 'Delivery client',
      chooseEmployee: 'Choose employee',
      business: 'Business',
      ngo: 'NGO',
      search: 'Search',
      fiscalNumber: 'NUI',
      vatNumber: 'Vat number',
      businessNumber: 'Business number',
      registrationNumber: 'Regsitration number',
      name: 'Name',
      address: 'Address',
      businessAddress: 'Business address',
      city: 'City',
      contactPerson: 'Contact person',
      comment: 'Comment',
      email: 'Email',
      website: 'Website',
      contact: 'Contact',
      bank: 'Bank',
      bankAccount: 'Bank account',
      cash: 'Cash',
      code: 'Code',
      barcode: 'Barcode',
      card: 'Card',
      idCard: 'ID card',
      seller: 'Seller',
      buyer: 'Buyer',
      value: 'Value',
      valueWithVat: 'Value with VAT',
      valueWithoutVat: 'Value w/o VAT',
      priceWithVat: 'Price with VAT',
      priceWithoutVat: 'Price w/o VAT',
      vat: 'VAT',
      chooseVat: 'Choose VAT',
      forPayment: 'For payment',
      submitted: 'Submitted',
      accept: 'Accept',
      from: 'From',
      to: 'To',
      until: 'Until',
      fromTable: 'From table',
      toTable: 'To table',
      staff: 'Staff',
      staffOrder: 'Staff order',
      staffPrice: 'Staff price',
      damagedGoods: 'Damaged goods',
      damagedProduct: 'Damaged product',
      reportDamage: 'Report damage',
      forFood: 'For food',
      chooseBank: 'Choose bank',
      chooseBanks: 'Choose banks',
      approveDamage: 'Approve the damage',
      chooseDate: 'Choose date',
      moneyChange: 'Change',
      freeOfCharge: 'Free of charge',
      goodsReturn: 'Return of goods',
      return: 'Return',
      categories: 'Categories',
      category: 'Category',
      categoryType: 'Category type',
      ranking: 'Ranking',
      autoRanking: 'Automatic order',
      rankingPrinter: 'Display-rank on the receipt',
      choose: 'Choose',
      description: 'Description',
      employee: 'Employee',
      user: 'User',
      vendor: 'Vendor',
      time: 'Time',
      paymentType: 'Payment type',
      orderType: 'Order type',
      invoiceNumber: 'Invoice nr',
      document: 'Document',
      transfer: 'Transfer',
      start: 'Start',
      end: 'End',
      damages: 'Damages',
      expenses: 'Expenses',
      totalSales: 'Total sales',
      mostSoldProd: 'The most-sold product',
      mostSoldProdQuantity: 'The quantity of the most-sold product',
      approvedBy: 'Approved by',
      clientName: 'Client name',
      clientCode: 'Client code',
      clientCard: 'Client card',
      cardNumber: 'Card number',
      ordersNumber: 'Nr. of orders',
      withDetails: 'With details',
      clients: 'Clients',
      type: 'Type',
      menuIcon: 'Menu icon',
      addProduct: 'Add product',
      addCategory: 'Add category',
      authorizedPerson: 'Authorized person',
      beginning: 'Beginning',
      dailySales: 'Daily sales',
      handedOver: 'Handed over',
      kitchen: 'Kitchen',
      choosePrinter: 'Choose printer/s',
      printer: 'Printer',
      bar: 'Bar',
      yes: 'Yes',
      no: 'No',
      color: 'Color',
      receipt: 'receipt',
      menu: 'Menu',
      picture: 'Picture',
      chooseCategory: 'Choose category',
      internalCode: 'Code',
      unit: 'Unit',
      units: 'Units',
      stockChange: 'Change the stock',
      dynamicAmount: 'Dynamic quantity',
      simple: 'Simple',
      compound: 'Compound',
      combo: 'Combo',
      comboQuantity: 'Combo quantity',
      productsIngredients: 'Product ingredients',
      preSelected: 'Pre-selected',
      preSelectedQuantity: 'Pre-selected quantity',
      dynamic: 'Dynamic',
      recipe: 'Recipe',
      default: 'Defualt',
      happyHour: 'Happy Hour',
      letter: 'Letter',
      number: 'Number',
      addedRemovedQty: 'Added/Removed quantity',
      draft: 'Draft',
      finalized: 'Finalized',
      view: 'View',
      stock: 'Stock',
      point: 'Point',
      productAt: 'The product at ',
      choosePoint: 'Choose point',
      ip: 'IP',
      rate: 'Rate',
      country: 'Country',
      currency: 'Currency',
      uploadLogo: 'Upload logo (max. 2MB)',
      general: 'General',
      port: 'Port',
      other: 'Other',
      level: 'Level',
      createdDate: 'Created date',
      role: 'Role',
      personalNumber: 'Personal number',
      dailyFoodLimit: 'Daily food allowance limit',
      calculateDiscount: 'Calculate discount',
      productsPrice: 'Product\'s price',
      priceWithDiscount: 'Price with discount',
      paid: 'Paid',
      remaining: 'Remaining',
      sum: 'Sum',
      sale: 'Sale',
      typesOfSales: 'Types of sales',
      qtyAndValue: 'Value and quantity',
      days: 'Days',
      choosePaymentType: 'Choose payment type',
      lastCount: 'Last count',
      purchaseDate: 'Purchase date',
      invoiceDate: 'Invoice date',
      stateReason: 'State reason',
      today: 'Today',
      yesterday: 'Yesterday',
      lastSevenDays: 'Last 7 days',
      lastThirtyDays: 'Last 30 days',
      emails: 'Emails',
      notification: 'Notification',
      programQuantity: 'Program quantity',
      physicalQuantity: 'Physical quanity',
      differencePurchasePrice: 'Difference purchase price',
      differenceSellPrice: 'Difference sell price',
      percentage: 'Percentage',
      filters: 'Filters',
      choosePeriod: 'Choose Period',
      language: 'Language',
      startEnd: 'Start/End',
      pcs: 'Pcs',
      createdBy: 'Created by',
      maker: 'Maker',
      addMaker: 'Add by maker',
      makers: 'Makers',
      searchClient: 'Search client',
      raportiDitor: 'Daily report',
      advance: 'Advance',
      doser: 'Doser',
      canCashOut: 'Cash out',
      waiterAccess: 'Waiter access',
      userAccess: 'User access (not Admin)',
      system: 'System',
      configOrder: 'Order',
      othersQuantity: 'Other quantity',
      totalOrders: 'No. of orders',
      displayOnlyResetProducts: 'Display only reset products',
      orderNumber: 'Order',
      employeeDeleted: 'Deleted by',
      deletedDate: 'Deleted date',
      show: 'Show',
      inhouse: 'Inhouse',
      takeaway: 'Takeaway',
      fiscal: 'Fiscal',
      noFiscal: 'No fiscal',
      noPayment: 'Free',
      invoice: 'Invoice',
      dailyDiscount: 'Daily',
      aggregate: 'Daily',
      salesman: 'Salesman',
      display: 'Display',
      chooseDisplay: 'Choose display/s',
      displayOnlyInTheseDevices: 'Display in this device ([0]) orders only from',
      clientDiscount: 'Discount',
      lock: 'Lock',
      stockThreshold: 'Stock threshold',
      service: 'Service',
      withTimer: 'With timer',
      cardNumberOrTelephone: 'Card numer or phone number',
      priceType: 'Price type',
      priceCalculation: 'Price calculation',
      applyToTables: 'Apply to tables',
      receiptForAllOrders: 'Receipt for all orders',
      parent: 'Parent',
      child: 'Child',
      twilioFriendlyName: 'Number/Name',
      smsSucces: 'SMS sent successfully.',
      SalesOrder: 'Sales order',
      StockChange: 'Stock change',
      StockReset: 'Stock reset',
      VendorPurchase: 'Purchase',
      showProduct: 'Show product',
      showCategory: 'Show category',
      showMaker: 'Show maker',
      showAllTableTotals: 'Show total of everyone (tables)',
      regularInvoiceForAllOrders: 'Regular invoice for all orders',
      totalQuantity: 'Total quantity',
      roles: {
        Admin: 'Admin',
        Waiter: 'Waiter',
        Kamarier: 'Waiter',
        Menaxher: 'Manager',
        Depoist: 'Warehouse',
        Staf: 'Staff',
        Salesman: 'Salesman',
        Display: 'Display'
      },
      approveFreePayment: 'Approve free of charge',
      purchasePriceWithoutVat: 'Purchase price (without VAT)',
      vendorName: 'Furnitori',
      totalWithouVat0: 'Total me TVSH 0%',
      totalWithoutVat8: 'Total pa TVSH (8%)',
      vatAmount8: 'Vlera e TVSH (8%)',
      totalWithoutVat18: 'Total pa TVSH (18%)',
      vatAmount18: 'Vlera e TVSH (18%)',
      applyToProducts: 'Apply to prodcuts',
      sellPrice: 'Sell price',
      margin: 'Margin',
      deliveryType: 'Delivery type',
      totalCurrentPrice: 'Total current price',
      configLabels: {
        hideDeliveryTotals: 'Hide delivery totals',
        printerNameTicket: 'Printer name in tickets',
        cardPaymentFee: 'Card payment fee',
        fiscalExtraMessage: 'Fiscal: extra text',
        reservationDuration: 'Reservation duration (hour)',
        mobileHideTotal: 'PostomGo: Hide total',
        courseSpliters: 'Course spliters',
        waiterSelfHandouts: 'Waiter self handout',
        liveTickerNoActions: 'Live ticker: block actions',
        chooseFiscalThermalPrinter: 'Choose fiscal thermal printer',
        employeeClocktimeProductSales: 'Display sold products on handouts print',
        searchClientCards: 'Show "Search" in clients card',
        chooseGeneralPrinter: 'Choose main printer',
        duplicatePrinter: 'Duplicate printer',
        duplicateGeneralPrinter: 'Duplicate the main printer',
        chooseFiscalPrinter: 'Choose fiscal printer',
        chooseInvoicePrinter: 'Invoice printer',
        duplicateInvoicePrinter: 'Duplicate a printer that prints the invoice',
        chooseCashOnPrinter: 'Cash-out printer',
        chooseFinalInvoicePrinter: 'Non-fiscal receipt printer',
        duplicateFinalInvoicePrinter: 'Duplicate a printer that prints the final invoice',
        finalInvoiceQuantity: 'Invoice copies',
        notRestaurant: 'Not a restaurant/bar',
        allowNegativeStock: 'Allow negative stock values',
        fiscalConfirm: 'Fiscal receipt confirmation',
        defaultDelivery: 'Delivery by default',
        manualFreeTable: 'Manually free the table',
        kitchenPrinter: 'Kitchen/Printer',
        cardPayment: 'Payment by card',
        directOrder: 'Direct order',
        showTotalOnNonfiscal: 'Non-fiscal receipt total',
        orderTotalNonFiscalOptional: '(Optional) Non-fiscal receipt total',
        showCommentsOnNonfiscal: 'Show comments on non-fiscal invoice',
        orderNrOnFiscal: 'Fiscal receipt order number',
        fixedShift: 'Start amount',
        adminCashShift: 'Cash start (for admins)',
        orderToKitchenAfterPayment: 'Send order post-payment',
        returnToTableAfterOrder: 'Return to table-view after order',
        logoutAfterOrder: 'Logout after ordering',
        returnToTableAfterPayment: 'Return to table-view after payment',
        logoutAfterPayment: 'Logout after payment',
        managerCashOut: 'Allow the manager to  cash-out waiters',
        dontIncludeCustomersIdinSale: 'Do not include Customers\' ID in sales',
        approvalDamages: 'Damages need an approval',
        mobilePos: 'Activate Mobile POS',
        closeAutomatically: 'Close automatically',
        transfers: 'Transfers',
        approveProgramClose: 'Approve program close',
        codeAndMakers: 'Code and Maker in products',
        enableMinimize: 'Enable app minimize<br/> <small>(valid for current device)</small>',
        liveTicker: 'Live ticker',
        liveTickerAllOrders: 'Live ticker: show only waiter orders',
        liveTickerSalesmanAllOrders: 'Live ticker: show only salesman orders',
        handoutsCalculateCard: 'Calculate sales with bank in handouts',
        autoStart: 'Auto start (applies only for this device)',
        printQuantityFromLeft: 'Quantity on the left (print)',
        disableOrderComments: 'Disable order comments',
        freePaymentConfirm: 'Free of charge with confirmation',
        displays: 'Displays',
        onlyFiscal: 'Only fiscal',
        isService: 'Is service',
        serviceClient: 'Kids playground',
        directOnlyFiscal: 'Direct fiscal'
      },
      reportsLabels: {
        salesTypeReport: 'Sales type report',
        businessDayClose: 'Business day close'
      },
      weekdays: {
        monday: 'Monday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday',
        thursday: 'Thursday',
        friday: 'Friday',
        saturday: 'Saturday',
        sunday: 'Sunday'
      }
    },
    mainMenu: {
      reports: {
        tableTransfers: 'Transfers',
        name: 'Reports',
        sales: 'Sales',
        productSales: 'Product Sales',
        hourlySales: 'Hourly Sales',
        purchases: 'Purchases',
        stockChanges: 'Stock Changes',
        handovers: 'Handovers',
        waiterRankings: 'Waiter Rankings',
        delivery: 'Delivery',
        ingredients: 'Ingredients',
        damages: 'Damages',
        clients: 'Clients',
        startEndSalesDay: 'Start/End Sales Day',
        categorySales: 'Category Sales',
        staff: 'Staff',
        salesByMaker: 'Sales by maker',
        deliveryClients: 'Delivery clients',
        productByCompoundItemsSales: 'Sales by addons',
        salesBook: 'Sales book',
        purchaseBook: 'Purchase book',
        regularInvoices: 'Regular invoices',
        productSalesInterval: 'Product sales interval',
        paymentMethods: 'Payment methods',
        vatSales: 'VAT sales',
        purchaseProducts: 'Purchase products',
        duePayments: 'Due payments',
        returnedProducts: 'Returned products',
        reservations: 'Reservations'
      },
      menu: 'Menu',
      categories: 'Categories',
      products: 'Products',
      priceList: 'Price lists',
      floorPlan: 'Floor plan',
      stock: {
        name: 'Stock',
        changeStock: 'Change stock',
        stockCutoff: 'Stock cut-off',
        inventoryLocations: 'Inventory Locations',
        stockThreshold: 'Stock threshold',
        transactions: 'Product transactions',
        transactionsPeriod: 'Product transactions period'
      },
      purchases: 'Purchases',
      config: {
        name: 'Settings',
        printers: 'Printers',
        measuringUnits: 'Measuring Units',
        vat: 'VAT',
        users: 'Users',
        vendors: 'Vendors',
        discounts: 'Discounts',
        clients: 'Clients',
        accessPoints: 'Access Points',
        makers: 'Makers',
        audit: 'Audit',
        license: 'License',
        displays: 'Displays',
        invoiceClients: 'Subjects',
        reservationClients: 'Reservation clients'
      }
    },
    exportFiles: {
      raporti_transfereve_tavolinave: 'table_transfers_report',
      raporti_shitjeve: 'sales_report',
      raporti_klientave: 'clients_report',
      raporti_barazimeve: 'handover_report',
      raporti_perberesave: 'ingridients_report',
      raporti_demtimeve: 'damages_report',
      raporti_delivery: 'delivery_report',
      raporti_kamarierave: 'waiters_report',
      raporti_shitjeve_produkt_sipas_ores: 'product_hourly_sales_report',
      raporti_shitjeve_produkt: 'product_sales_report',
      raporti_blerjeve: 'purchases_report',
      raporti_shitjeve_kategorise: 'category_sales_report',
      raporti_shitjeve_prodhuesit: 'maker_sales_report',
      raporti_staf: 'staff_report',
      raporti_fillimit_mbarimit: 'sales_day_report',
      raporti_ndryshimit_stokut: 'stock_change_report',
      raporti_stokut: 'stock_report',
      prerja_stokut: 'stock_reset',
      product_transactions: 'product_transactions',
      raporti_faturave_rregullta: 'regular_invoices_report',
      raporti_shitje_produkt_interval: 'product_sales_interval_report',
      lista_produkteve: 'products_list',
      raporti_shitjeve_produkt_interval_ores: 'product_sales_interval_report',
      raporti_shitjeve_menyres_pageses: 'payment_method_sales_report',
      raporti_shitjeve_tvsh: 'vat_sales_report',
      raporti_blerjeve_produktet: 'purchase_products_report',
      raporti_borxhit: 'due_payments_report',
      raporti_kthimit_mallit: 'returned_products_report',
      raporti_rezervimeve: 'reservations_report',
      raporti_auditimit: 'audit_report'
    },
    licenseMessages: {
      LICENSESUCCESS: 'License activated successfully.',
      INVALIDSIGNATURE: 'License is changed and is not valid!',
      INVALIDLICENCETOTHISDEVICE: 'License is not valid for this device!',
      INVALIDLICENCE: 'The license has expired!',
      LICENCECONVERTERROR: 'The text of the license has changed, license is not valid!',
      NOLICENSEFOUND: 'This device is not licensed! Please contact STOM LLC +383 46 333 444!',
      licenseWarning: 'The application license expires in |daysLicenseExpire| days, on |expireDate|. ' +
        'Please reactivate the license on time in order to continue using the application after the license expiration date. ' +
        'To reactivate, contact STOM shpk on +383 49 313 526'
    }
  },
  mk: {
    message: {
      resetDisplayItemConfirm: 'Дали сте сигурни дека сакате да ја промените статусот на нарачката?',
      closeAllOrdersDisplayConfirm: 'Дали сте сигурни дека сакате да затворите сите нарачки? Оваа акција не може да се анулира.',
      pendingOrders: 'Нерешени нарачки',
      noSearchResult: 'Нема резултати од пребарувањето.',
      restartMessage: 'ПОСТОМ ќе се рестартира за...',
      login: 'Најава',
      logout: 'Одјава',
      details: 'Детали',
      transferOrders: 'Пренеси ги нарачките',
      changeWaiter: 'Смени келнер',
      orderClosed: 'Затворена нарачка',
      startOfShift: 'Почеток на смена',
      endOfShift: 'Крај на смена',
      successfulStartOfShift: 'Успешен почеток на смена.',
      successfulEndOfShift: 'Успешен крај на смена.',
      scanQrCode: 'Скенирај QR код',
      confirmOrderTransfer: 'Потврди го преносот на нарачки',
      currentWaiter: 'Моментален келнер',
      newWaiter: 'Нов келнер',
      changeWaiterMsg: 'Вашето барање за промена на келнер е испратено. Доколку другиот келнер го прифати, преносот ќе се изврши.',
      orderCloseConfirmation: 'Дали сте сигурни дека сакате да ја затворите нарачката?',
      serachSubjectOrFiscal: 'Пребарај фискален субјект/број',
      validInvoiceWithoutStamp: 'Оваа фактура важи без печат.',
      removeOrderMessage: 'Нарачката не може да се откаже бидејќи содржи производи.',
      freeTableMessage: 'Масата не може да се ослободи, има активни нарачки.',
      closeOrderMessage: 'Нарачката е затворена. Не можете да додавате производи.',
      closeOrderConfirmMessage: 'Дали сте сигурни дека сакате да ја затворите нарачката и да испечатите фискален сметка?',
      closeOrderConfirmMessageReservation: 'Дали нарачката е поврзана со оваа резервација?',
      printFiscalConfirm: 'Дали сте сигурни дека сакате да испечатите фискален сметка?',
      noProductMessage: 'Нарачката е празна. Не можете да испечатите фискален сметка.',
      noProductRetailMessage: 'Нарачката е празна. Не можете да ја завршите продажбата.',
      chooseTotalDiscount: 'Изберете вкупен попуст',
      chooseProdDiscount: 'Изберете попуст за производ',
      scanClientCard: 'Скенирајте клиентска картичка',
      clientNotExist: 'Картичката не постои. Внесете ги податоците за да креирате клиент.',
      scanCardToApproveDamage: 'Скенирајте картичка или внесете PIN за одобрување на штета',
      deliveryConfirmMessage: 'Дали сте сигурни дека сакате да ја завршите delivery нарачката?',
      splitOrderMessage: 'Не можете да ја поделите целата нарачка. Изберете само дел.',
      clientLeft: 'Клиентот замина.',
      houseCompliments: 'Комплимент од куќа',
      waitersMistake: 'Грешка на келнер',
      finalizeGoodsReturn: 'Дали сте сигурни дека сакате да финализирате враќање на стока?',
      goodsReturnDifference: 'Разлика при враќање стока',
      noApproveAccess: 'Немате привилегии за одобрување!',
      noBarcode: 'нема баркод',
      noCode: 'нема код',
      notInStock: 'нема на залиха!',
      stockValue: 'на залиха има само',
      noAdminPrivileges: 'Немате административни привилегии!',
      finalizeCashOut: 'Дали сте сигурни дека сакате да финализирате порамнување?',
      waiterCashedOut: 'Келнерот е порамнет.',
      approveExit: 'Одобри затворање/минимизирање на програмата',
      scanCardToExit: 'Скенирајте картичка или внесете PIN за одобрување',
      sendReport: 'Испрати извештај',
      emailSent: 'Е-поштата е успешно испратена!',
      emailFailed: 'Е-поштата не е испратена. Обидете се повторно.',
      invalidEmail: 'Е-поштата не е валидна!',
      sending: 'Се испраќа',
      device_mismatch: 'Истата нарачка е отворена на друг уред. Промените се дозволени само на тој уред.',
      confirm_admin_changes: 'Сите промени ќе ги пребришат промените направени од келнерот. Дали сакате да продолжите?',
      DOCUMENTISCLOSED_CANNOTFINALIZE: 'Документот не може да се финализира бидејќи е веќе финализиран!',
      DOCUMENTISCLOSED_CANNOTSAVE: 'Производот не може да се зачува бидејќи документот е финализиран!',
      scanCardToApproveFreePayment: 'Скенирајте картичка или внесете PIN за одобрување на бесплатна уплата',
      productsUpdatedWithVat: 'ДДВ е применет на сите производи',
      tablesUpdatedWithProduct: 'Производот е применет на сите маси',
      chooseTemplate: 'Изберете шаблон!',
      cannotDeleteItem: 'Производот не може да се избрише од нарачката!',
      serviceClientFormError: 'Телефон, име на дете и име на родител не смеат да бидат празни!',
      contiueWithService: 'Да продолжиме со услугата?',
      CANNOTCHANGEDOCUMENTLESSLASTSTOCKRESET: 'Не може да се избрише промена на залихи направена пред последното ресетирање!',
      salesAmountChanged: 'Износот на продажба е променет во меѓувреме.',
      menus: {
        productExists: 'Производот веќе постои во менито.',
        pleaseAddProduct: 'Ве молиме додадете производи во менито.',
        cantBeEmpty: 'Празното мени не може да се зачува.',
        confirmProdRemove: 'Дали сте сигурни дека сакате да го отстраните производот?',
        confirmRemove: 'Дали сте сигурни дека сакате да го избришете менито?'
      },
      categories: {
        confirmDiscountChanges: 'Попустите на производите од оваа категорија ќе бидат пребришани. Дали сакате да продолжите?',
        confirmRemove: 'Дали сте сигурни дека сакате да ја избришете категоријата?'
      },
      products: {
        confirmRemove: 'Дали сте сигурни дека сакате да го избришете производот?',
        confirmIngredientsRemove: 'Дали сакате да го избришете состојката?',
        addProductIngredients: 'Ве молиме додадете состојки на производот, листата не може да биде празна.',
        enabledHappyHour: 'Прикажи само со Happy Hour',
        cannotRemoveLastProduct: 'Последната состојка не може да се избрише без да додадете нова!',
        productDeleteFailed: 'Производот не може да се избрише бидејќи се користи како состојка во следниве производи:'
      },
      tablePlan: {
        confirmRemove: 'Дали сте сигурни дека сакате да го избришете планот?',
        successUpdate: 'Планот е успешно ажуриран!'
      },
      stock: {
        confirmRemove: 'Дали сте сигурни дека сакате да ја избришете промената на залихите?',
        confirmProdRemove: 'Дали сте сигурни дека сакате да го отстраните производот?',
        finalizePurchase: 'Дали сакате да финализирате набавка?',
        confirmStockReset: 'Дали сакате да финализирате ресетирање на залихи? Податоците нема да можат да се менуваат после ова!'
      },
      points: {
        confirmRemove: 'Дали сте сигурни дека сакате да ја избришете точката?'
      },
      purchases: {
        confirmRemove: 'Дали сте сигурни дека сакате да ја избришете набавката?',
        finalizePurchase: 'Дали сакате да финализирате набавка?'
      },
      printers: {
        confirmRemove: 'Дали сте сигурни дека сакате да го избришете печатачот?',
        printingError: 'Нарачката не е испечатена! Проверете дали печатачот е вклучен и поврзан. Доколку проблемот продолжи, контактирајте го одговорниот за печатачи.'
      },
      units: {
        confirmRemove: 'Дали сте сигурни дека сакате да ја избришете единицата?'
      },
      vats: {
        confirmRemove: 'Дали сте сигурни дека сакате да ја избришете даночната стапка?',
        vatRateExist: 'Оваа ДДВ стапка веќе постои'
      },
      users: {
        cannotChangeAdminRole: 'Не можете да ја промените улогата на администратор!',
        notAdminUser: 'Немате администраторски привилегии за бришење на корисник!',
        confirmRemove: 'Дали сте сигурни дека сакате да го избришете корисникот?',
        nameNotNull: 'Името не може да биде празно!',
        pinNotNull: 'PIN не може да биде празен!',
        roleNotNull: 'Улогата не може да биде празна!',
        personalNumberNotNull: 'Личниот број не може да биде празен!',
        emailNotNull: 'Е-поштата не може да биде празна!',
        setStaffLimit: 'Поставете лимит на храна за корисникот!'
      },
      vendors: {
        confirmRemove: 'Дали сте сигурни дека сакате да го избришете добавувачот?'
      },
      config: {
        changeApplied: 'Промената е применета. Најавете се повторно за да ги видите промените.',
        bankInfoMandatory: 'Банката и банкарската сметка мора да се пополнат!',
        chooseOperatingCountry: 'Мора да изберете држава каде што работите!'
      },
      vouchers: {
        confirmRemove: 'Дали сте сигурни дека сакате да го избришете ваучерот?'
      },
      clients: {
        confirmRemove: 'Дали сте сигурни дека сакате да го избришете клиентот?'
      },
      validations: {
        cannotBeEmpty: 'Не може да биде празно!',
        notNullLettersAndNumbers: 'Не може да биде празно и мора да содржи само букви и бројки.',
        validNameAndFiscalNumber: 'Името и фискалниот број не смеат да бидат празни!',
        validProductNameAndTotal: 'Името на производот и вкупниот износ не смеат да бидат празни!',
        cannotBeNegativeValue: 'Не може да биде негативна вредност.',
        nameCannotBeEmpty: 'Името не може да биде празно!',
        doserCannotBeNegativeValue: 'Дозата мора да биде поголема од нула или празна!'
      },
      expenses: {
        confirmCloseAndRemove: 'Дали сте сигурни дека сакате да ја затворите оваа страница? Сите незачувани трошоци ќе бидат избришани!'
      }
    },
    buttons: {
      splitCourse: 'Подели курс',
      fiscalCopy: 'Фискална копија',
      groupedOrders: 'Групирани нарачки',
      changePayment: 'Смени начин на плаќање',
      continueWithoutCoupon: 'Продолжи без купон',
      continueWithCoupon: 'Продолжи со купон',
      save: 'Зачувај',
      saveDraft: 'Зачувај нацрт',
      cancel: 'Откажи',
      continue: 'Продолжи',
      close: 'Затвори',
      print: 'Печати',
      split: 'Подели',
      goBack: 'Назад',
      finalize: 'Финализирај',
      fiscal: 'Фискална',
      notFiscal: 'Нефискална',
      finish: 'Заврши',
      finishOptionalPrintTotal: 'Заврши со сметка',
      qrCode: 'QR код',
      invoice: 'Фактура',
      filterDates: 'Филтрирај датуми',
      generateReport: 'Генерирај извештај',
      add: 'Додади',
      addExpenses: 'Додади трошоци',
      cashOut: 'Порамни',
      send: 'Испрати',
      email: 'Е-пошта',
      refresh: 'Освежи',
      tryAgain: 'Обиди се повторно',
      refuse: 'Одбиј',
      changeClient: 'Смени клиент',
      menus: {
        addMenu: 'Додади мени',
        deleteMenu: 'Избриши мени',
        deletePriceList: 'Избриши ценовник',
        addAllProducts: 'Додади ги сите производи',
        addPriceList: 'Додади ценовник'
      },
      categories: {
        addCategory: 'Додади категорија'
      },
      products: {
        addProduct: 'Додади производ',
        export: 'Извези'
      },
      tablePlan: {
        addPlan: 'Додади план',
        addTable: 'Додади маса',
        deleteTable: 'Избриши маса',
        addMultipleTables: 'Додади повеќе маси'
      },
      stock: {
        addProduct: 'Додади производ'
      },
      points: {
        addPoint: 'Додади точка',
        pointName: 'Име на точка'
      },
      printers: {
        addPrinter: 'Додади печатач',
        printerName: 'Име на печатач',
        printerPort: 'Порт на печатач',
        printerType: 'Тип на печатач',
        fiscalPrinterType: 'Тип на фискален печатач',
        letterDimensions: 'Димензии на буква',
        dynamicPath: 'Динамичка патека'
      },
      units: {
        addUnit: 'Додади единица'
      },
      vats: {
        addVat: 'Додади ДДВ',
        vatRate: 'Стапка на ДДВ'
      },
      users: {
        addUser: 'Додади корисник'
      },
      vendors: {
        addVendor: 'Додади добавувач',
        vendorName: 'Име на добавувач',
        chooseVendor: 'Избери добавувач'
      },
      locations: {
        addLocation: 'Додади локација'
      },
      clients: {
        addClient: 'Додади клиент'
      },
      happyHours: {
        addHappyHour: 'Додади среќен час'
      },
      makers: {
        addMaker: 'Додади производител',
        makerName: 'Име на производител',
        chooseMaker: 'Избери производител'
      },
      displays: {
        addDisplay: 'Додади дисплеј',
        displayName: 'Име'
      }
    },
    labels: {
      receivedBy: 'Доставен од',
      outgoingDocument: 'Излезен документ',
      displayControllerPermission: 'Display controller',
      advancedConfiguration: 'Advanced configuration',
      productConfigurationType: 'Product configuration type',
      reason: 'Причина',
      required: 'Ова поле е задолжително',
      freePaymentWithFiscal: 'Бесплатна уплата со фискална',
      changePaymentMethodAllOrders: 'Смени начин на плаќање за сите нарачки',
      liveTickerAllOrders: 'Во живо: сите нарачки',
      currencyExchange: 'Валутен курс',
      excludedVat: 'Исклучено од ДДВ',
      excludedVatCode: 'Исклучено од ДДВ код',
      finished: 'Завршено',
      showAll: 'Прикажи ги сите',
      expense: 'Трошок',
      freeTables: 'Слободни',
      reservationsArriving: 'За 30 мин',
      reservationClientPriority: 'Клиент со приоритет',
      additionalInfo: 'Дополнителни информации',
      tablesWithoutReservations: 'Слободни маси',
      changeReservationStatus: 'Смени статус на резервација',
      reservationStatusUpdateFailed: 'Неуспешно ажурирање на статусот на резервација!',
      reservationDeleteConfirmation: 'Дали сте сигурни дека сакате да ја избришете резервацијата?',
      showed: 'Се појави',
      notShowed: 'Не се појави',
      clientAdditionalInfo: 'Дополнителни информации за клиентот',
      newReservation: 'Нова резервација',
      numberPersons: 'Број на лица',
      reservations: 'Резервации',
      totalWithoutDiscount: 'Вкупно пред попуст',
      serviceFee: 'Надоместок за услуга',
      serviceFeeType: 'Тип на надоместок',
      serviceFeeAutomatic: 'Автоматски надоместок',
      courseSpliter: 'Подели курс',
      employeeTip: 'Бакшиш',
      deleteOrderPermission: 'Дозвола за бришење нарачка',
      orderDeleteConfirmation: 'Дали сте сигурни дека сакате да ја избришете нарачката?',
      delete: 'Избриши',
      avgPrice: 'Просечна цена',
      sellPriceWithVAt: 'Продажна цена (со ДДВ)',
      totalSellPriceWithVAt: 'Вкупна продажна цена',
      clearCreateNew: 'Исчисти/Креирај нов клиент',
      duePayment: 'Должна уплата',
      loanPermission: 'Дозвола за должни уплати',
      minDate: 'Почетен датум',
      maxDate: 'Завршен датум',
      numberOfOrders: 'Број на нарачки',
      selectedToPay: 'За плаќање',
      paidProducts: 'Делумни уплати',
      ordersCount: 'Бр. на нарачки',
      onlinePaymentProcessing: 'Се процесира...',
      onlinePaymentCanceled: 'Откажано/Неуспешно!',
      onlinePaymentSuccess: 'Успешно.',
      changePaymentMethod: 'Смени начин на плаќање',
      refreshIn: 'Освежи за',
      identifierCode: 'Идентификациски код',
      writeDescription: 'Напиши коментар',
      apiCode: 'API код',
      doNotPrint: 'Не печати',
      calculatePrice: 'Пресметај цена',
      actualPrice: 'Реална цена',
      newPrice: 'Нова цена',
      displayInInterval: 'Прикажи во интервал',
      ingredient: 'Состојка',
      day: 'Ден',
      month: 'Месец',
      year: 'Година',
      birthDate: 'Датум на раѓање',
      pin: 'PIN',
      active: 'Активен',
      inactive: 'Неактивен',
      activate: 'Активирај',
      activateDeductions: 'Активирај одбитоци',
      order: 'Ред',
      orders: 'Нарачки',
      theOrder: 'Нарачка',
      orderAndContinue: 'Нарачај + Продолжи',
      information: 'Информации',
      printReceipt: 'Печати сметка',
      printWReceipt: 'Печати без сметка',
      clearOrder: 'Исчисти нарачка',
      clearTable: 'Исчисти маса',
      cancelOrder: 'Откажи нарачка',
      splitOrder: 'Подели нарачка',
      product: 'Производ',
      products: 'Производи',
      productType: 'Тип на производ',
      quantity: 'Количина',
      total: 'Вкупно',
      totalAmount: 'Вкупен износ',
      discount: 'Попуст',
      discounts: 'Попусти',
      price: 'Цена',
      phone: 'Телефон',
      delivery: 'Достава',
      takeAway: 'Поноси',
      inHouse: 'Во објект',
      table: 'Маса',
      tables: 'Маси',
      amount: 'Износ',
      waiter: 'Келнер',
      plan: 'Келнери',
      free: 'Бесплатно',
      open: 'Отворено',
      closed: 'Затворено',
      busy: 'Зафатено',
      status: 'Статус',
      confirmation: 'Потврда',
      currentQuantity: 'Тековна количина',
      previousQuantity: 'Претходна количина',
      difference: 'Разлика',
      lastChange: 'Последна промена',
      date: 'Датум',
      payment: 'Плаќање',
      collect: 'Собери',
      collected: 'Собрано',
      collection: 'Колекција',
      uncollected: 'Несобрано',
      actions: 'Акции',
      client: 'Клиент',
      deliveryClient: 'Клиент за достава',
      chooseEmployee: 'Избери вработен',
      business: 'Бизнис',
      ngo: 'НВО',
      search: 'Пребарај',
      fiscalNumber: 'Фискален број',
      vatNumber: 'ДДВ број',
      businessNumber: 'Бизнис број',
      registrationNumber: 'Регистарски број',
      name: 'Име',
      address: 'Адреса',
      businessAddress: 'Бизнис адреса',
      city: 'Град',
      contactPerson: 'Контакт лице',
      comment: 'Коментар',
      email: 'Е-пошта',
      website: 'Веб страница',
      contact: 'Контакт',
      bank: 'Банка',
      bankAccount: 'Банкарска сметка',
      cash: 'Готовина',
      code: 'Код',
      barcode: 'Баркод',
      card: 'Картичка',
      idCard: 'Лична карта',
      seller: 'Продавач',
      buyer: 'Купувач',
      value: 'Вредност',
      valueWithVat: 'Вредност со ДДВ',
      valueWithoutVat: 'Вредност без ДДВ',
      priceWithVat: 'Цена со ДДВ',
      priceWithoutVat: 'Цена без ДДВ',
      vat: 'ДДВ',
      chooseVat: 'Избери ДДВ',
      forPayment: 'За плаќање',
      submitted: 'Поднесено',
      accept: 'Прифати',
      from: 'Од',
      to: 'До',
      until: 'До',
      fromTable: 'Од маса',
      toTable: 'До маса',
      staff: 'Персонал',
      staffOrder: 'Нарачка на персонал',
      staffPrice: 'Цена за персонал',
      damagedGoods: 'Оштетена стока',
      damagedProduct: 'Оштетен производ',
      reportDamage: 'Пријави штета',
      forFood: 'За храна',
      chooseBank: 'Избери банка',
      chooseBanks: 'Избери банки',
      approveDamage: 'Одобри штета',
      chooseDate: 'Избери датум',
      moneyChange: 'Кусур',
      freeOfCharge: 'Бесплатно',
      goodsReturn: 'Враќање стока',
      return: 'Врати',
      categories: 'Категории',
      category: 'Категорија',
      categoryType: 'Тип на категорија',
      ranking: 'Рангирање',
      autoRanking: 'Автоматско рангирање',
      rankingPrinter: 'Прикажи ранг на сметка',
      choose: 'Избери',
      description: 'Опис',
      employee: 'Вработен',
      user: 'Корисник',
      vendor: 'Добавувач',
      time: 'Време',
      paymentType: 'Начин на плаќање',
      orderType: 'Тип на нарачка',
      invoiceNumber: 'Број на фактура',
      document: 'Документ',
      transfer: 'Трансфер',
      start: 'Почеток',
      end: 'Крај',
      damages: 'Штети',
      expenses: 'Трошоци',
      totalSales: 'Вкупна продажба',
      mostSoldProd: 'Најпродаван производ',
      mostSoldProdQuantity: 'Количина на најпродаваниот производ',
      approvedBy: 'Одобрено од',
      clientName: 'Име на клиент',
      clientCode: 'Код на клиент',
      clientCard: 'Клиентска картичка',
      cardNumber: 'Број на картичка',
      ordersNumber: 'Бр. на нарачки',
      withDetails: 'Со детали',
      clients: 'Клиенти',
      type: 'Тип',
      menuIcon: 'Икона за мени',
      addProduct: 'Додади производ',
      addCategory: 'Додади категорија',
      authorizedPerson: 'Овластено лице',
      beginning: 'Почеток',
      dailySales: 'Дневна продажба',
      handedOver: 'Предадено',
      kitchen: 'Кујна',
      choosePrinter: 'Избери печатач/и',
      printer: 'Печатач',
      bar: 'Бар',
      yes: 'Да',
      no: 'Не',
      color: 'Боја',
      receipt: 'Сметка',
      menu: 'Мени',
      picture: 'Слика',
      chooseCategory: 'Избери категорија',
      internalCode: 'Код',
      unit: 'Единица',
      units: 'Единици',
      stockChange: 'Промена на залихи',
      dynamicAmount: 'Динамичка количина',
      simple: 'Едноставен',
      compound: 'Составен',
      combo: 'Комбо',
      comboQuantity: 'Комбо количина',
      productsIngredients: 'Состојки на производ',
      preSelected: 'Претходно избрано',
      preSelectedQuantity: 'Претходно избрана количина',
      dynamic: 'Динамичен',
      recipe: 'Рецепт',
      default: 'Стандардно',
      happyHour: 'Среќен час',
      letter: 'Буква',
      number: 'Број',
      lastMove: 'Последно движење',
      addedRemovedQty: 'Додадена/отстранета количина',
      draft: 'Нацрт',
      finalized: 'Финализирано',
      view: 'Преглед',
      stock: 'Залиха',
      point: 'Точка',
      productAt: 'Производ во ',
      choosePoint: 'Избери точка',
      ip: 'IP',
      rate: 'Стапка',
      country: 'Држава',
      currency: 'Валута',
      uploadLogo: 'Постави лого (макс. 2 MB)',
      general: 'Генерално',
      port: 'Порт',
      other: 'Друго',
      level: 'Ниво',
      createdDate: 'Датум на креирање',
      role: 'Улога',
      personalNumber: 'Личен број',
      dailyFoodLimit: 'Дневен лимит за храна',
      calculateDiscount: 'Пресметај попуст',
      productsPrice: 'Цена на производ',
      priceWithDiscount: 'Цена со попуст',
      paid: 'Платено',
      remaining: 'Останато',
      sum: 'Збир',
      sale: 'Продажба',
      typesOfSales: 'Типови на продажба',
      qtyAndValue: 'Количина и вредност',
      days: 'Денови',
      choosePaymentType: 'Избери тип на плаќање',
      lastCount: 'Последно броење',
      purchaseDate: 'Датум на набавка',
      invoiceDate: 'Датум на фактура',
      stateReason: 'Причина',
      today: 'Денес',
      yesterday: 'Вчера',
      lastSevenDays: 'Последни 7 дена',
      lastThirtyDays: 'Последни 30 дена',
      emails: 'Е-пошти',
      notification: 'Известување',
      programQuantity: 'Програмска количина',
      physicalQuantity: 'Физичка количина',
      differencePurchasePrice: 'Разлика во набавна цена',
      differenceSellPrice: 'Разлика во продажна цена',
      percentage: 'Процент',
      filters: 'Филтри',
      choosePeriod: 'Избери период',
      language: 'Јазик',
      startEnd: 'Почеток/крај',
      pcs: 'парчиња',
      createdBy: 'Креирано од',
      maker: 'Производител',
      addMaker: 'Додади производител',
      makers: 'Производители',
      searchClient: 'Пребарај клиент',
      raportiDitor: 'Дневен извештај',
      advance: 'Аванс',
      doser: 'Дозер',
      canCashOut: 'Може да се порамни',
      waiterAccess: 'Пристап за келнер',
      userAccess: 'Кориснички пристап (не администратор)',
      system: 'Систем',
      configOrder: 'Нарачка',
      othersQuantity: 'Друга количина',
      totalOrders: 'Вкупно нарачки',
      displayOnlyResetProducts: 'Прикажи само производи за ресетирање',
      orderNumber: 'Број на нарачка',
      employeeDeleted: 'Избришано од',
      deletedDate: 'Датум на бришење',
      show: 'Прикажи',
      inhouse: 'Во објект',
      takeaway: 'Поноси',
      fiscal: 'Фискална',
      noFiscal: 'Нефискална',
      noPayment: 'Бесплатно',
      invoice: 'Фактура',
      dailyDiscount: 'Дневен попуст',
      aggregate: 'Агрегат',
      salesman: 'Продавач',
      display: 'Дисплеј',
      chooseDisplay: 'Избери дисплеј/и',
      displayOnlyInTheseDevices: 'Прикажи само нарачки од',
      clientDiscount: 'Попуст за клиент',
      lock: 'Заклучи',
      stockThreshold: 'Праг на залихи',
      service: 'Услуга',
      withTimer: 'Со тајмер',
      cardNumberOrTelephone: 'Број на картичка или телефон',
      priceType: 'Тип на цена',
      priceCalculation: 'Пресметка на цена',
      applyToTables: 'Примени на маси',
      receiptForAllOrders: 'Сметка за сите нарачки',
      parent: 'Родител',
      child: 'Дете',
      twilioFriendlyName: 'Број/Име',
      smsSucces: 'СМС пораката е успешно испратена.',
      SalesOrder: 'Продажна нарачка',
      StockChange: 'Промена на залихи',
      StockReset: 'Ресетирање на залихи',
      VendorPurchase: 'Набавка',
      showProduct: 'Прикажи производ',
      showCategory: 'Прикажи категорија',
      showMaker: 'Прикажи производител',
      showAllTableTotals: 'Прикажи вкупно за сите (маси)',
      regularInvoiceForAllOrders: 'Редовна фактура за сите нарачки',
      totalQuantity: 'Вкупна количина',
      roles: {
        Admin: 'Администратор',
        Waiter: 'Келнер',
        Kamarier: 'Келнер',
        Menaxher: 'Менаџер',
        Depoist: 'Складиште',
        Staf: 'Персонал',
        Salesman: 'Продавач',
        Display: 'Дисплеј'
      },
      approveFreePayment: 'Одобри бесплатна уплата',
      purchasePriceWithoutVat: 'Набавна цена (без ДДВ)',
      vendorName: 'Добавувачи',
      totalWithouVat0: 'Вкупно без ДДВ 0%',
      totalWithoutVat8: 'Вкупно без ДДВ (8%)',
      vatAmount8: 'Износ на ДДВ (8%)',
      totalWithoutVat18: 'Вкупно без ДДВ (18%)',
      vatAmount18: 'Износ на ДДВ (18%)',
      applyToProducts: 'Примени на производи',
      sellPrice: 'Продажна цена',
      margin: 'Маржа',
      deliveryType: 'Тип на достава',
      totalCurrentPrice: 'Вкупна тековна цена',
      configLabels: {
        hideDeliveryTotals: 'Сокриј вкупно на достава',
        printerNameTicket: 'Име на принтер во табели',
        cardPaymentFee: 'Надомест за плаќање со картичка',
        fiscalExtraMessage: 'Фискално: дополнителен текст',
        reservationDuration: 'Времетраење на резервацијата (часови)',
        mobileHideTotal: 'PostomGo: Сокриј вкупно',
        courseSpliters: 'Разделувачи на оброци',
        waiterSelfHandouts: 'Келнер самостојна испорака',
        liveTickerNoActions: 'Во живо тикер: блокирај дејства',
        chooseFiscalThermalPrinter: 'Изберете фискален термален печатач',
        employeeClocktimeProductSales: 'Прикажи продадени производи на испечатен извештај',
        searchClientCards: 'Прикажи "Пребарај" во картичките на клиенти',
        chooseGeneralPrinter: 'Изберете главен печатач',
        duplicatePrinter: 'Дупликат печатач',
        duplicateGeneralPrinter: 'Дуплирајте го главниот печатач',
        chooseFiscalPrinter: 'Изберете фискален печатач',
        chooseInvoicePrinter: 'Печатач за фактури',
        duplicateInvoicePrinter: 'Дуплирајте печатач што ја печати фактурата',
        chooseCashOnPrinter: 'Изберете го печатачот за еквилајзер',
        chooseFinalInvoicePrinter: 'Изберете го печатачот за конечна фактура',
        duplicateFinalInvoicePrinter: 'Повторете го печатачот за конечна фактура',
        finalInvoiceQuantity: 'Број на копии за конечна фактура',
        notRestaurant: 'Нема ресторан/бар',
        allowNegativeStock: 'Дозволете залиха со минус',
        fiscalConfirm: 'Потврда за фискален купон',
        defaultDelivery: 'Потврда за фискален купон',
        manualFreeTable: 'Ослободете ја масата рачно',
        kitchenPrinter: 'Кујна/печатач',
        cardPayment: 'Плаќање со картичка',
        directOrder: 'Директни нарачки',
        showTotalOnNonfiscal: 'Прикажи вкупно на не-фискален печатач',
        orderTotalNonFiscalOptional: '(Опционално) Вкупно на не-фискален фискален купон',
        showCommentsOnNonfiscal: 'Прикажи коментари на не-фискална фактура',
        orderNrOnFiscal: 'Број на нарачка во фискален купон',
        fixedShift: 'Почеток на фиксна смена',
        adminCashShift: 'Почеток на готовинска смена (за администратори)',
        orderToKitchenAfterPayment: 'Испрати нарачка по плаќање',
        returnToTableAfterOrder: 'Врати се на преглед на масата по нарачка',
        logoutAfterOrder: 'Одјави се по нарачка',
        returnToTableAfterPayment: 'Врати се на преглед на масата по уплата',
        logoutAfterPayment: 'Одјави се по уплата',
        managerCashOut: 'Дозволи му на менаџерот да исплати келнери',
        dontIncludeCustomersIdinSale: 'Не вклучувај лична карта на клиентот во продажба',
        approvalDamages: 'Одобрение за штети',
        mobilePos: 'Активирај мобилен ПОС',
        closeAutomatically: 'Затвори автоматски',
        transfers: 'Трансфери',
        approveProgramClose: 'Одобри затворање на програмата',
        codeAndMakers: 'Код и креатор во производи',
        enableMinimize: 'Овозможи минимизирање на апликацијата<br/> <small>(важи за тековниот уред)</small>',
        liveTicker: 'Во живо тикер',
        liveTickerAllOrders: 'Во живо тикер: прикажи само нарачки од келнери',
        liveTickerSalesmanAllOrders: 'Во живо тикер: прикажи само нарачки од продавачи',
        handoutsCalculateCard: 'Пресметај продажба со картичка во испечатени материјали',
        autoStart: 'Автоматско стартување (важи само за овој уред)',
        printQuantityFromLeft: 'Количина лево (печатење)',
        disableOrderComments: 'Оневозможи коментари за нарачки',
        freePaymentConfirm: 'Бесплатно со потврда',
        displays: 'Прикажувачи',
        onlyFiscal: 'Само фискално',
        isService: 'Дали е услуга',
        serviceClient: 'Детско игралиште',
        directOnlyFiscal: 'Директно фискално'
      },
      reportsLabels: {
        salesTypeReport: 'Извештај за тип на продажба',
        businessDayClose: 'Затворање на работен ден'
      },
      weekdays: {
        monday: 'Понеделник',
        tuesday: 'Вторник',
        wednesday: 'Среда',
        thursday: 'Четврток',
        friday: 'Петок',
        saturday: 'Сабота',
        sunday: 'Недела'
      }
    },
    mainMenu: {
      reports: {
        tableTransfers: 'Трансфери',
        name: 'Извештаи',
        sales: 'Продажба',
        productSales: 'Продажба на производи',
        hourlySales: 'Часовна продажба',
        purchases: 'Набавки',
        stockChanges: 'Промени на залихи',
        handovers: 'Предавања',
        waiterRankings: 'Рангирање на келнери',
        delivery: 'Испорака',
        ingredients: 'Состојки',
        damages: 'Штети',
        clients: 'Клиенти',
        startEndSalesDay: 'Почеток/крај на продажен ден',
        categorySales: 'Продажба по категории',
        staff: 'Персонал',
        salesByMaker: 'Продажба по производител',
        deliveryClients: 'Клиенти за испорака',
        productByCompoundItemsSales: 'Продажба по сложени производи',
        salesBook: 'Книга за продажба',
        purchaseBook: 'Книга за набавки',
        regularInvoices: 'Редовни фактури',
        productSalesInterval: 'Интервал на продажба на производи',
        paymentMethods: 'Начини на плаќање',
        vatSales: 'ДДВ продажба',
        purchaseProducts: 'Набавка на производи',
        duePayments: 'Доспеани плаќања',
        returnedProducts: 'Вратени производи',
        reservations: 'Резервации'
      },
      menu: 'Мени',
      categories: 'Категории',
      products: 'Производи',
      priceList: 'Ценовници',
      floorPlan: 'Распоред на маси',
      stock: {
        name: 'Залиха',
        changeStock: 'Промени во залихата',
        stockCutoff: 'Затворање на залихата',
        inventoryLocations: 'Локации на залихи',
        stockThreshold: 'Гранична вредност на залиха',
        transactions: 'Трансакции со производи',
        transactionsPeriod: 'Период на трансакции со производи'
      },
      purchases: 'Купувања',
      config: {
        name: 'Поставки',
        printers: 'Принтери',
        measuringUnits: 'Мерни единици',
        vat: 'ДДВ',
        users: 'Корисници',
        vendors: 'Добавувачи',
        discounts: 'Попусти',
        clients: 'Клиенти',
        accessPoints: 'Пристапни точки',
        makers: 'Производители',
        audit: 'Ревизија',
        license: 'Лиценца',
        displays: 'Прикажувачи',
        invoiceClients: 'Субјекти',
        reservationClients: 'Клиенти за резервации'
      }
    },
    exportFiles: {
      raporti_transfereve_tavolinave: 'table_transfers_report',
      raporti_shitjeve: 'raporti_shitjeve',
      raporti_klientave: 'raporti_klientave',
      raporti_barazimeve: 'raporti_barazimeve',
      raporti_perberesave: 'raporti_perberesave',
      raporti_demtimeve: 'raporti_demtimeve',
      raporti_delivery: 'raporti_delivery',
      raporti_kamarierave: 'raporti_kamarierave',
      raporti_shitjeve_produkt_sipas_ores: 'raporti_shitjeve_produkt_sipas_ores',
      raporti_shitjeve_produkt: 'raporti_shitjeve_produkt',
      raporti_blerjeve: 'raporti_blerjeve',
      raporti_shitjeve_kategorise: 'raporti_shitjeve_kategorise',
      raporti_shitjeve_prodhuesit: 'raporti_shitjeve_prodhuesit',
      raporti_staf: 'raporti_staf',
      raporti_fillimit_mbarimit: 'raporti_fillimit_mbarimit',
      raporti_ndryshimit_stokut: 'raporti_ndryshimit_stokut',
      raporti_stokut: 'raporti_stokut',
      prerja_stokut: 'prerja_stokut',
      product_transactions: 'transakstionet_produktit',
      raporti_faturave_rregullta: 'raporti_faturave_rregullta',
      raporti_shitje_produkt_interval: 'raporti_shitje_produkt_interval',
      lista_produkteve: 'lista_produkteve',
      raporti_shitjeve_produkt_interval_ores: 'product_sales_interval_report',
      raporti_shitjeve_menyres_pageses: 'payment_method_sales_report',
      raporti_shitjeve_tvsh: 'vat_sales_report',
      raporti_blerjeve_produktet: 'purchase_products_report',
      raporti_borxhit: 'due_payments_report',
      raporti_kthimit_mallit: 'returned_products_report',
      raporti_rezervimeve: 'reservations_report',
      raporti_auditimit: 'audit_report'
    },
    licenseMessages: {
      LICENSESUCCESS: 'Лиценцата е успешно активирана.',
      INVALIDSIGNATURE: 'Лиценцата е изменета, не е валидна!',
      INVALIDLICENCETOTHISDEVICE: 'Лиценцата не е валидна за овој уред!',
      INVALIDLICENCE: 'Лиценцата е истечена!',
      LICENCECONVERTERROR: 'Текстот на лиценцата е изменет, лиценцата не е валидна!',
      NOLICENSEFOUND: 'Овој уред не е лиценциран! Ве молиме контактирајте STOM LLC +383 46 333 444!',
      licenseWarning: 'Лиценцата на програмата истекува за |daysLicenseExpire| дена, на датум |expireDate|. ' +
        'Ве молиме реактивирајте ја лиценцата навреме за да продолжите со користење на програмата по датумот на истекување. ' +
        'За реактивација, контактирајте ја STOM ДООЕЛ на +383 49 313 526'
    }
  },
  sr: {
    message: {
      resetDisplayItemConfirm: 'Are you sure you want to change the order status?',
      closeAllOrdersDisplayConfirm: 'Are you sure you want to close all orders? This action cannot be undone.',
      pendingOrders: 'Pending orders',
      noSearchResult: 'No search result.',
      restartMessage: 'Poruka za restart...',
      login: 'Login',
      logout: 'Logout',
      details: 'Detalji',
      transferOrders: 'Prenos narudžbe',
      changeWaiter: 'Promena konobara',
      orderClosed: 'Narudžba zatvorena',
      startOfShift: 'Početak smene',
      endOfShift: 'Kraj smene',
      successfulStartOfShift: 'Uspešan početak smene',
      successfulEndOfShift: 'Uspešan kraj smene.',
      scanQrCode: 'Skeniraj QR kod',
      confirmOrderTransfer: 'Molimo vas potvrdite transfer narudžbe',
      currentWaiter: 'Trenutni konobar',
      newWaiter: 'Novi konobar',
      changeWaiterMsg: 'Vaš zahtev za promenu konobara je poslat.Ako drugi konobar prihvati zahtev, transfer će biti realizovan.',
      orderCloseConfirmation: 'Da li ste sigurni da želite da kompletirate ovu narudžbu?',
      serachSubjectOrFiscal: 'Tražite po subjektu/fiskalnom broju',
      validInvoiceWithoutStamp: 'Ova faktura je validna bez pečata.',
      removeOrderMessage: 'Narudžba se ne može otkazati jer obuhvata produkte.',
      freeTableMessage: 'Sto se ne može osloboditi, jer postoji aktivna narudžba.',
      closeOrderMessage: 'Narudžba je zatvorena. Ne možete da dodate produkte ovoj narudžbi.',
      closeOrderConfirmMessage: 'Da li ste sigurni  da želite da zatvorite narudžbu i da izdate fiskalni kupon?',
      closeOrderConfirmMessageReservation: 'Is the order linked with this reservation?',
      printFiscalConfirm: 'Da li ste sigurni  da želite da izdate fiskalni kupon?',
      noProductMessage: 'Narudžba je prazna. Ne možete odštampati fiskalni kupon.',
      noProductRetailMessage: 'Narudžba je prazna. Ne možete da kompletirate prodaju.',
      chooseTotalDiscount: 'Odaberite ukupno sniženje',
      chooseProdDiscount: 'Odaberite sniženje za produkt',
      scanClientCard: 'Skenirajte karticu klijenta',
      clientNotExist: 'Kartica ne postoji u bazi podataka. Unesite podatke klijenta kako bi je kreirali',
      scanCardToApproveDamage: 'Skenirajte karticu ili unesite PIN kako bi odobrili oštećenje',
      deliveryConfirmMessage: 'Da li ste sigurni da želite da kompletirate narudžbu?',
      splitOrderMessage: 'Ne možete da podelite sve narudžbe. Odaberite samo nekoliko.',
      clientLeft: 'Klijent je otišao.',
      houseCompliments: 'Od kuće',
      waitersMistake: 'Greška konobara',
      finalizeGoodsReturn: 'Da li ste sigurni za želite da finalizirate povratak robe?',
      goodsReturnDifference: 'Razlika od povraćaja robe',
      noApproveAccess: 'Nemate pravo da odobrite!',
      noBarcode: 'ne postoji barkod',
      noCode: 'ne postoji kod',
      notInStock: 'nema na raspolaganju!',
      stockValue: 'Na raspolaganju je samo',
      noAdminPrivileges: 'Nemate privilegije administratora!',
      finalizeCashOut: 'Da li ste sigurni da želite da finalizirati poravnanje?',
      waiterCashedOut: 'Konobar je sproveo poravnanje.',
      approveExit: 'Odobri zatvaranje/minimiziranje programa',
      scanCardToExit: 'Skeniraj karticu ili unesi PIN kako bi odobrio radnju',
      sendReport: 'Dostavi izveštaj',
      emailSent: 'Emajl je uspešno dostavljen!',
      emailFailed: 'Email nije poslat. Molim vas, pokušajte ponovo.',
      invalidEmail: 'Emajl adresa nije validna!',
      sending: 'Šalje se',
      device_mismatch: 'Ista narudžba je otvorena na drugom uređaju.Promene narudžbe su dozvoljene samo na tom uređaju.',
      confirm_admin_changes: 'Svaka promena koju napravite će izbrisati sve promene koje je u međuvremenu uneo konobar. Želite li da nastavite?',
      DOCUMENTISCLOSED_CANNOTFINALIZE: 'Dokument se ne može finalizirati jer je ranije finalizovan!',
      DOCUMENTISCLOSED_CANNOTSAVE: 'Proizvod se ne može sačuvati jer je dokument ranije finaliziran!',
      scanCardToApproveFreePayment: 'Skeniraj karticu ili unesi PIN kako bi odobrio besplatno ',
      productsUpdatedWithVat: 'PDV se primenjuje na sve proizvode',
      tablesUpdatedWithProduct: 'Proizvod je dostavljen na svim stolovima',
      chooseTemplate: 'Odaberite poruku!',
      cannotDeleteItem: 'Proizvod ne može da se izbriše iz narudžbe!',
      serviceClientFormError: 'Telefon, ime deteta i ime roditelja ne mogu ostati prazni!',
      contiueWithService: 'Nastavi sa uslugom?',
      CANNOTCHANGEDOCUMENTLESSLASTSTOCKRESET: 'Nije moguće izbrisati bilo koju promenu u zalihama koja je realizovan pre poslednjeg preseka zaliha!',
      salesAmountChanged: 'Iznos prodaje je u međuvremenu promenjen.',
      menus: {
        productExists: 'Proizvod postoji na meniju.',
        pleaseAddProduct: 'Molimo vas dodajte ovaj proizvod u Meniju.',
        cantBeEmpty: 'Prazan meni ne može da se sačuva.',
        confirmProdRemove: 'Da li ste sigurni da želite da uklonite proizvod?',
        confirmRemove: 'Da li ste sigurni da želite da izbrišite meni?'
      },
      categories: {
        confirmDiscountChanges: 'Sniženje za ove proizvode će biti izbrisano. Želite li da nastavite?',
        confirmRemove: 'Da li ste sigurni da želite da uklonite ovu kategoriju?'
      },
      products: {
        confirmRemove: 'Da li ste sigurni da želite da izbrišete ovaj proizvod?',
        confirmIngredientsRemove: 'Da li da želite da izbrišete sastojke ovog proizvoda',
        addProductIngredients: 'Molimo vas da dodate sastojke proizvodu, lista ne može da ostane prazna.',
        enabledHappyHour: 'Prikaži samo kad je Happy Hour',
        cannotRemoveLastProduct: 'Poslednji sastojak ne može da se izbriše ako se ne doda neki drugi sastojak!',
        productDeleteFailed: 'Proizvod ne može da se izbriše jer se koristi kao sastojak u dole navedenim proizvodima:'
      },
      tablePlan: {
        confirmRemove: 'Da li ste sigurni da želite da izbrišete plan?',
        successUpdate: 'Plan je uspešno ažuriran!'
      },
      stock: {
        confirmRemove: 'Da li ste sigurni da želite da izbrišete promene u zalihama?',
        confirmProdRemove: 'Da li ste sigurni da želite da uklonite proizvod?',
        finalizePurchase: 'Da li želite da finalizirate kupovinu?',
        confirmStockReset: 'Da li želite da finalizirate presek u zalihama? Podaci nakon toga ne mogu da se promene!'
      },
      points: {
        confirmRemove: 'Da li ste sigurni da želite da izbrišete ovu tačku?'
      },
      purchases: {
        confirmRemove: 'Da li ste sigurni da želite da izbrišete kupovinu?',
        finalizePurchase: 'Želite li da finalizirate kupovinu?'
      },
      printers: {
        confirmRemove: 'Da li ste sigurni da želite da izbrišete printer?',
        printingError: 'Narudžba nije odštampana! Molimo vas da proverite da li je printer uključen i povezan sa kompjuterom. Ako i dalje ne radi, kontaktirajte osobu odgovornu za printer kao i tehničara.'
      },
      units: {
        confirmRemove: 'Da li ste sigurni da želite da izbrišete jedinicu?'
      },
      vats: {
        confirmRemove: 'Da li ste sigurni da želite da izbrišete poresku normu?',
        vatRateExist: 'Ova PDV stopa postoji'
      },
      users: {
        cannotChangeAdminRole: 'Ne možete da promenite ulogu administratora!',
        notAdminUser: 'Nemate privilegije administratora da izbrišete ovog korisnika!',
        confirmRemove: 'Da li ste sigurni da želite da izbrišete korisnika?',
        nameNotNull: 'Ime ne sme da ostane prazno!',
        pinNotNull: 'PIN ne sme da ostane prazan!',
        roleNotNull: 'Uloga ne sme da ostane prazna!',
        personalNumberNotNull: 'Lični broj ne može da ostane prazan!',
        emailNotNull: 'Emajl ne sme da ostane prazan!',
        setStaffLimit: 'Navedite limit za hranu za korisnika!'
      },
      vendors: {
        confirmRemove: 'Da li ste sigurni da želite da izbrišete snabdevača?'
      },
      config: {
        changeApplied: 'Promena je sprovedena. Ponovo se uključite kako bi videli promenu. Hvala vam',
        bankInfoMandatory: 'Banka i bankovni račun treba da budu popunjeni!',
        chooseOperatingCountry: 'Treba da odabere državu gde ste funkcionalni!'
      },
      vouchers: {
        confirmRemove: 'Da li ste sigurni da želite da izbrišete sniženje?'
      },
      clients: {
        confirmRemove: 'Da li ste sigurni da želite da izbrišete klijenta?'
      },
      validations: {
        cannotBeEmpty: 'Ne sme da ostane prazno!',
        notNullLettersAndNumbers: 'Ne sme da ostane prazno i treba da sadrži samo brojeve i slova.',
        validNameAndFiscalNumber: 'Ime i fiskalni broj ne mogu da ostanu prazni!',
        validProductNameAndTotal: 'Naziv proizvoda i Ukupno ne mogu da ostanu prazni!',
        cannotBeNegativeValue: 'Ne može da stoji negativna vrednost.',
        nameCannotBeEmpty: 'Ime ne može da ostane prazno!',
        doserCannotBeNegativeValue: 'Dozer treba da bude veći od nule ili prazan!'
      },
      expenses: {
        confirmCloseAndRemove: 'Da li ste sigurni da želite da zatvorite ovu stranicu? Svi troškovi koji nisu sačuvani će biti izbrisani!'
      }
    },
    buttons: {
      splitCourse: 'Split course',
      fiscalCopy: 'Fiscal copy',
      groupedOrders: 'Grouped orders',
      changePayment: 'Change payment',
      continueWithoutCoupon: 'Nastavi bez kupona',
      continueWithCoupon: 'Nastavi sa kuponima',
      save: 'Sačuvaj',
      saveDraft: 'Sačuvaj nacrt',
      cancel: 'Poništi',
      continue: 'Nastavi',
      close: 'Zatvori',
      print: 'Odštampaj',
      split: 'Podeli',
      goBack: 'Vrati se',
      finalize: 'Finaliziraj',
      fiscal: 'Fiskalno',
      notFiscal: 'Ne fiskalno',
      finish: 'Završi',
      finishOptionalPrintTotal: 'Finish with receipt',
      qrCode: 'QR kod',
      invoice: 'Račun',
      filterDates: 'Filtriraj datume',
      generateReport: 'Pripremi izveštaj',
      add: 'Dodaj',
      addExpenses: 'Dodaj troškove',
      cashOut: 'Poravnaj',
      send: 'Pošalji',
      email: 'Emajl',
      refresh: 'Ažuriraj',
      tryAgain: 'Pokušaj ponovo',
      refuse: 'Odbi',
      changeClient: 'Promeni klijenta',
      menus: {
        addMenu: 'Dodaj meni',
        deleteMenu: 'Izbriši meni',
        deletePriceList: 'Delete price list',
        addAllProducts: 'Add all products',
        addPriceList: 'Add price list'
      },
      categories: {
        addCategory: 'Dodaj kategoriju'
      },
      products: {
        addProduct: 'Dodaj proizvod',
        export: 'Prenesi'
      },
      tablePlan: {
        addPlan: 'Dodaj plan',
        addTable: 'Dodaj sto',
        deleteTable: 'Izbriši sto',
        addMultipleTables: 'Add multiple'
      },
      stock: {
        addProduct: 'Dodaj proizvod'
      },
      points: {
        addPoint: 'Dodaj tačku',
        pointName: 'Naziv tačke'
      },
      printers: {
        addPrinter: 'Dodaj printer',
        printerName: 'Naziv printera',
        printerPort: 'Portal printera',
        printerType: 'Vrsta printera',
        fiscalPrinterType: 'Vrsta fiskalnog printera',
        letterDimensions: 'Dimenzija papira',
        dynamicPath: 'Dinamički put'
      },
      units: {
        addUnit: 'Dodaj jedinicu'
      },
      vats: {
        addVat: 'Dodaj PDV',
        vatRate: 'PDV stopa'
      },
      users: {
        addUser: 'Dodaj korisnika'
      },
      vendors: {
        addVendor: 'Dodaj nabavljača',
        vendorName: 'Naziv nabavljača',
        chooseVendor: 'Odaberi nabavljača'
      },
      locations: {
        addLocation: 'Dodaj lokaciju'
      },
      clients: {
        addClient: 'Dodaj klijenta'
      },
      happyHours: {
        addHappyHour: 'Dodaj Happy Hour'
      },
      makers: {
        addMaker: 'Dodaj proizvođača',
        makerName: 'Naziv proizvođača',
        chooseMaker: 'Odaberi proizvođača'
      },
      displays: {
        addDisplay: 'Dodaj ekran',
        displayName: 'Ime'
      }
    },
    labels: {
      receivedBy: 'Received by',
      outgoingDocument: 'Outgoing document',
      displayControllerPermission: 'Display controller',
      advancedConfiguration: 'Advanced configuration',
      productConfigurationType: 'Product configuration type',
      reason: 'Reason',
      required: 'This field is required',
      freePaymentWithFiscal: 'Free payment with fiscal',
      changePaymentMethodAllOrders: 'Change payment for all orders',
      liveTickerAllOrders: 'Live ticker: all orders',
      currencyExchange: 'Currency exchange',
      excludedVat: 'Excluded from VAT',
      excludedVatCode: 'Excluded from VAT code',
      finished: 'Završeno',
      showAll: 'Show all',
      expense: 'Expense',
      freeTables: ' OPEN',
      reservationsArriving: 'In 30 min',
      reservationClientPriority: 'Client with priority',
      additionalInfo: 'Additional info',
      tablesWithoutReservations: 'Free tables',
      changeReservationStatus: 'Change reservation status',
      reservationStatusUpdateFailed: 'Failed to update reservation status!',
      reservationDeleteConfirmation: 'Are you sure you want to delete the reservation?',
      showed: 'Showed',
      notShowed: 'Did not show',
      clientAdditionalInfo: 'Client additional info',
      newReservation: 'New reservation',
      numberPersons: 'Number of persons',
      reservations: 'Reservations',
      totalWithoutDiscount: 'Total before discount',
      serviceFee: 'Service fee',
      serviceFeeType: 'Service fee type',
      serviceFeeAutomatic: 'Service fee automatic',
      courseSpliter: 'Split course',
      employeeTip: 'Tip',
      deleteOrderPermission: 'Delete order permission',
      orderDeleteConfirmation: 'Da li ste sigurni da želite da izbrišete narudžbu?',
      delete: 'Izbriši',
      avgPrice: 'Prosečna cena',
      sellPriceWithVAt: 'Selling price (with VAT)',
      totalSellPriceWithVAt: 'Total selling price',
      clearCreateNew: 'Clear / Create new client',
      duePayment: 'Due payment',
      loanPermission: 'Due payments permission',
      minDate: 'Start date',
      maxDate: 'End date',
      numberOfOrders: 'Number of orders',
      selectedToPay: 'To pay',
      paidProducts: 'Partial payments',
      ordersCount: 'No. of orders',
      onlinePaymentProcessing: 'Processing ...',
      onlinePaymentCanceled: 'Canceled/Failed!',
      onlinePaymentSuccess: 'Success.',
      changePaymentMethod: 'Change payment',
      refreshIn: 'Refresh in',
      identifierCode: 'Identifier code',
      writeDescription: 'Unesite opis',
      apiCode: 'API code',
      doNotPrint: 'Do not print',
      calculatePrice: 'Calculate price',
      actualPrice: 'Actual price',
      newPrice: 'New price',
      displayInInterval: 'Display in interval',
      ingredient: 'Ingredient',
      day: 'Day',
      month: 'Month',
      year: 'Year',
      birthDate: 'Date of birth',
      pin: 'PIN',
      active: 'Aktivan',
      inactive: 'Neaktivan',
      activate: 'Aktiviraj',
      activateDeductions: 'Aktiviraj sniženja',
      order: 'Naruči',
      orders: 'Narudžbe',
      theOrder: 'Narudžba',
      orderAndContinue: 'Naruči + Nastavi',
      information: 'Informacija',
      printReceipt: 'Odštampaj fiskalni',
      printWReceipt: 'Odštampaj onaj koji nije fiskalni',
      clearOrder: 'Izbriši narudžbu',
      clearTable: 'Oslobodi sto',
      cancelOrder: 'Otkaži narudžbu',
      splitOrder: 'Podeli narudžbu',
      product: 'Proizvod',
      products: 'Proizvodi',
      productType: 'Vrsta proizvoda',
      quantity: 'Količina',
      total: 'Ukupno',
      totalAmount: 'Ukupan iznos',
      discount: 'Sniženje',
      discounts: 'Sniženja',
      price: 'Cena',
      phone: 'Telefon',
      delivery: 'Dostava',
      takeAway: 'Za poneti',
      inHouse: 'Ovde',
      table: 'Sto',
      tables: 'Stolovi',
      amount: 'Iznos',
      waiter: 'Konobar',
      plan: 'Plan',
      free: 'Slobodno',
      open: 'Otvoreno',
      closed: 'Zatvoreno',
      busy: 'Zauzeto',
      status: 'Status',
      confirmation: 'Konfirmacija',
      currentQuantity: 'Trenutna količina',
      previousQuantity: 'Prethodna količina',
      difference: 'Razlika',
      lastChange: 'Poslednja promena',
      date: 'Datum',
      payment: 'Isplata',
      collect: 'Inkasiraj',
      collected: 'Inkasirano',
      collection: 'Inkasiraj',
      uncollected: 'Nije naplaćeno',
      actions: 'Radnje',
      client: 'Klijent',
      deliveryClient: 'Klijent za dostavu',
      chooseEmployee: 'Odaberi zaposlenika',
      business: 'Biznis',
      ngo: 'NVO',
      search: 'Traži',
      fiscalNumber: 'Fiskalni broj',
      vatNumber: 'Broj PDV-a',
      businessNumber: 'Broj biznisa',
      registrationNumber: 'Registracioni broj',
      name: 'Ime',
      address: 'Adresa',
      businessAddress: 'Adresa biznisa',
      city: 'Grad',
      contactPerson: 'Kontakt osoba',
      comment: 'Komentar',
      email: 'Emajl',
      website: 'Internet stranica',
      contact: 'Kontakt',
      bank: 'Banka',
      bankAccount: 'Bankovni račun',
      cash: 'Keš',
      code: 'Kod',
      barcode: 'Barkod',
      card: 'Kartica',
      idCard: 'ID kartica',
      seller: 'Prodavac',
      buyer: 'Kupac',
      value: 'Vrednost',
      valueWithVat: 'Vrednost sa PDV-om',
      valueWithoutVat: 'Vrednost be PDV-a',
      priceWithVat: 'Cena sa PDV-om',
      priceWithoutVat: 'Cena bez PDV-a',
      vat: 'PDV',
      chooseVat: 'Odaberi PDV',
      forPayment: 'Za naplatu',
      submitted: 'Predato',
      accept: 'Prihvaćeno',
      from: 'Od',
      to: 'Za',
      until: 'Do',
      fromTable: 'Od stola',
      toTable: 'Za sto',
      staff: 'Osoblje',
      staffOrder: 'Narudžba za osoblje',
      staffPrice: 'Cena za osoblje',
      damagedGoods: 'Oštećenje robe',
      damagedProduct: 'Oštećeni proizvod',
      reportDamage: 'Prijavi oštećenje',
      forFood: 'Za hranu',
      chooseBank: 'Odaberi banku',
      chooseBanks: 'Odaberi banke',
      approveDamage: 'Odobri oštećenje',
      chooseDate: 'Odaberi datum',
      moneyChange: 'Kusur',
      freeOfCharge: 'Besplatno',
      goodsReturn: 'Povraćaj robe',
      return: 'Vrati',
      categories: 'Kategorije',
      category: 'Kategorija',
      categoryType: 'Vrsta kategorije',
      ranking: 'Redosled',
      autoRanking: 'Automatski redosled',
      rankingPrinter: 'Redosled printera',
      choose: 'Odaberi',
      description: 'Opis',
      employee: 'Zaposlenik',
      user: 'Korisnik',
      vendor: 'Nabavljač',
      time: 'Vreme',
      paymentType: 'Vrsta isplate',
      orderType: 'Vrsta narudžbe',
      invoiceNumber: 'Broj računa',
      document: 'Dokument',
      transfer: 'Transfer',
      start: 'Početak',
      end: 'Kraj',
      damages: 'Oštećenja',
      expenses: 'Troškovi',
      totalSales: 'Ukupno prodaja',
      mostSoldProd: 'Najprodavaniji proizvod',
      mostSoldProdQuantity: 'Količina najprodavanijeg proizvoda',
      approvedBy: 'Odobreno od',
      clientName: 'Ime klijenta',
      clientCode: 'Kod klijenta',
      clientCard: 'Kartica klijenta',
      cardNumber: 'Broj kartice',
      ordersNumber: 'Broj narudžbi',
      withDetails: 'Sa detaljima',
      clients: 'Klijenti',
      type: 'Vrsta',
      menuIcon: 'Ikona menija',
      addProduct: 'Dodaj proizvod',
      addCategory: 'Dodaj katwgoriju',
      authorizedPerson: 'Ovlašćeno lice',
      beginning: 'Start',
      dailySales: 'Dnevna prodaja',
      handedOver: 'Predato',
      kitchen: 'Kuhinja',
      choosePrinter: 'Odaberi printer',
      printer: 'Printer',
      bar: 'Šank',
      yes: 'Da',
      no: 'Ne',
      color: 'Boja',
      receipt: 'nefiskalni kupon',
      menu: 'Meni',
      picture: 'Fotografija',
      chooseCategory: 'Odaberi kategoriju',
      internalCode: 'Kod',
      unit: 'Jedinica',
      units: 'Jedinice',
      stockChange: 'Promena u zalihama',
      dynamicAmount: 'Dinamička količina',
      simple: 'Jednostavno',
      compound: 'Kombinovano',
      combo: 'Kombo',
      comboQuantity: 'Kombo količina',
      productsIngredients: 'Sastojci proizvoda',
      preSelected: 'Pre-odabrano',
      preSelectedQuantity: 'Količina pre-odabranog',
      dynamic: 'Dinamično',
      recipe: 'Recept',
      default: 'Predodređeno',
      happyHour: 'Happy Hour',
      letter: 'Slovo',
      number: 'Broj',
      lastMove: 'Poslednji pokret',
      addedRemovedQty: 'Dodata/smanjena količina',
      draft: 'nacrt',
      finalized: 'Finalizovano',
      view: 'Pogledaj',
      stock: 'Zaliha',
      point: 'Tačka',
      productAt: 'Proizvod na',
      choosePoint: 'Odaberi tačku',
      ip: 'IP',
      rate: 'Stopa',
      country: 'Država',
      currency: 'Valuta',
      uploadLogo: 'Preuzmi logo (maksimalno 2MB)',
      general: 'Opšte',
      port: 'Portal',
      other: 'Ostalo',
      level: 'Nivo',
      createdDate: 'Datum kreiranja',
      role: 'Uloga',
      personalNumber: 'Lični broj',
      dailyFoodLimit: 'Dnevni limit za hranu',
      calculateDiscount: 'Obračunaj sniženje',
      productsPrice: 'Cena proizvoda',
      priceWithDiscount: 'Cena sa sniženjem',
      paid: 'Plaćeno',
      remaining: 'Ostalo',
      sum: 'Iznos',
      sale: 'Prodaja',
      typesOfSales: 'Vrste prodaje',
      qtyAndValue: 'Količina i vrednost',
      days: 'Dani',
      choosePaymentType: 'Odaberi vrstu plaćanja',
      lastCount: 'Poslednji obračun',
      purchaseDate: 'Datum kupovine',
      invoiceDate: 'Datum računa',
      stateReason: 'Navedi razlog',
      today: 'Danas',
      yesterday: 'Juče',
      lastSevenDays: '7 poslednjih dana',
      lastThirtyDays: '30 poslednjih dana',
      emails: 'Emajl adrese',
      notification: 'Obaveštenje',
      programQuantity: 'Količina programa',
      physicalQuantity: 'Fizička količina',
      differencePurchasePrice: 'Razlika od kupovne cene',
      differenceSellPrice: 'Razlika od prodajne cene',
      percentage: 'Procenat',
      filters: 'Filteri',
      choosePeriod: 'Odaberi period',
      language: 'Jezik',
      startEnd: 'Start/Kraj',
      pcs: 'Komad',
      createdBy: 'Kreirano od',
      maker: 'Proizvođač',
      addMaker: 'Dodaj na osnovu proizvođača',
      makers: 'Proizvođači',
      searchClient: 'Traži klijenta',
      raportiDitor: 'Dnevni izveštaj',
      advance: 'Avans',
      doser: 'Dozer',
      canCashOut: 'Poravnanje/saldo',
      waiterAccess: 'Pristup konobara',
      userAccess: 'Pristup korisnika (ne Admin)',
      system: 'Sistem',
      configOrder: 'Narudžba',
      othersQuantity: 'Ostala količina',
      totalOrders: 'Broj narudžbi',
      displayOnlyResetProducts: 'Prikaži samo izbrojene proizvode',
      orderNumber: 'Broj narudžbe',
      employeeDeleted: 'Izbrisani zaposlenik',
      deletedDate: 'Datum brisanja',
      show: 'Prikaži',
      inhouse: 'Ovde',
      takeaway: 'Za poneti',
      fiscal: 'Fiskalni',
      noFiscal: 'Nefiskalni',
      noPayment: 'Besplatno',
      invoice: 'Račun',
      dailyDiscount: 'Dnevno sniženje',
      aggregate: 'Ukupno',
      salesman: 'Prodavac',
      display: 'Ekran',
      chooseDisplay: 'Odaberi ekran/ekrane',
      displayOnlyInTheseDevices: 'Display in this device ([0]) orders only from',
      clientDiscount: 'Sniženje',
      lock: 'Blokiraj',
      stockThreshold: 'Limit zaliha',
      service: 'Usluga',
      withTimer: 'Sa satnicom',
      cardNumberOrTelephone: 'Broj kartice ili telefona',
      priceType: 'Vrsta cene',
      priceCalculation: 'Obračun cene',
      applyToTables: 'Primeni za stolove',
      receiptForAllOrders: 'Račun za sve narudžbe',
      parent: 'Roditelj',
      child: 'Dete',
      twilioFriendlyName: 'Broj/Ime',
      smsSucces: 'SMS je uspešno dostavljen.',
      SalesOrder: 'Prodaja',
      StockChange: 'Promena zalihe',
      StockReset: 'Presek zaliha',
      VendorPurchase: 'Kupovina',
      showProduct: 'Prikaži proizvod',
      showCategory: 'Prikaži kategoriju',
      showMaker: 'Prikaži proizvođača',
      showAllTableTotals: 'Prikaži ukupno za sve (stolovi)',
      regularInvoiceForAllOrders: 'Redovni račun za sve narudžbe',
      totalQuantity: 'Total quantity',
      roles: {
        Admin: 'Administrator',
        Waiter: 'Konobar',
        Kamarier: 'Konobar',
        Menaxher: 'Menadžer',
        Depoist: 'Magacioner',
        Staf: 'Osoblje',
        Salesman: 'Prodavac',
        Display: 'Ekran'
      },
      approveFreePayment: 'Odobri besplatno',
      purchasePriceWithoutVat: 'Cena kupovine (bez PDV-a)',
      vendorName: 'Nabavljač',
      totalWithouVat0: 'Ukupno bez PDV-a 0%',
      totalWithoutVat8: 'Ukupno bez PDV-om (8%)',
      vatAmount8: 'Vrednost PDV-a (8%)',
      totalWithoutVat18: 'Ukupno bez PDV-a (18%)',
      vatAmount18: 'Vrednost PDV-a (18%)',
      applyToProducts: 'Primeni za proizvode',
      sellPrice: 'Sell price',
      margin: 'Margin',
      deliveryType: 'Delivery type',
      totalCurrentPrice: 'Total current price',
      configLabels: {
        hideDeliveryTotals: 'Hide delivery totals',
        printerNameTicket: 'Printer name in tickets',
        cardPaymentFee: 'Card payment fee',
        fiscalExtraMessage: 'Fiscal: extra text',
        reservationDuration: 'Reservation duration (hour)',
        mobileHideTotal: 'PostomGo: Hide total',
        courseSpliters: 'Course spliters',
        waiterSelfHandouts: 'Waiter self handout',
        liveTickerNoActions: 'Live ticker: block actions',
        chooseFiscalThermalPrinter: 'Choose fiscal thermal printer',
        employeeClocktimeProductSales: 'Display sold products on handouts print',
        searchClientCards: 'Show "Search" in clients card',
        chooseGeneralPrinter: 'Odaberi osnovni printer',
        duplicatePrinter: 'Dupliraj printer',
        duplicateGeneralPrinter: 'Dupliraj osnovni printer',
        chooseFiscalPrinter: 'Odaberi fiskalni printer',
        chooseInvoicePrinter: 'Odaberi printer za redovni račun',
        duplicateInvoicePrinter: 'Dupliraj printer za redovni račun',
        chooseCashOnPrinter: 'Odaberi printer za poravnanje/saldo',
        chooseFinalInvoicePrinter: 'Odaberi printer za završni račun',
        duplicateFinalInvoicePrinter: 'Dupliraj printer za završni račun',
        finalInvoiceQuantity: 'Broj kopija za završni račun',
        notRestaurant: 'Nije restoran/bar',
        allowNegativeStock: 'Dozvoli zalihu sa minusom',
        fiscalConfirm: 'Potvrdi za fiskalni kupon',
        defaultDelivery: 'Dostava narudžbe by default',
        manualFreeTable: 'Ručno oslobodi sto',
        kitchenPrinter: 'Kuhinja/Printer',
        cardPayment: 'Plaćanje karticom',
        directOrder: 'Direktna narudžba',
        showTotalOnNonfiscal: 'Prikazi ukupno na nefiskalnom printeru',
        orderTotalNonFiscalOptional: '(Optional) Non-fiscal receipt total',
        showCommentsOnNonfiscal: 'Prikazi komentare na nefiskalnom računu',
        orderNrOnFiscal: 'Broj narudžbi na fiskalnom kuponu',
        fixedShift: 'Početak fiksne smene',
        adminCashShift: 'Administrator da krene sa prvom smenom',
        orderToKitchenAfterPayment: 'Odštampaj narudžbu u kuhinji samo posle naplate',
        returnToTableAfterOrder: 'Vrati na sto nakon narudžbe',
        logoutAfterOrder: 'Logout nakon narudžbe',
        returnToTableAfterPayment: 'Vrati na stolove nakon naplate',
        logoutAfterPayment: 'Logout nakon naplate',
        managerCashOut: 'Menadžer može da uradi poravnanje sa konobarima',
        dontIncludeCustomersIdinSale: 'Nemoj obračunati u saldo sa kartice klijenta',
        approvalDamages: 'Oštećenja sa odobrenjem',
        mobilePos: 'Mobilni POS',
        closeAutomatically: 'Automatski zatvori',
        transfers: 'Transferi',
        approveProgramClose: 'Zatvori program samo sa konfirmacijom',
        codeAndMakers: 'Kod i proizvođač za proizvod',
        enableMinimize: 'Aktiviraj minimiziranje programa<br/> <small>(vredi za trenutni uređaj)</small>',
        liveTicker: 'Live ticker',
        liveTickerAllOrders: 'Live ticker: prikaži samo narudžbe konobara',
        liveTickerSalesmanAllOrders: 'Live ticker: prikaži samo narudžbe prodavca',
        handoutsCalculateCard: 'Obračunaj prodaju sa bankom u poravnanje',
        autoStart: 'Auto start (vredi samo za ovaj uređaj)',
        printQuantityFromLeft: 'Količina na levoj strani (odštampaj)',
        disableOrderComments: 'Deaktiviraj komentare u narudžbi',
        freePaymentConfirm: 'Potvrda za besplatno',
        displays: 'Ekrani',
        onlyFiscal: 'Samo fiskalni',
        isService: 'Je usluga',
        serviceClient: 'Igre za decu',
        directOnlyFiscal: 'Direct fiscal'
      },
      reportsLabels: {
        salesTypeReport: 'Izveštaj o vrsti prodaje',
        businessDayClose: 'Prema zatvaranju dana'
      },
      weekdays: {
        monday: 'Ponedeljak',
        tuesday: 'Utorak',
        wednesday: 'Sreda',
        thursday: 'Četvrtak',
        friday: 'Petak',
        saturday: 'Subota',
        sunday: 'Nedelja'
      }
    },
    mainMenu: {
      reports: {
        tableTransfers: 'Transfers',
        name: 'Izveštaji',
        sales: 'Prodaje',
        productSales: 'Prodaja proizvoda',
        hourlySales: 'Prodaja po satima',
        purchases: 'Kupovine',
        stockChanges: 'Promene u zalihama',
        handovers: 'Poravnanje/saldo',
        waiterRankings: 'Rangiranje konobara',
        delivery: 'Dostava',
        ingredients: 'Sastojci',
        damages: 'Oštećenja',
        clients: 'Klijenti',
        startEndSalesDay: 'Početak/Kraj',
        categorySales: 'Prodaja prema kategorijama',
        staff: 'Osoblje',
        salesByMaker: 'Prodaja prema proizvođačima',
        deliveryClients: 'Klijenti za dostavu',
        productByCompoundItemsSales: 'Prodaja prema dodacima',
        salesBook: 'Knjiga prodaje',
        purchaseBook: 'Knjiga nabavke',
        regularInvoices: 'Redovni računi',
        productSalesInterval: 'Prodaja proizvoda po intervalima',
        duePayments: 'Dugovanja',
        paymentMethods: 'Vrste plaćanja',
        vatSales: 'PDV prodaje',
        purchaseProducts: 'Nabavka proizvoda',
        returnedProducts: 'Returned products',
        reservations: 'Reservations'
      },
      menu: 'Meni',
      categories: 'Kategorije',
      products: 'Proizvodi',
      priceList: 'Price lists',
      floorPlan: 'Plan stolova',
      stock: {
        name: 'Zalihe',
        changeStock: 'Promeni zalihe',
        stockCutoff: 'Presek zaliha',
        inventoryLocations: 'Lokacije',
        stockThreshold: 'Limit zaliha',
        transactions: 'Transakcije proizvoda',
        transactionsPeriod: 'Product transactions period'
      },
      purchases: 'Nabavka',
      config: {
        name: 'Konfiguracija',
        printers: 'Printeri',
        measuringUnits: 'Jedinice',
        vat: 'PDV',
        users: 'Korisnici',
        vendors: 'Nabavljači',
        discounts: 'Sniženja',
        clients: 'Klijenti',
        accessPoints: 'Lokacije',
        makers: 'Proizvođači',
        audit: 'Revizija',
        license: 'Licence',
        displays: 'Ekrani',
        invoiceClients: 'Subjects',
        reservationClients: 'Reservation clients'
      }
    },
    exportFiles: {
      raporti_transfereve_tavolinave: 'table_transfers_report',
      raporti_shitjeve: 'izveštaj o prodaji',
      raporti_klientave: 'izveštaj_klijenti',
      raporti_barazimeve: 'izveštaj_balans',
      raporti_perberesave: 'izveštaj_sastojci',
      raporti_demtimeve: 'izveštaj oštećenja',
      raporti_delivery: 'izveštaj_dostava',
      raporti_kamarierave: 'izveštaj_konobari',
      raporti_shitjeve_produkt_sipas_ores: 'izveštaj_prodaja_proizvodi_prema_satnici',
      raporti_shitjeve_produkt: 'izveštaj_prodaja_proizvod',
      raporti_blerjeve: 'izveštaj _nabavka',
      raporti_shitjeve_kategorise: 'izveštaj_prodaja_kategorije',
      raporti_shitjeve_prodhuesit: 'izveštaj _prodaja_ proizvođači',
      raporti_staf: 'izveštaj _osoblje',
      raporti_fillimit_mbarimit: 'izveštaj _o početku _ o kraju',
      raporti_ndryshimit_stokut: 'izveštaj _ promena_ u zalihama',
      raporti_stokut: 'izveštaj _zalihe',
      prerja_stokut: 'presek _zaliha',
      product_transactions: 'transakcije _proizvoda',
      raporti_faturave_rregullta: 'izveštaj _redovnih  _računa',
      raporti_shitje_produkt_interval: 'izveštaj _prodaja _proizvoda _u intervalima',
      lista_produkteve: 'lista _proizvoda',
      raporti_shitjeve_produkt_interval_ores: 'product_sales_interval_report',
      raporti_shitjeve_menyres_pageses: 'payment_method_sales_report',
      raporti_shitjeve_tvsh: 'vat_sales_report',
      raporti_blerjeve_produktet: 'purchase_products_report',
      raporti_borxhit: 'due_payments_report',
      raporti_kthimit_mallit: 'returned_products_report',
      raporti_rezervimeve: 'reservations_report',
      raporti_auditimit: 'audit_report'
    },
    licenseMessages: {
      LICENSESUCCESS: 'Licenca je uspešno aktivirana.',
      INVALIDSIGNATURE: 'Licenca je promenjena, više nije validna!',
      INVALIDLICENCETOTHISDEVICE: 'Licenca nije validna za ovaj uređaj',
      INVALIDLICENCE: 'Licenca je istekla!',
      LICENCECONVERTERROR: 'Tekst licence je promenjen, licenca nije validna!',
      NOLICENSEFOUND: 'Ovaj uređaj nije licenciran! Molimo vas kontaktirajte STOM LLC +383 46 333 444!',
      licenseWarning: 'Licenca za ovaj program ističe za |daysLicenseExpire| dana, od datuma |expireDate|. ' +
        'Molimo vas da ponovno aktivirate licencu na vreme, kako bi mogli da nastavite upotrebu programa nakon isteka datuma za korišćenje ove licence. ' +
        'Za ponovno aktiviranje, molimo vas kontaktirajte STOM shpk na broj telefona +383 49 313 526'
    }
  },
  gr: {
    message: {
      resetDisplayItemConfirm: 'Are you sure you want to change the order status?',
      closeAllOrdersDisplayConfirm: 'Are you sure you want to close all orders? This action cannot be undone.',
      pendingOrders: 'Pending orders',
      noSearchResult: 'No search result.',
      restartMessage: 'Poruka za restart...',
      login: 'Login',
      logout: 'Logout',
      details: 'Detalji',
      transferOrders: 'Prenos narudžbe',
      changeWaiter: 'Promena konobara',
      orderClosed: 'Narudžba zatvorena',
      startOfShift: 'Početak smene',
      endOfShift: 'Kraj smene',
      successfulStartOfShift: 'Uspešan početak smene',
      successfulEndOfShift: 'Uspešan kraj smene.',
      scanQrCode: 'Skeniraj QR kod',
      confirmOrderTransfer: 'Molimo vas potvrdite transfer narudžbe',
      currentWaiter: 'Trenutni konobar',
      newWaiter: 'Novi konobar',
      changeWaiterMsg: 'Vaš zahtev za promenu konobara je poslat.Ako drugi konobar prihvati zahtev, transfer će biti realizovan.',
      orderCloseConfirmation: 'Da li ste sigurni da želite da kompletirate ovu narudžbu?',
      serachSubjectOrFiscal: 'Tražite po subjektu/fiskalnom broju',
      validInvoiceWithoutStamp: 'Ova faktura je validna bez pečata.',
      removeOrderMessage: 'Narudžba se ne može otkazati jer obuhvata produkte.',
      freeTableMessage: 'Sto se ne može osloboditi, jer postoji aktivna narudžba.',
      closeOrderMessage: 'Narudžba je zatvorena. Ne možete da dodate produkte ovoj narudžbi.',
      closeOrderConfirmMessage: 'Da li ste sigurni  da želite da zatvorite narudžbu i da izdate fiskalni kupon?',
      closeOrderConfirmMessageReservation: 'Is the order linked with this reservation?',
      printFiscalConfirm: 'Da li ste sigurni  da želite da izdate fiskalni kupon?',
      noProductMessage: 'Narudžba je prazna. Ne možete odštampati fiskalni kupon.',
      noProductRetailMessage: 'Narudžba je prazna. Ne možete da kompletirate prodaju.',
      chooseTotalDiscount: 'Odaberite ukupno sniženje',
      chooseProdDiscount: 'Odaberite sniženje za produkt',
      scanClientCard: 'Skenirajte karticu klijenta',
      clientNotExist: 'Kartica ne postoji u bazi podataka. Unesite podatke klijenta kako bi je kreirali',
      scanCardToApproveDamage: 'Skenirajte karticu ili unesite PIN kako bi odobrili oštećenje',
      deliveryConfirmMessage: 'Da li ste sigurni da želite da kompletirate narudžbu?',
      splitOrderMessage: 'Ne možete da podelite sve narudžbe. Odaberite samo nekoliko.',
      clientLeft: 'Klijent je otišao.',
      houseCompliments: 'Od kuće',
      waitersMistake: 'Greška konobara',
      finalizeGoodsReturn: 'Da li ste sigurni za želite da finalizirate povratak robe?',
      goodsReturnDifference: 'Razlika od povraćaja robe',
      noApproveAccess: 'Nemate pravo da odobrite!',
      noBarcode: 'ne postoji barkod',
      noCode: 'ne postoji kod',
      notInStock: 'nema na raspolaganju!',
      stockValue: 'Na raspolaganju je samo',
      noAdminPrivileges: 'Nemate privilegije administratora!',
      finalizeCashOut: 'Da li ste sigurni da želite da finalizirati poravnanje?',
      waiterCashedOut: 'Konobar je sproveo poravnanje.',
      approveExit: 'Odobri zatvaranje/minimiziranje programa',
      scanCardToExit: 'Skeniraj karticu ili unesi PIN kako bi odobrio radnju',
      sendReport: 'Dostavi izveštaj',
      emailSent: 'Emajl je uspešno dostavljen!',
      emailFailed: 'Email nije poslat. Molim vas, pokušajte ponovo.',
      invalidEmail: 'Emajl adresa nije validna!',
      sending: 'Šalje se',
      device_mismatch: 'Ista narudžba je otvorena na drugom uređaju.Promene narudžbe su dozvoljene samo na tom uređaju.',
      confirm_admin_changes: 'Svaka promena koju napravite će izbrisati sve promene koje je u međuvremenu uneo konobar. Želite li da nastavite?',
      DOCUMENTISCLOSED_CANNOTFINALIZE: 'Dokument se ne može finalizirati jer je ranije finalizovan!',
      DOCUMENTISCLOSED_CANNOTSAVE: 'Proizvod se ne može sačuvati jer je dokument ranije finaliziran!',
      scanCardToApproveFreePayment: 'Skeniraj karticu ili unesi PIN kako bi odobrio besplatno ',
      productsUpdatedWithVat: 'PDV se primenjuje na sve proizvode',
      tablesUpdatedWithProduct: 'Proizvod je dostavljen na svim stolovima',
      chooseTemplate: 'Odaberite poruku!',
      cannotDeleteItem: 'Proizvod ne može da se izbriše iz narudžbe!',
      serviceClientFormError: 'Telefon, ime deteta i ime roditelja ne mogu ostati prazni!',
      contiueWithService: 'Nastavi sa uslugom?',
      CANNOTCHANGEDOCUMENTLESSLASTSTOCKRESET: 'Nije moguće izbrisati bilo koju promenu u zalihama koja je realizovan pre poslednjeg preseka zaliha!',
      salesAmountChanged: 'Iznos prodaje je u međuvremenu promenjen.',
      menus: {
        productExists: 'Proizvod postoji na meniju.',
        pleaseAddProduct: 'Molimo vas dodajte ovaj proizvod u Meniju.',
        cantBeEmpty: 'Prazan meni ne može da se sačuva.',
        confirmProdRemove: 'Da li ste sigurni da želite da uklonite proizvod?',
        confirmRemove: 'Da li ste sigurni da želite da izbrišite meni?'
      },
      categories: {
        confirmDiscountChanges: 'Sniženje za ove proizvode će biti izbrisano. Želite li da nastavite?',
        confirmRemove: 'Da li ste sigurni da želite da uklonite ovu kategoriju?'
      },
      products: {
        confirmRemove: 'Da li ste sigurni da želite da izbrišete ovaj proizvod?',
        confirmIngredientsRemove: 'Da li da želite da izbrišete sastojke ovog proizvoda',
        addProductIngredients: 'Molimo vas da dodate sastojke proizvodu, lista ne može da ostane prazna.',
        enabledHappyHour: 'Prikaži samo kad je Happy Hour',
        cannotRemoveLastProduct: 'Poslednji sastojak ne može da se izbriše ako se ne doda neki drugi sastojak!',
        productDeleteFailed: 'Proizvod ne može da se izbriše jer se koristi kao sastojak u dole navedenim proizvodima:'
      },
      tablePlan: {
        confirmRemove: 'Da li ste sigurni da želite da izbrišete plan?',
        successUpdate: 'Plan je uspešno ažuriran!'
      },
      stock: {
        confirmRemove: 'Da li ste sigurni da želite da izbrišete promene u zalihama?',
        confirmProdRemove: 'Da li ste sigurni da želite da uklonite proizvod?',
        finalizePurchase: 'Da li želite da finalizirate kupovinu?',
        confirmStockReset: 'Da li želite da finalizirate presek u zalihama? Podaci nakon toga ne mogu da se promene!'
      },
      points: {
        confirmRemove: 'Da li ste sigurni da želite da izbrišete ovu tačku?'
      },
      purchases: {
        confirmRemove: 'Da li ste sigurni da želite da izbrišete kupovinu?',
        finalizePurchase: 'Želite li da finalizirate kupovinu?'
      },
      printers: {
        confirmRemove: 'Da li ste sigurni da želite da izbrišete printer?',
        printingError: 'Narudžba nije odštampana! Molimo vas da proverite da li je printer uključen i povezan sa kompjuterom. Ako i dalje ne radi, kontaktirajte osobu odgovornu za printer kao i tehničara.'
      },
      units: {
        confirmRemove: 'Da li ste sigurni da želite da izbrišete jedinicu?'
      },
      vats: {
        confirmRemove: 'Da li ste sigurni da želite da izbrišete poresku normu?',
        vatRateExist: 'Ova PDV stopa postoji'
      },
      users: {
        cannotChangeAdminRole: 'Ne možete da promenite ulogu administratora!',
        notAdminUser: 'Nemate privilegije administratora da izbrišete ovog korisnika!',
        confirmRemove: 'Da li ste sigurni da želite da izbrišete korisnika?',
        nameNotNull: 'Ime ne sme da ostane prazno!',
        pinNotNull: 'PIN ne sme da ostane prazan!',
        roleNotNull: 'Uloga ne sme da ostane prazna!',
        personalNumberNotNull: 'Lični broj ne može da ostane prazan!',
        emailNotNull: 'Emajl ne sme da ostane prazan!',
        setStaffLimit: 'Navedite limit za hranu za korisnika!'
      },
      vendors: {
        confirmRemove: 'Da li ste sigurni da želite da izbrišete snabdevača?'
      },
      config: {
        changeApplied: 'Promena je sprovedena. Ponovo se uključite kako bi videli promenu. Hvala vam',
        bankInfoMandatory: 'Banka i bankovni račun treba da budu popunjeni!',
        chooseOperatingCountry: 'Treba da odabere državu gde ste funkcionalni!'
      },
      vouchers: {
        confirmRemove: 'Da li ste sigurni da želite da izbrišete sniženje?'
      },
      clients: {
        confirmRemove: 'Da li ste sigurni da želite da izbrišete klijenta?'
      },
      validations: {
        cannotBeEmpty: 'Ne sme da ostane prazno!',
        notNullLettersAndNumbers: 'Ne sme da ostane prazno i treba da sadrži samo brojeve i slova.',
        validNameAndFiscalNumber: 'Ime i fiskalni broj ne mogu da ostanu prazni!',
        validProductNameAndTotal: 'Naziv proizvoda i Ukupno ne mogu da ostanu prazni!',
        cannotBeNegativeValue: 'Ne može da stoji negativna vrednost.',
        nameCannotBeEmpty: 'Ime ne može da ostane prazno!',
        doserCannotBeNegativeValue: 'Dozer treba da bude veći od nule ili prazan!'
      },
      expenses: {
        confirmCloseAndRemove: 'Da li ste sigurni da želite da zatvorite ovu stranicu? Svi troškovi koji nisu sačuvani će biti izbrisani!'
      }
    },
    buttons: {
      splitCourse: 'Split course',
      fiscalCopy: 'Fiscal copy',
      groupedOrders: 'Grouped orders',
      changePayment: 'Change payment',
      continueWithoutCoupon: 'Nastavi bez kupona',
      continueWithCoupon: 'Nastavi sa kuponima',
      save: 'Sačuvaj',
      saveDraft: 'Sačuvaj nacrt',
      cancel: 'Poništi',
      continue: 'Nastavi',
      close: 'Zatvori',
      print: 'Odštampaj',
      split: 'Podeli',
      goBack: 'Vrati se',
      finalize: 'Finaliziraj',
      fiscal: 'Fiskalno',
      notFiscal: 'Ne fiskalno',
      finish: 'Završi',
      finishOptionalPrintTotal: 'Finish with receipt',
      qrCode: 'QR kod',
      invoice: 'Račun',
      filterDates: 'Filtriraj datume',
      generateReport: 'Pripremi izveštaj',
      add: 'Dodaj',
      addExpenses: 'Dodaj troškove',
      cashOut: 'Poravnaj',
      send: 'Pošalji',
      email: 'Emajl',
      refresh: 'Ažuriraj',
      tryAgain: 'Pokušaj ponovo',
      refuse: 'Odbi',
      changeClient: 'Promeni klijenta',
      menus: {
        addMenu: 'Dodaj meni',
        deleteMenu: 'Izbriši meni',
        deletePriceList: 'Delete price list',
        addAllProducts: 'Add all products',
        addPriceList: 'Add price list'
      },
      categories: {
        addCategory: 'Dodaj kategoriju'
      },
      products: {
        addProduct: 'Dodaj proizvod',
        export: 'Prenesi'
      },
      tablePlan: {
        addPlan: 'Dodaj plan',
        addTable: 'Dodaj sto',
        deleteTable: 'Izbriši sto',
        addMultipleTables: 'Add multiple'
      },
      stock: {
        addProduct: 'Dodaj proizvod'
      },
      points: {
        addPoint: 'Dodaj tačku',
        pointName: 'Naziv tačke'
      },
      printers: {
        addPrinter: 'Dodaj printer',
        printerName: 'Naziv printera',
        printerPort: 'Portal printera',
        printerType: 'Vrsta printera',
        fiscalPrinterType: 'Vrsta fiskalnog printera',
        letterDimensions: 'Dimenzija papira',
        dynamicPath: 'Dinamički put'
      },
      units: {
        addUnit: 'Dodaj jedinicu'
      },
      vats: {
        addVat: 'Dodaj PDV',
        vatRate: 'PDV stopa'
      },
      users: {
        addUser: 'Dodaj korisnika'
      },
      vendors: {
        addVendor: 'Dodaj nabavljača',
        vendorName: 'Naziv nabavljača',
        chooseVendor: 'Odaberi nabavljača'
      },
      locations: {
        addLocation: 'Dodaj lokaciju'
      },
      clients: {
        addClient: 'Dodaj klijenta'
      },
      happyHours: {
        addHappyHour: 'Dodaj Happy Hour'
      },
      makers: {
        addMaker: 'Dodaj proizvođača',
        makerName: 'Naziv proizvođača',
        chooseMaker: 'Odaberi proizvođača'
      },
      displays: {
        addDisplay: 'Dodaj ekran',
        displayName: 'Ime'
      }
    },
    labels: {
      receivedBy: 'Received by',
      outgoingDocument: 'Outgoing document',
      displayControllerPermission: 'Display controller',
      advancedConfiguration: 'Advanced configuration',
      productConfigurationType: 'Product configuration type',
      reason: 'Reason',
      required: 'This field is required',
      freePaymentWithFiscal: 'Free payment with fiscal',
      changePaymentMethodAllOrders: 'Change payment for all orders',
      liveTickerAllOrders: 'Live ticker: all orders',
      currencyExchange: 'Currency exchange',
      excludedVat: 'Excluded from VAT',
      excludedVatCode: 'Excluded from VAT code',
      finished: 'Završeno',
      showAll: 'Show all',
      expense: 'Expense',
      freeTables: ' OPEN',
      reservationsArriving: 'In 30 min',
      reservationClientPriority: 'Client with priority',
      additionalInfo: 'Additional info',
      tablesWithoutReservations: 'Free tables',
      changeReservationStatus: 'Change reservation status',
      reservationStatusUpdateFailed: 'Failed to update reservation status!',
      reservationDeleteConfirmation: 'Are you sure you want to delete the reservation?',
      showed: 'Showed',
      notShowed: 'Did not show',
      clientAdditionalInfo: 'Client additional info',
      newReservation: 'New reservation',
      numberPersons: 'Number of persons',
      reservations: 'Reservations',
      totalWithoutDiscount: 'Total before discount',
      serviceFee: 'Service fee',
      serviceFeeType: 'Service fee type',
      serviceFeeAutomatic: 'Service fee automatic',
      courseSpliter: 'Split course',
      employeeTip: 'Tip',
      deleteOrderPermission: 'Delete order permission',
      orderDeleteConfirmation: 'Da li ste sigurni da želite da izbrišete narudžbu?',
      delete: 'Izbriši',
      avgPrice: 'Prosečna cena',
      sellPriceWithVAt: 'Selling price (with VAT)',
      totalSellPriceWithVAt: 'Total selling price',
      clearCreateNew: 'Clear / Create new client',
      duePayment: 'Due payment',
      loanPermission: 'Due payments permission',
      minDate: 'Start date',
      maxDate: 'End date',
      numberOfOrders: 'Number of orders',
      selectedToPay: 'To pay',
      paidProducts: 'Partial payments',
      ordersCount: 'No. of orders',
      onlinePaymentProcessing: 'Processing ...',
      onlinePaymentCanceled: 'Canceled/Failed!',
      onlinePaymentSuccess: 'Success.',
      changePaymentMethod: 'Change payment',
      refreshIn: 'Refresh in',
      identifierCode: 'Identifier code',
      writeDescription: 'Unesite opis',
      apiCode: 'API code',
      doNotPrint: 'Do not print',
      calculatePrice: 'Calculate price',
      actualPrice: 'Actual price',
      newPrice: 'New price',
      displayInInterval: 'Display in interval',
      ingredient: 'Ingredient',
      day: 'Day',
      month: 'Month',
      year: 'Year',
      birthDate: 'Date of birth',
      pin: 'PIN',
      active: 'Aktivan',
      inactive: 'Neaktivan',
      activate: 'Aktiviraj',
      activateDeductions: 'Aktiviraj sniženja',
      order: 'Naruči',
      orders: 'Narudžbe',
      theOrder: 'Paragalia',
      orderAndContinue: 'Naruči + Nastavi',
      information: 'Informacija',
      printReceipt: 'Odštampaj fiskalni',
      printWReceipt: 'Odštampaj onaj koji nije fiskalni',
      clearOrder: 'Izbriši narudžbu',
      clearTable: 'Oslobodi sto',
      cancelOrder: 'Otkaži narudžbu',
      splitOrder: 'Podeli narudžbu',
      product: 'Proizvod',
      products: 'Proizvodi',
      productType: 'Vrsta proizvoda',
      quantity: 'Količina',
      total: 'Ukupno',
      totalAmount: 'Ukupan iznos',
      discount: 'Sniženje',
      discounts: 'Sniženja',
      price: 'Cena',
      phone: 'Telefon',
      delivery: 'Dostava',
      takeAway: 'Za poneti',
      inHouse: 'Ovde',
      table: 'Sto',
      tables: 'Stolovi',
      amount: 'Iznos',
      waiter: 'Konobar',
      plan: 'Plan',
      free: 'Slobodno',
      open: 'Otvoreno',
      closed: 'Zatvoreno',
      busy: 'Zauzeto',
      status: 'Status',
      confirmation: 'Konfirmacija',
      currentQuantity: 'Trenutna količina',
      previousQuantity: 'Prethodna količina',
      difference: 'Razlika',
      lastChange: 'Poslednja promena',
      date: 'Datum',
      payment: 'Isplata',
      collect: 'Inkasiraj',
      collected: 'Inkasirano',
      collection: 'Inkasiraj',
      uncollected: 'Nije naplaćeno',
      actions: 'Radnje',
      client: 'Klijent',
      deliveryClient: 'Klijent za dostavu',
      chooseEmployee: 'Odaberi zaposlenika',
      business: 'Biznis',
      ngo: 'NVO',
      search: 'Traži',
      fiscalNumber: 'Fiskalni broj',
      vatNumber: 'Broj PDV-a',
      businessNumber: 'Broj biznisa',
      registrationNumber: 'Registracioni broj',
      name: 'Ime',
      address: 'Adresa',
      businessAddress: 'Adresa biznisa',
      city: 'Grad',
      contactPerson: 'Kontakt osoba',
      comment: 'Komentar',
      email: 'Emajl',
      website: 'Internet stranica',
      contact: 'Kontakt',
      bank: 'Banka',
      bankAccount: 'Bankovni račun',
      cash: 'Keš',
      code: 'Kod',
      barcode: 'Barkod',
      card: 'Kartica',
      idCard: 'ID kartica',
      seller: 'Prodavac',
      buyer: 'Kupac',
      value: 'Vrednost',
      valueWithVat: 'Vrednost sa PDV-om',
      valueWithoutVat: 'Vrednost be PDV-a',
      priceWithVat: 'Cena sa PDV-om',
      priceWithoutVat: 'Cena bez PDV-a',
      vat: 'PDV',
      chooseVat: 'Odaberi PDV',
      forPayment: 'Za naplatu',
      submitted: 'Predato',
      accept: 'Prihvaćeno',
      from: 'Od',
      to: 'Za',
      until: 'Do',
      fromTable: 'Od stola',
      toTable: 'Za sto',
      staff: 'Osoblje',
      staffOrder: 'Narudžba za osoblje',
      staffPrice: 'Cena za osoblje',
      damagedGoods: 'Oštećenje robe',
      damagedProduct: 'Oštećeni proizvod',
      reportDamage: 'Prijavi oštećenje',
      forFood: 'Za hranu',
      chooseBank: 'Odaberi banku',
      chooseBanks: 'Odaberi banke',
      approveDamage: 'Odobri oštećenje',
      chooseDate: 'Odaberi datum',
      moneyChange: 'Kusur',
      freeOfCharge: 'Besplatno',
      goodsReturn: 'Povraćaj robe',
      return: 'Vrati',
      categories: 'Kategorije',
      category: 'Kategorija',
      categoryType: 'Vrsta kategorije',
      ranking: 'Redosled',
      autoRanking: 'Automatski redosled',
      rankingPrinter: 'Redosled printera',
      choose: 'Odaberi',
      description: 'Opis',
      employee: 'Zaposlenik',
      user: 'Korisnik',
      vendor: 'Nabavljač',
      time: 'Vreme',
      paymentType: 'Vrsta isplate',
      orderType: 'Vrsta narudžbe',
      invoiceNumber: 'Broj računa',
      document: 'Dokument',
      transfer: 'Transfer',
      start: 'Početak',
      end: 'Kraj',
      damages: 'Oštećenja',
      expenses: 'Troškovi',
      totalSales: 'Ukupno prodaja',
      mostSoldProd: 'Najprodavaniji proizvod',
      mostSoldProdQuantity: 'Količina najprodavanijeg proizvoda',
      approvedBy: 'Odobreno od',
      clientName: 'Ime klijenta',
      clientCode: 'Kod klijenta',
      clientCard: 'Kartica klijenta',
      cardNumber: 'Broj kartice',
      ordersNumber: 'Broj narudžbi',
      withDetails: 'Sa detaljima',
      clients: 'Klijenti',
      type: 'Vrsta',
      menuIcon: 'Ikona menija',
      addProduct: 'Dodaj proizvod',
      addCategory: 'Dodaj katwgoriju',
      authorizedPerson: 'Ovlašćeno lice',
      beginning: 'Start',
      dailySales: 'Dnevna prodaja',
      handedOver: 'Predato',
      kitchen: 'Kuhinja',
      choosePrinter: 'Odaberi printer',
      printer: 'Printer',
      bar: 'Šank',
      yes: 'Da',
      no: 'Ne',
      color: 'Boja',
      receipt: 'nefiskalni kupon',
      menu: 'Meni',
      picture: 'Fotografija',
      chooseCategory: 'Odaberi kategoriju',
      internalCode: 'Kod',
      unit: 'Jedinica',
      units: 'Jedinice',
      stockChange: 'Promena u zalihama',
      dynamicAmount: 'Dinamička količina',
      simple: 'Jednostavno',
      compound: 'Kombinovano',
      combo: 'Kombo',
      comboQuantity: 'Kombo količina',
      productsIngredients: 'Sastojci proizvoda',
      preSelected: 'Pre-odabrano',
      preSelectedQuantity: 'Količina pre-odabranog',
      dynamic: 'Dinamično',
      recipe: 'Recept',
      default: 'Predodređeno',
      happyHour: 'Happy Hour',
      letter: 'Slovo',
      number: 'Broj',
      lastMove: 'Poslednji pokret',
      addedRemovedQty: 'Dodata/smanjena količina',
      draft: 'nacrt',
      finalized: 'Finalizovano',
      view: 'Pogledaj',
      stock: 'Zaliha',
      point: 'Tačka',
      productAt: 'Proizvod na',
      choosePoint: 'Odaberi tačku',
      ip: 'IP',
      rate: 'Stopa',
      country: 'Država',
      currency: 'Valuta',
      uploadLogo: 'Preuzmi logo (maksimalno 2MB)',
      general: 'Opšte',
      port: 'Portal',
      other: 'Ostalo',
      level: 'Nivo',
      createdDate: 'Datum kreiranja',
      role: 'Uloga',
      personalNumber: 'Lični broj',
      dailyFoodLimit: 'Dnevni limit za hranu',
      calculateDiscount: 'Obračunaj sniženje',
      productsPrice: 'Cena proizvoda',
      priceWithDiscount: 'Cena sa sniženjem',
      paid: 'Plaćeno',
      remaining: 'Ostalo',
      sum: 'Iznos',
      sale: 'Prodaja',
      typesOfSales: 'Vrste prodaje',
      qtyAndValue: 'Količina i vrednost',
      days: 'Dani',
      choosePaymentType: 'Odaberi vrstu plaćanja',
      lastCount: 'Poslednji obračun',
      purchaseDate: 'Datum kupovine',
      invoiceDate: 'Datum računa',
      stateReason: 'Navedi razlog',
      today: 'Danas',
      yesterday: 'Juče',
      lastSevenDays: '7 poslednjih dana',
      lastThirtyDays: '30 poslednjih dana',
      emails: 'Emajl adrese',
      notification: 'Obaveštenje',
      programQuantity: 'Količina programa',
      physicalQuantity: 'Fizička količina',
      differencePurchasePrice: 'Razlika od kupovne cene',
      differenceSellPrice: 'Razlika od prodajne cene',
      percentage: 'Procenat',
      filters: 'Filteri',
      choosePeriod: 'Odaberi period',
      language: 'Jezik',
      startEnd: 'Start/Kraj',
      pcs: 'Komad',
      createdBy: 'Kreirano od',
      maker: 'Proizvođač',
      addMaker: 'Dodaj na osnovu proizvođača',
      makers: 'Proizvođači',
      searchClient: 'Traži klijenta',
      raportiDitor: 'Dnevni izveštaj',
      advance: 'Avans',
      doser: 'Dozer',
      canCashOut: 'Poravnanje/saldo',
      waiterAccess: 'Pristup konobara',
      userAccess: 'Pristup korisnika (ne Admin)',
      system: 'Sistem',
      configOrder: 'Narudžba',
      othersQuantity: 'Ostala količina',
      totalOrders: 'Broj narudžbi',
      displayOnlyResetProducts: 'Prikaži samo izbrojene proizvode',
      orderNumber: 'Broj narudžbe',
      employeeDeleted: 'Izbrisani zaposlenik',
      deletedDate: 'Datum brisanja',
      show: 'Prikaži',
      inhouse: 'Ovde',
      takeaway: 'Za poneti',
      fiscal: 'Fiskalni',
      noFiscal: 'Nefiskalni',
      noPayment: 'Besplatno',
      invoice: 'Račun',
      dailyDiscount: 'Dnevno sniženje',
      aggregate: 'Ukupno',
      salesman: 'Prodavac',
      display: 'Ekran',
      chooseDisplay: 'Odaberi ekran/ekrane',
      displayOnlyInTheseDevices: 'Display in this device ([0]) orders only from',
      clientDiscount: 'Sniženje',
      lock: 'Blokiraj',
      stockThreshold: 'Limit zaliha',
      service: 'Usluga',
      withTimer: 'Sa satnicom',
      cardNumberOrTelephone: 'Broj kartice ili telefona',
      priceType: 'Vrsta cene',
      priceCalculation: 'Obračun cene',
      applyToTables: 'Primeni za stolove',
      receiptForAllOrders: 'Račun za sve narudžbe',
      parent: 'Roditelj',
      child: 'Dete',
      twilioFriendlyName: 'Broj/Ime',
      smsSucces: 'SMS je uspešno dostavljen.',
      SalesOrder: 'Prodaja',
      StockChange: 'Promena zalihe',
      StockReset: 'Presek zaliha',
      VendorPurchase: 'Kupovina',
      showProduct: 'Prikaži proizvod',
      showCategory: 'Prikaži kategoriju',
      showMaker: 'Prikaži proizvođača',
      showAllTableTotals: 'Prikaži ukupno za sve (stolovi)',
      regularInvoiceForAllOrders: 'Redovni račun za sve narudžbe',
      totalQuantity: 'Total quantity',
      roles: {
        Admin: 'Administrator',
        Waiter: 'Konobar',
        Kamarier: 'Konobar',
        Menaxher: 'Menadžer',
        Depoist: 'Magacioner',
        Staf: 'Osoblje',
        Salesman: 'Prodavac',
        Display: 'Ekran'
      },
      approveFreePayment: 'Odobri besplatno',
      purchasePriceWithoutVat: 'Cena kupovine (bez PDV-a)',
      vendorName: 'Nabavljač',
      totalWithouVat0: 'Ukupno bez PDV-a 0%',
      totalWithoutVat8: 'Ukupno bez PDV-om (8%)',
      vatAmount8: 'Vrednost PDV-a (8%)',
      totalWithoutVat18: 'Ukupno bez PDV-a (18%)',
      vatAmount18: 'Vrednost PDV-a (18%)',
      applyToProducts: 'Primeni za proizvode',
      sellPrice: 'Sell price',
      margin: 'Margin',
      deliveryType: 'Delivery type',
      totalCurrentPrice: 'Total current price',
      configLabels: {
        hideDeliveryTotals: 'Hide delivery totals',
        printerNameTicket: 'Printer name in tickets',
        cardPaymentFee: 'Card payment fee',
        fiscalExtraMessage: 'Fiscal: extra text',
        reservationDuration: 'Reservation duration (hour)',
        mobileHideTotal: 'PostomGo: Hide total',
        courseSpliters: 'Course spliters',
        waiterSelfHandouts: 'Waiter self handout',
        liveTickerNoActions: 'Live ticker: block actions',
        chooseFiscalThermalPrinter: 'Choose fiscal thermal printer',
        employeeClocktimeProductSales: 'Display sold products on handouts print',
        searchClientCards: 'Show "Search" in clients card',
        chooseGeneralPrinter: 'Odaberi osnovni printer',
        duplicatePrinter: 'Dupliraj printer',
        duplicateGeneralPrinter: 'Dupliraj osnovni printer',
        chooseFiscalPrinter: 'Odaberi fiskalni printer',
        chooseInvoicePrinter: 'Odaberi printer za redovni račun',
        duplicateInvoicePrinter: 'Dupliraj printer za redovni račun',
        chooseCashOnPrinter: 'Odaberi printer za poravnanje/saldo',
        chooseFinalInvoicePrinter: 'Odaberi printer za završni račun',
        duplicateFinalInvoicePrinter: 'Dupliraj printer za završni račun',
        finalInvoiceQuantity: 'Broj kopija za završni račun',
        notRestaurant: 'Nije restoran/bar',
        allowNegativeStock: 'Dozvoli zalihu sa minusom',
        fiscalConfirm: 'Potvrdi za fiskalni kupon',
        defaultDelivery: 'Dostava narudžbe by default',
        manualFreeTable: 'Ručno oslobodi sto',
        kitchenPrinter: 'Kuhinja/Printer',
        cardPayment: 'Plaćanje karticom',
        directOrder: 'Direktna narudžba',
        showTotalOnNonfiscal: 'Prikazi ukupno na nefiskalnom printeru',
        orderTotalNonFiscalOptional: '(Optional) Non-fiscal receipt total',
        showCommentsOnNonfiscal: 'Prikazi komentare na nefiskalnom računu',
        orderNrOnFiscal: 'Broj narudžbi na fiskalnom kuponu',
        fixedShift: 'Početak fiksne smene',
        adminCashShift: 'Administrator da krene sa prvom smenom',
        orderToKitchenAfterPayment: 'Odštampaj narudžbu u kuhinji samo posle naplate',
        returnToTableAfterOrder: 'Vrati na sto nakon narudžbe',
        logoutAfterOrder: 'Logout nakon narudžbe',
        returnToTableAfterPayment: 'Vrati na stolove nakon naplate',
        logoutAfterPayment: 'Logout nakon naplate',
        managerCashOut: 'Menadžer može da uradi poravnanje sa konobarima',
        dontIncludeCustomersIdinSale: 'Nemoj obračunati u saldo sa kartice klijenta',
        approvalDamages: 'Oštećenja sa odobrenjem',
        mobilePos: 'Mobilni POS',
        closeAutomatically: 'Automatski zatvori',
        transfers: 'Transferi',
        approveProgramClose: 'Zatvori program samo sa konfirmacijom',
        codeAndMakers: 'Kod i proizvođač za proizvod',
        enableMinimize: 'Aktiviraj minimiziranje programa<br/> <small>(vredi za trenutni uređaj)</small>',
        liveTicker: 'Live ticker',
        liveTickerAllOrders: 'Live ticker: prikaži samo narudžbe konobara',
        liveTickerSalesmanAllOrders: 'Live ticker: prikaži samo narudžbe prodavca',
        handoutsCalculateCard: 'Obračunaj prodaju sa bankom u poravnanje',
        autoStart: 'Auto start (vredi samo za ovaj uređaj)',
        printQuantityFromLeft: 'Količina na levoj strani (odštampaj)',
        disableOrderComments: 'Deaktiviraj komentare u narudžbi',
        freePaymentConfirm: 'Potvrda za besplatno',
        displays: 'Ekrani',
        onlyFiscal: 'Samo fiskalni',
        isService: 'Je usluga',
        serviceClient: 'Igre za decu',
        directOnlyFiscal: 'Direct fiscal'
      },
      reportsLabels: {
        salesTypeReport: 'Izveštaj o vrsti prodaje',
        businessDayClose: 'Prema zatvaranju dana'
      },
      weekdays: {
        monday: 'Ponedeljak',
        tuesday: 'Utorak',
        wednesday: 'Sreda',
        thursday: 'Četvrtak',
        friday: 'Petak',
        saturday: 'Subota',
        sunday: 'Nedelja'
      }
    },
    mainMenu: {
      reports: {
        tableTransfers: 'Transfers',
        name: 'Izveštaji',
        sales: 'Prodaje',
        productSales: 'Prodaja proizvoda',
        hourlySales: 'Prodaja po satima',
        purchases: 'Kupovine',
        stockChanges: 'Promene u zalihama',
        handovers: 'Poravnanje/saldo',
        waiterRankings: 'Rangiranje konobara',
        delivery: 'Dostava',
        ingredients: 'Sastojci',
        damages: 'Oštećenja',
        clients: 'Klijenti',
        startEndSalesDay: 'Početak/Kraj',
        categorySales: 'Prodaja prema kategorijama',
        staff: 'Osoblje',
        salesByMaker: 'Prodaja prema proizvođačima',
        deliveryClients: 'Klijenti za dostavu',
        productByCompoundItemsSales: 'Prodaja prema dodacima',
        salesBook: 'Knjiga prodaje',
        purchaseBook: 'Knjiga nabavke',
        regularInvoices: 'Redovni računi',
        productSalesInterval: 'Prodaja proizvoda po intervalima',
        duePayments: 'Dugovanja',
        paymentMethods: 'Vrste plaćanja',
        vatSales: 'PDV prodaje',
        purchaseProducts: 'Nabavka proizvoda',
        returnedProducts: 'Returned products',
        reservations: 'Reservations'
      },
      menu: 'Meni',
      categories: 'Kategorije',
      products: 'Proizvodi',
      priceList: 'Price lists',
      floorPlan: 'Plan stolova',
      stock: {
        name: 'Zalihe',
        changeStock: 'Promeni zalihe',
        stockCutoff: 'Presek zaliha',
        inventoryLocations: 'Lokacije',
        stockThreshold: 'Limit zaliha',
        transactions: 'Transakcije proizvoda',
        transactionsPeriod: 'Product transactions period'
      },
      purchases: 'Nabavka',
      config: {
        name: 'Konfiguracija',
        printers: 'Printeri',
        measuringUnits: 'Jedinice',
        vat: 'PDV',
        users: 'Korisnici',
        vendors: 'Nabavljači',
        discounts: 'Sniženja',
        clients: 'Klijenti',
        accessPoints: 'Lokacije',
        makers: 'Proizvođači',
        audit: 'Revizija',
        license: 'Licence',
        displays: 'Ekrani',
        invoiceClients: 'Subjects',
        reservationClients: 'Reservation clients'
      }
    },
    exportFiles: {
      raporti_transfereve_tavolinave: 'table_transfers_report',
      raporti_shitjeve: 'izveštaj o prodaji',
      raporti_klientave: 'izveštaj_klijenti',
      raporti_barazimeve: 'izveštaj_balans',
      raporti_perberesave: 'izveštaj_sastojci',
      raporti_demtimeve: 'izveštaj oštećenja',
      raporti_delivery: 'izveštaj_dostava',
      raporti_kamarierave: 'izveštaj_konobari',
      raporti_shitjeve_produkt_sipas_ores: 'izveštaj_prodaja_proizvodi_prema_satnici',
      raporti_shitjeve_produkt: 'izveštaj_prodaja_proizvod',
      raporti_blerjeve: 'izveštaj _nabavka',
      raporti_shitjeve_kategorise: 'izveštaj_prodaja_kategorije',
      raporti_shitjeve_prodhuesit: 'izveštaj _prodaja_ proizvođači',
      raporti_staf: 'izveštaj _osoblje',
      raporti_fillimit_mbarimit: 'izveštaj _o početku _ o kraju',
      raporti_ndryshimit_stokut: 'izveštaj _ promena_ u zalihama',
      raporti_stokut: 'izveštaj _zalihe',
      prerja_stokut: 'presek _zaliha',
      product_transactions: 'transakcije _proizvoda',
      raporti_faturave_rregullta: 'izveštaj _redovnih  _računa',
      raporti_shitje_produkt_interval: 'izveštaj _prodaja _proizvoda _u intervalima',
      lista_produkteve: 'lista _proizvoda',
      raporti_shitjeve_produkt_interval_ores: 'product_sales_interval_report',
      raporti_shitjeve_menyres_pageses: 'payment_method_sales_report',
      raporti_shitjeve_tvsh: 'vat_sales_report',
      raporti_blerjeve_produktet: 'purchase_products_report',
      raporti_borxhit: 'due_payments_report',
      raporti_kthimit_mallit: 'returned_products_report',
      raporti_rezervimeve: 'reservations_report',
      raporti_auditimit: 'audit_report'
    },
    licenseMessages: {
      LICENSESUCCESS: 'Licenca je uspešno aktivirana.',
      INVALIDSIGNATURE: 'Licenca je promenjena, više nije validna!',
      INVALIDLICENCETOTHISDEVICE: 'Licenca nije validna za ovaj uređaj',
      INVALIDLICENCE: 'Licenca je istekla!',
      LICENCECONVERTERROR: 'Tekst licence je promenjen, licenca nije validna!',
      NOLICENSEFOUND: 'Ovaj uređaj nije licenciran! Molimo vas kontaktirajte STOM LLC +383 46 333 444!',
      licenseWarning: 'Licenca za ovaj program ističe za |daysLicenseExpire| dana, od datuma |expireDate|. ' +
        'Molimo vas da ponovno aktivirate licencu na vreme, kako bi mogli da nastavite upotrebu programa nakon isteka datuma za korišćenje ove licence. ' +
        'Za ponovno aktiviranje, molimo vas kontaktirajte STOM shpk na broj telefona +383 49 313 526'
    }
  },
  de: {
    message: {
      resetDisplayItemConfirm: 'Are you sure you want to change the order status?',
      closeAllOrdersDisplayConfirm: 'Are you sure you want to close all orders? This action cannot be undone.',
      pendingOrders: 'Ausstehende Bestellungen',
      noSearchResult: 'Kein Suchergebnis.',
      restartMessage: 'POSTOM wird neu gestartet in...',
      login: 'Anmelden',
      logout: 'Abmelden',
      details: 'Details',
      transferOrders: 'Übertragungsbestellungen',
      changeWaiter: 'Kellner wechseln',
      orderClosed: 'Geschlossene Bestellung',
      startOfShift: 'Schichtbeginn',
      endOfShift: 'Schichtende',
      successfulStartOfShift: 'Erfolgreicher Schichtbeginn.',
      successfulEndOfShift: 'Erfolgreiches Schichtende.',
      scanQrCode: 'QR-Code scannen',
      confirmOrderTransfer: 'Bitte bestätigen Sie die Übertragung der Bestellungen',
      currentWaiter: 'Aktueller Kellner',
      newWaiter: 'Neuer Kellner',
      changeWaiterMsg: 'Ihre Anfrage zur Änderung des Kellners wurde gesendet. Wenn der andere Kellner sie akzeptiert, wird die Übertragung durchgeführt.',
      orderCloseConfirmation: 'Sind Sie sicher, dass Sie diese Bestellung abschließen möchten?',
      serachSubjectOrFiscal: 'Suche mit der Betreff-/Steuernummer',
      validInvoiceWithoutStamp: 'Diese Rechnung ist ohne Stempel gültig.',
      removeOrderMessage: 'Die Bestellung kann nicht storniert werden, da aktive Produkte vorhanden sind.',
      // removeOrderRetailMessage: 'Die Bestellung kann nicht storniert werden, da aktive Produkte vorhanden sind.',
      freeTableMessage: 'Der Tisch kann nicht freigegeben werden, da eine aktive Bestellung vorhanden ist.',
      closeOrderMessage: 'Die Bestellung ist geschlossen. Sie können keine weiteren Produkte hinzufügen.',
      closeOrderConfirmMessage: 'Sind Sie sicher, dass Sie die Bestellung abschließen und einen Steuerbeleg drucken möchten?',
      closeOrderConfirmMessageReservation: 'Is the order linked with this reservation?',
      printFiscalConfirm: 'Sind Sie sicher, dass Sie einen Steuerbeleg drucken möchten?',
      noProductMessage: 'Die Bestellung ist leer. Sie können keinen Steuerbeleg drucken.',
      noProductRetailMessage: 'Die Bestellung ist leer. Sie können den Verkauf nicht abschließen.',
      chooseTotalDiscount: 'Bitte wählen Sie den Gesamtrabatt aus',
      chooseProdDiscount: 'Bitte wählen Sie einen Rabatt für das Produkt aus',
      scanClientCard: 'Kundenkarte scannen',
      clientNotExist: 'Die Karte existiert nicht in der Datenbank. Geben Sie Kundendaten ein, um sie zu erstellen',
      scanCardToApproveDamage: 'Scannen Sie die Karte oder geben Sie Ihre PIN ein, um den Schaden zu genehmigen',
      deliveryConfirmMessage: 'Sind Sie sicher, dass Sie die Lieferbestellung abschließen möchten?',
      splitOrderMessage: 'Sie können nicht die gesamte Bestellung aufteilen. Bitte wählen Sie einige Produkte aus.',
      clientLeft: 'Der Kunde hat das Lokal verlassen.',
      houseCompliments: 'Hauskomplimente',
      waitersMistake: 'Fehler des Kellners',
      finalizeGoodsReturn: 'Sind Sie sicher, dass Sie die Rückgabe der Waren abschließen möchten?',
      goodsReturnDifference: 'Der Betragsdifferenz aus den zurückgegebenen Waren',
      noApproveAccess: 'Sie haben keine Berechtigung, diese Aktion zu genehmigen',
      noBarcode: 'Kein Barcode',
      noCode: 'Kein Code',
      notInStock: 'ist nicht mehr auf Lager!',
      stockValue: 'Es sind nur noch',
      noAdminPrivileges: 'Sie haben keine Administratorrechte!',
      finalizeCashOut: 'Sind Sie sicher, dass Sie auszahlen möchten?',
      waiterCashedOut: 'Der Kellner wurde ausgezahlt.',
      approveExit: 'Anwendung mit Genehmigung schließen',
      scanCardToExit: 'Code scannen, um die Genehmigung zu erteilen',
      sendReport: 'Bericht senden',
      emailSent: 'E-Mail wurde erfolgreich gesendet!',
      emailFailed: 'Beim Versuch, Ihre E-Mail zu senden, ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
      invalidEmail: 'E-Mail nicht gültig!',
      sending: 'Senden',
      device_mismatch: 'Die gleiche Bestellung ist auf einem anderen Gerät geöffnet. Änderungen an der Bestellung sind nur auf diesem Gerät zulässig.',
      confirm_admin_changes: 'Jede vorgenommene Änderung wird die vom Kellner in der Zwischenzeit vorgenommenen Änderungen überschreiben. Möchten Sie fortfahren?',
      DOCUMENTISCLOSED_CANNOTFINALIZE: 'Dokument kann nicht abgeschlossen werden, da es bereits abgeschlossen ist!',
      DOCUMENTISCLOSED_CANNOTSAVE: 'Das Produkt kann nicht gespeichert werden, da das Dokument bereits abgeschlossen ist!',
      scanCardToApproveFreePayment: 'Scannen Sie die Karte oder geben Sie Ihre PIN ein, um die kostenlose Zahlung zu genehmigen',
      productsUpdatedWithVat: 'MwSt auf alle Produkte angewendet',
      tablesUpdatedWithProduct: 'Produkt auf alle Tische angewendet',
      chooseTemplate: 'Vorlage auswählen!',
      cannotDeleteItem: 'Das Produkt kann nicht aus der Bestellung entfernt werden!',
      serviceClientFormError: 'Telefonnummer, Kindesname und Elternname dürfen nicht leer sein!',
      contiueWithService: 'Mit dem Service fortfahren?',
      CANNOTCHANGEDOCUMENTLESSLASTSTOCKRESET: 'Die Lageränderung, die vor dem letzten Lagerreset abgeschlossen wurde, kann nicht gelöscht werden!',
      salesAmountChanged: 'Der Verkaufsbetrag hat sich in der Zwischenzeit geändert.',
      menus: {
        productExists: 'Das Produkt existiert bereits in der Speisekarte.',
        pleaseAddProduct: 'Bitte fügen Sie Produkte zur Speisekarte hinzu.',
        cantBeEmpty: 'Sie können keine leere Speisekarte speichern.',
        confirmProdRemove: 'Sind Sie sicher, dass Sie ein Produkt entfernen möchten?',
        confirmRemove: 'Sind Sie sicher, dass Sie die Speisekarte löschen möchten?'
      },
      categories: {
        confirmDiscountChanges: 'Die Rabatte für diese Produkte werden überschrieben. Fortfahren?',
        confirmRemove: 'Sind Sie sicher, dass Sie die Kategorie löschen möchten? '
      },
      products: {
        confirmRemove: 'Sind Sie sicher, dass Sie das Produkt löschen möchten?',
        confirmIngredientsRemove: 'Zutat des Produkts löschen?',
        addProductIngredients: 'Bitte fügen Sie die Zutaten für das Produkt hinzu. Die Liste darf nicht leer sein.',
        enabledHappyHour: 'Zeige Happy Hour aktiviert',
        cannotRemoveLastProduct: 'Die letzte Zutat kann nicht gelöscht werden, bevor eine andere Zutat hinzugefügt wird!',
        productDeleteFailed: 'Das Produkt kann nicht gelöscht werden, da es als Zutat in den folgenden Produkten verwendet wird:'
      },
      tablePlan: {
        confirmRemove: 'Sind Sie sicher, dass Sie den Tischplan löschen möchten?',
        successUpdate: 'Der Plan wurde erfolgreich aktualisiert!'
      },
      stock: {
        confirmRemove: 'Sind Sie sicher, dass Sie die Lageränderung löschen möchten?',
        confirmProdRemove: 'Sind Sie sicher, dass Sie ein Produkt entfernen möchten?',
        finalizePurchase: 'Einkauf abschließen?',
        confirmStockReset: 'Lageränderungen abschließen? Die Daten können danach nicht mehr geändert werden.'
      },
      points: {
        confirmRemove: 'Sind Sie sicher, dass Sie den Punkt löschen möchten?'
      },
      purchases: {
        confirmRemove: 'Sind Sie sicher, dass Sie den Einkauf löschen möchten?',
        finalizePurchase: 'Einkauf abschließen?'
      },
      printers: {
        confirmRemove: 'Sind Sie sicher, dass Sie den Drucker löschen möchten?',
        printingError: 'Die Bestellung wurde nicht gedruckt! Stellen Sie sicher, dass der Drucker eingeschaltet und mit dem PC verbunden ist. Wenn es immer noch nicht funktioniert, wenden Sie sich bitte an die für den Drucker und andere Geräte verantwortliche Person.'
      },
      units: {
        confirmRemove: 'Sind Sie sicher, dass Sie die Einheit löschen möchten?'
      },
      vats: {
        confirmRemove: 'Sind Sie sicher, dass Sie den Mehrwertsteuersatz löschen möchten?',
        vatRateExist: 'Mehrwertsteuersatz existiert'
      },
      users: {
        cannotChangeAdminRole: 'Die Rolle des Administrators kann nicht geändert werden.',
        notAdminUser: 'Das Löschen von Benutzern ist nur für Administratoren zulässig.',
        confirmRemove: 'Sind Sie sicher, dass Sie den Benutzer löschen möchten?',
        nameNotNull: 'Bitte geben Sie den Namen ein!',
        pinNotNull: 'Bitte geben Sie die PIN ein!',
        roleNotNull: 'Bitte geben Sie die Position ein!',
        personalNumberNotNull: 'Bitte geben Sie die ID-Nummer ein!',
        emailNotNull: 'Bitte geben Sie die E-Mail-Adresse ein!',
        setStaffLimit: 'Bitte legen Sie ein Lebensmittellimit für den Benutzer fest!'
      },
      vendors: {
        confirmRemove: 'Sind Sie sicher, dass Sie den Lieferanten löschen möchten?'
      },
      config: {
        changeApplied: 'Bitte melden Sie sich erneut an, um die Änderungen zu übernehmen.',
        bankInfoMandatory: 'Die Felder für Bank und Bankkonto sind obligatorisch.',
        chooseOperatingCountry: 'Bitte wählen Sie das Land des Betriebs aus'
      },
      vouchers: {
        confirmRemove: 'Sind Sie sicher, dass Sie den Gutschein löschen möchten?'
      },
      clients: {
        confirmRemove: 'Sind Sie sicher, dass Sie den Kunden löschen möchten?'
      },
      validations: {
        cannotBeEmpty: 'Darf nicht leer sein!',
        notNullLettersAndNumbers: 'Darf nicht leer sein und muss nur Buchstaben und Zahlen enthalten.',
        validNameAndFiscalNumber: 'Name und Steuernummer dürfen nicht leer sein!',
        validProductNameAndTotal: 'Name und Gesamtprodukt dürfen nicht leer sein!',
        cannotBeNegativeValue: 'Darf keinen negativen Wert haben.',
        nameCannotBeEmpty: 'Der Name darf nicht leer sein!',
        doserCannotBeNegativeValue: 'Die Dosiermenge muss größer als Null oder leer sein!'
      },
      expenses: {
        confirmCloseAndRemove: 'Sind Sie sicher, dass Sie die Seite schließen und entfernen möchten? Alle nicht gespeicherten Ausgaben werden gelöscht!'
      }
    },
    buttons: {
      splitCourse: 'Split course',
      fiscalCopy: 'Fiscal copy',
      continueWithoutCoupon: 'Weiter ohne Gutschein',
      continueWithCoupon: 'Weiter mit Gutschein',
      groupedOrders: 'Gruppierte Bestellungen',
      changePayment: 'Zahlung ändern',
      save: 'Speichern',
      saveDraft: 'Entwurf speichern',
      cancel: 'Abbrechen',
      continue: 'Weiter',
      close: 'Schließen',
      print: 'Drucken',
      split: 'Teilen',
      goBack: 'Zurück',
      finalize: 'Abschließen',
      order: 'Bestellung',
      orders: 'Bestellungen',
      fiscal: 'Fiskal',
      notFiscal: 'Nicht fiskal',
      finish: 'Abschließen',
      finishOptionalPrintTotal: 'Abschließen mit Beleg',
      qrCode: 'QR-Code',
      invoice: 'Rechnung',
      filterDates: 'Daten filtern',
      generateReport: 'Bericht generieren',
      add: 'Hinzufügen',
      addExpenses: 'Ausgaben hinzufügen',
      cashOut: 'Kassenabschluss',
      send: 'Senden',
      email: 'E-Mail',
      refresh: 'Aktualisieren',
      tryAgain: 'Erneut versuchen',
      refuse: 'Ablehnen',
      changeClient: 'Kunde ändern',
      menus: {
        addMenu: 'Menü hinzufügen',
        deleteMenu: 'Menü löschen',
        deletePriceList: 'Preisliste löschen',
        addAllProducts: 'Alle Produkte hinzufügen',
        addPriceList: 'Preisliste hinzufügen'
      },
      categories: {
        addCategory: 'Kategorie hinzufügen'
      },
      products: {
        addProduct: 'Produkt hinzufügen',
        export: 'Exportieren'
      },
      tablePlan: {
        addPlan: 'Plan hinzufügen',
        addTable: 'Tisch hinzufügen',
        deleteTable: 'Tisch löschen',
        addMultipleTables: 'Mehrere hinzufügen'
      },
      stock: {
        addProduct: 'Produkt hinzufügen'
      },
      points: {
        addPoint: 'Punkt hinzufügen',
        pointName: 'Punktname'
      },
      printers: {
        addPrinter: 'Drucker hinzufügen',
        printerName: 'Druckername',
        printerPort: 'Druckeranschluss',
        printerType: 'Druckertyp',
        fiscalPrinterType: 'Fiskaler Druckertyp',
        letterDimensions: 'Buchstabendimensionen',
        dynamicPath: 'Dynamischer Pfad'
      },
      units: {
        addUnit: 'Einheit hinzufügen'
      },
      vats: {
        addVat: 'MwSt. hinzufügen',
        vatRate: 'MwSt.-Satz'
      },
      users: {
        addUser: 'Benutzer hinzufügen'
      },
      vendors: {
        addVendor: 'Lieferant hinzufügen',
        vendorName: 'Lieferantenname',
        chooseVendor: 'Lieferant auswählen'
      },
      locations: {
        addLocation: 'Standort hinzufügen'
      },
      clients: {
        addClient: 'Kunde hinzufügen'
      },
      happyHours: {
        addHappyHour: 'Happy Hour hinzufügen'
      },
      makers: {
        addMaker: 'Hersteller hinzufügen',
        makerName: 'Name des Herstellers',
        chooseMaker: 'Hersteller auswählen'
      },
      displays: {
        addDisplay: 'Anzeige hinzufügen',
        displayName: 'Name'
      }
    },
    labels: {
      receivedBy: 'Received by',
      outgoingDocument: 'Outgoing document',
      displayControllerPermission: 'Display controller',
      advancedConfiguration: 'Advanced configuration',
      productConfigurationType: 'Product configuration type',
      reason: 'Reason',
      required: 'This field is required',
      freePaymentWithFiscal: 'Free payment with fiscal',
      changePaymentMethodAllOrders: 'Change payment for all orders',
      liveTickerAllOrders: 'Live ticker: all orders',
      currencyExchange: 'Currency exchange',
      excludedVat: 'Excluded from VAT',
      excludedVatCode: 'Excluded from VAT code',
      finished: 'Abgeschlossen',
      showAll: 'Show all',
      expense: 'Expense',
      freeTables: ' OPEN',
      reservationsArriving: 'In 30 min',
      reservationClientPriority: 'Client with priority',
      additionalInfo: 'Additional info',
      tablesWithoutReservations: 'Free tables',
      changeReservationStatus: 'Change reservation status',
      reservationStatusUpdateFailed: 'Failed to update reservation status!',
      reservationDeleteConfirmation: 'Are you sure you want to delete the reservation?',
      showed: 'Showed',
      notShowed: 'Did not show',
      clientAdditionalInfo: 'Client additional info',
      newReservation: 'New reservation',
      numberPersons: 'Number of persons',
      reservations: 'Reservations',
      totalWithoutDiscount: 'Total before discount',
      serviceFee: 'Service fee',
      serviceFeeType: 'Service fee type',
      serviceFeeAutomatic: 'Service fee automatic',
      courseSpliter: 'Split course',
      employeeTip: 'Tip',
      deleteOrderPermission: 'Bestellung löschen',
      orderDeleteConfirmation: 'Sind Sie sicher, dass Sie die Bestellung löschen möchten?',
      delete: 'Löschen',
      avgPrice: 'Durchschnittspreis',
      sellPriceWithVAt: 'Verkaufspreis (mit MwSt.)',
      totalSellPriceWithVAt: 'Gesamter Verkaufspreis',
      clearCreateNew: 'Löschen / Neuen Kunden erstellen',
      duePayment: 'Ausstehende Zahlung',
      loanPermission: 'Erlaubnis für Ausstehende Zahlungen',
      minDate: 'Startdatum',
      maxDate: 'Enddatum',
      numberOfOrders: 'Anzahl der Bestellungen',
      selectedToPay: 'Zu zahlen',
      paidProducts: 'Teilzahlungen',
      ordersCount: 'Anzahl der Bestellungen',
      onlinePaymentProcessing: 'Verarbeitung ...',
      onlinePaymentCanceled: 'Abgebrochen/Fehlgeschlagen!',
      onlinePaymentSuccess: 'Erfolgreich.',
      changePaymentMethod: 'Zahlung ändern',
      refreshIn: 'Aktualisierung in',
      identifierCode: 'Kennungscode',
      writeDescription: 'Kommentar schreiben',
      apiCode: 'API-Code',
      doNotPrint: 'Nicht drucken',
      calculatePrice: 'Preis berechnen',
      actualPrice: 'Aktueller Preis',
      newPrice: 'Neuer Preis',
      displayInInterval: 'Anzeige im Intervall',
      ingredient: 'Zutat',
      day: 'Tag',
      month: 'Monat',
      year: 'Jahr',
      birthDate: 'Geburtsdatum',
      pin: 'PIN',
      active: 'Aktiv',
      inactive: 'Inaktiv',
      activate: 'Aktivieren',
      activateDeductions: 'Abzüge aktivieren',
      order: 'Bestellung',
      orders: 'Bestellungen',
      theOrder: 'Bestellung',
      orderAndContinue: 'Bestellen',
      information: 'Information',
      printReceipt: 'Beleg drucken',
      printWReceipt: 'Drucken ohne Beleg',
      clearOrder: 'Bestellung leeren',
      clearTable: 'Tisch leeren',
      cancelOrder: 'Bestellung stornieren',
      splitOrder: 'Bestellung aufteilen',
      product: 'Produkt',
      products: 'Produkte',
      productType: 'Produkttyp',
      quantity: 'Menge',
      total: 'Gesamt',
      totalAmount: 'Gesamtbetrag',
      discount: 'Rabatt | Rab.',
      discounts: 'Rabatte',
      price: 'Preis',
      phone: 'Telefon',
      delivery: 'Lieferung',
      takeAway: 'Zum Mitnehmen',
      inHouse: 'Im Haus',
      table: 'Tisch',
      tables: 'Tische',
      amount: 'Betrag',
      waiter: 'Kellner',
      plan: 'Plan',
      free: 'Frei',
      open: 'Offen',
      closed: 'Geschlossen',
      busy: 'Beschäftigt',
      status: 'Status',
      confirmation: 'Bestätigung',
      currentQuantity: 'Aktuelle Menge',
      previousQuantity: 'Vorherige Menge',
      difference: 'Unterschied',
      lastChange: 'Letzte Änderung',
      date: 'Datum',
      payment: 'Zahlung',
      collect: 'Einzug',
      collected: 'Eingezogen',
      collection: 'Sammlung',
      uncollected: 'Nicht eingezogen',
      actions: 'Aktionen',
      client: 'Kunde',
      deliveryClient: 'Lieferkunde',
      chooseEmployee: 'Mitarbeiter auswählen',
      business: 'Unternehmen',
      ngo: 'NGO',
      search: 'Suche',
      fiscalNumber: 'NUI',
      vatNumber: 'MwSt.-Nummer',
      businessNumber: 'Unternehmensnummer',
      registrationNumber: 'Registrierungsnummer',
      name: 'Name',
      address: 'Adresse',
      businessAddress: 'Geschäftsadresse',
      city: 'Stadt',
      contactPerson: 'Kontaktperson',
      comment: 'Kommentar',
      email: 'E-Mail',
      website: 'Website',
      contact: 'Kontakt',
      bank: 'Bank',
      bankAccount: 'Bankkonto',
      cash: 'Bargeld',
      code: 'Code',
      barcode: 'Strichcode',
      card: 'Karte',
      idCard: 'Personalausweis',
      seller: 'Verkäufer',
      buyer: 'Käufer',
      value: 'Wert',
      valueWithVat: 'Wert mit MwSt.',
      valueWithoutVat: 'Wert ohne MwSt.',
      priceWithVat: 'Preis mit MwSt.',
      priceWithoutVat: 'Preis ohne MwSt.',
      vat: 'MwSt.',
      chooseVat: 'MwSt. auswählen',
      forPayment: 'Zur Zahlung',
      submitted: 'Eingereicht',
      accept: 'Akzeptieren',
      from: 'Von',
      to: 'Bis',
      until: 'Bis',
      fromTable: 'Von Tisch',
      toTable: 'Zu Tisch',
      staff: 'Personal',
      staffOrder: 'Mitarbeiterbestellung',
      staffPrice: 'Personalpreis',
      damagedGoods: 'Beschädigte Ware',
      damagedProduct: 'Beschädigtes Produkt',
      reportDamage: 'Schaden melden',
      forFood: 'Für Essen',
      chooseBank: 'Bank auswählen',
      chooseBanks: 'Banken auswählen',
      approveDamage: 'Schaden genehmigen',
      chooseDate: 'Datum wählen',
      moneyChange: 'Wechselgeld',
      freeOfCharge: 'Kostenlos',
      goodsReturn: 'Warenrückgabe',
      return: 'Rückgabe',
      categories: 'Kategorien',
      category: 'Kategorie',
      categoryType: 'Kategorie-Typ',
      ranking: 'Rangfolge',
      autoRanking: 'Automatische Reihenfolge',
      rankingPrinter: 'Rang auf dem Beleg anzeigen',
      choose: 'Auswählen',
      description: 'Beschreibung',
      employee: 'Mitarbeiter',
      user: 'Benutzer',
      vendor: 'Lieferant',
      time: 'Zeit',
      paymentType: 'Zahlungsart',
      orderType: 'Bestelltyp',
      invoiceNumber: 'Rechnungsnummer',
      document: 'Dokument',
      transfer: 'Überweisung',
      start: 'Start',
      end: 'Ende',
      damages: 'Schäden',
      expenses: 'Ausgaben',
      totalSales: 'Gesamtverkauf',
      mostSoldProd: 'Meistverkauftes Produkt',
      mostSoldProdQuantity: 'Menge des meistverkauften Produkts',
      approvedBy: 'Genehmigt von',
      clientName: 'Kundenname',
      clientCode: 'Kundennummer',
      clientCard: 'Kundenkarte',
      cardNumber: 'Kartennummer',
      ordersNumber: 'Anzahl der Bestellungen',
      withDetails: 'Mit Details',
      clients: 'Kunden',
      type: 'Typ',
      menuIcon: 'Menüsymbol',
      addProduct: 'Produkt hinzufügen',
      addCategory: 'Kategorie hinzufügen',
      authorizedPerson: 'Bevollmächtigte Person',
      beginning: 'Anfang',
      dailySales: 'Tagesverkauf',
      handedOver: 'Übergeben',
      kitchen: 'Küche',
      choosePrinter: 'Drucker auswählen',
      printer: 'Drucker',
      bar: 'Bar',
      yes: 'Ja',
      no: 'Nein',
      color: 'Farbe',
      receipt: 'Beleg',
      menu: 'Menü',
      picture: 'Bild',
      chooseCategory: 'Kategorie auswählen',
      internalCode: 'Interne Nummer',
      unit: 'Einheit',
      units: 'Einheiten',
      stockChange: 'Bestandsänderung',
      dynamicAmount: 'Dynamische Menge',
      simple: 'Einfach',
      compound: 'Zusammengesetzt',
      combo: 'Combo',
      comboQuantity: 'Combo-Menge',
      productsIngredients: 'Produktzutaten',
      preSelected: 'Vorausgewählt',
      preSelectedQuantity: 'Vorausgewählte Menge',
      dynamic: 'Dynamisch',
      recipe: 'Rezept',
      default: 'Standard',
      happyHour: 'Happy Hour',
      letter: 'Buchstabe',
      number: 'Nummer',
      addedRemovedQty: 'Hinzugefügte/Entfernte Menge',
      draft: 'Entwurf',
      finalized: 'Abgeschlossen',
      view: 'Anzeigen',
      stock: 'Bestand',
      point: 'Punkt',
      productAt: 'Das Produkt bei',
      choosePoint: 'Punkt auswählen',
      ip: 'IP',
      rate: 'Rate',
      country: 'Land',
      currency: 'Währung',
      uploadLogo: 'Logo hochladen (max. 2 MB)',
      general: 'Allgemein',
      port: 'Port',
      other: 'Andere',
      level: 'Level',
      createdDate: 'Erstellungsdatum',
      role: 'Rolle',
      personalNumber: 'Personalnummer',
      dailyFoodLimit: 'Tägliches Lebensmittel-Budgetlimit',
      calculateDiscount: 'Rabatt berechnen',
      productsPrice: 'Produktpreis',
      priceWithDiscount: 'Preis mit Rabatt',
      paid: 'Bezahlt',
      remaining: 'Verbleibend',
      sum: 'Summe',
      sale: 'Verkauf',
      typesOfSales: 'Arten von Verkäufen',
      qtyAndValue: 'Menge und Wert',
      days: 'Tage',
      choosePaymentType: 'Zahlungsart auswählen',
      lastCount: 'Letzte Zählung',
      purchaseDate: 'Kaufdatum',
      invoiceDate: 'Rechnungsdatum',
      stateReason: 'Grund des Zustands',
      today: 'Heute',
      yesterday: 'Gestern',
      lastSevenDays: 'Letzte 7 Tage',
      lastThirtyDays: 'Letzte 30 Tage',
      emails: 'E-Mails',
      notification: 'Benachrichtigung',
      programQuantity: 'Programm-Menge',
      physicalQuantity: 'Physische Menge',
      differencePurchasePrice: 'Differenz Kaufpreis',
      differenceSellPrice: 'Differenz Verkaufspreis',
      percentage: 'Prozentsatz',
      filters: 'Filter',
      choosePeriod: 'Zeitraum auswählen',
      language: 'Sprache',
      startEnd: 'Start/Ende',
      pcs: 'Stück',
      createdBy: 'Erstellt von',
      maker: 'Hersteller',
      addMaker: 'Hersteller hinzufügen',
      makers: 'Hersteller',
      searchClient: 'Kunde suchen',
      raportiDitor: 'Tagesbericht',
      advance: 'Vorauszahlung',
      doser: 'Dosierer',
      canCashOut: 'Kassieren',
      waiterAccess: 'Zugang für Kellner',
      userAccess: 'Zugang für Benutzer (nicht Admin)',
      system: 'System',
      configOrder: 'Bestellung konfigurieren',
      othersQuantity: 'Andere Menge',
      totalOrders: 'Gesamtzahl der Bestellungen',
      displayOnlyResetProducts: 'Nur zurückgesetzte Produkte anzeigen',
      orderNumber: 'Bestellnummer',
      employeeDeleted: 'Gelöscht von',
      deletedDate: 'Löschdatum',
      show: 'Anzeigen',
      inhouse: 'Im Haus',
      takeaway: 'Zum Mitnehmen',
      fiscal: 'Fiskalisch',
      noFiscal: 'Nicht fiskalisch',
      noPayment: 'Kostenlos',
      invoice: 'Rechnung',
      dailyDiscount: 'Täglich',
      aggregate: 'Täglich',
      salesman: 'Verkäufer',
      display: 'Anzeige',
      chooseDisplay: 'Anzeige auswählen',
      displayOnlyInTheseDevices: 'Nur in diesem Gerät ([0]) Bestellungen anzeigen von',
      clientDiscount: 'Rabatt',
      lock: 'Sperren',
      stockThreshold: 'Lagergrenzwert',
      service: 'Dienst',
      withTimer: 'Mit Timer',
      cardNumberOrTelephone: 'Kartennummer oder Telefonnummer',
      priceType: 'Preistyp',
      priceCalculation: 'Preisberechnung',
      applyToTables: 'Auf Tische anwenden',
      receiptForAllOrders: 'Quittung für alle Bestellungen',
      parent: 'Elternteil',
      child: 'Kind',
      twilioFriendlyName: 'Nummer/Name',
      smsSucces: 'SMS erfolgreich gesendet.',
      SalesOrder: 'Verkaufsauftrag',
      StockChange: 'Lageränderung',
      StockReset: 'Lager zurücksetzen',
      VendorPurchase: 'Einkauf',
      showProduct: 'Produkt anzeigen',
      showCategory: 'Kategorie anzeigen',
      showMaker: 'Hersteller anzeigen',
      showAllTableTotals: 'Gesamtsumme aller (Tische) anzeigen',
      regularInvoiceForAllOrders: 'Reguläre Rechnung für alle Bestellungen',
      totalQuantity: 'Gesamtmenge',
      roles: {
        Admin: 'Administrator',
        Waiter: 'Kellner',
        Kamarier: 'Kellner',
        Menaxher: 'Manager',
        Depoist: 'Lager',
        Staf: 'Mitarbeiter',
        Salesman: 'Verkäufer',
        Display: 'Anzeige'
      },
      approveFreePayment: 'Kostenlos genehmigen',
      purchasePriceWithoutVat: 'Einkaufspreis (ohne MwSt.)',
      vendorName: 'Lieferant',
      totalWithouVat0: 'Gesamtbetrag ohne MwSt. 0%',
      totalWithoutVat8: 'Gesamtbetrag ohne MwSt. (8%)',
      vatAmount8: 'MwSt.-Betrag (8%)',
      totalWithoutVat18: 'Gesamtbetrag ohne MwSt. (18%)',
      vatAmount18: 'MwSt.-Betrag (18%)',
      applyToProducts: 'Auf Produkte anwenden',
      sellPrice: 'Verkaufspreis',
      margin: 'Marge',
      deliveryType: 'Lieferart',
      totalCurrentPrice: 'Gesamtpreis aktuell',
      configLabels: {
        hideDeliveryTotals: 'Hide delivery totals',
        printerNameTicket: 'Printer name in tickets',
        cardPaymentFee: 'Card payment fee',
        fiscalExtraMessage: 'Fiscal: extra text',
        reservationDuration: 'Reservation duration (hour)',
        mobileHideTotal: 'PostomGo: Hide total',
        courseSpliters: 'Course spliters',
        waiterSelfHandouts: 'Kellner darf Handzettel selbst ausdrucken',
        liveTickerNoActions: 'Live-Ticker: Keine Aktionen anzeigen',
        chooseFiscalThermalPrinter: 'Wähle den fiskalischen Thermodrucker',
        employeeClocktimeProductSales: 'Verkaufte Produkte auf Handzetteldruck anzeigen',
        searchClientCards: '"Suche" in Kundenkarten anzeigen',
        chooseGeneralPrinter: 'Hauptdrucker auswählen',
        duplicatePrinter: 'Drucker duplizieren',
        duplicateGeneralPrinter: 'Den Hauptdrucker duplizieren',
        chooseFiscalPrinter: 'Fiskaldrucker auswählen',
        chooseInvoicePrinter: 'Rechnungsdrucker',
        duplicateInvoicePrinter: 'Einen Drucker, der die Rechnung druckt, duplizieren',
        chooseCashOnPrinter: 'Auszahlungsdrucker auswählen',
        chooseFinalInvoicePrinter: 'Drucker für Nichtfiskalbelege auswählen',
        duplicateFinalInvoicePrinter: 'Einen Drucker, der den endgültigen Beleg druckt, duplizieren',
        finalInvoiceQuantity: 'Anzahl der Belegkopien',
        notRestaurant: 'Kein Restaurant/Bar',
        allowNegativeStock: 'Negative Lagerbestände zulassen',
        fiscalConfirm: 'Bestätigung für fiskalische Belege',
        defaultDelivery: 'Standardlieferung',
        manualFreeTable: 'Tisch manuell freigeben',
        kitchenPrinter: 'Küche/Drucker',
        cardPayment: 'Zahlung per Karte',
        directOrder: 'Direktbestellung',
        showTotalOnNonfiscal: 'Gesamtsumme auf Nichtfiskalbeleg anzeigen',
        orderTotalNonFiscalOptional: '(Optional) Gesamtsumme auf Nichtfiskalbeleg anzeigen',
        showCommentsOnNonfiscal: 'Kommentare auf nichtfiskalischem Beleg anzeigen',
        orderNrOnFiscal: 'Bestellnummer auf fiskalischem Beleg',
        fixedShift: 'Startbetrag',
        adminCashShift: 'Bargeldstart (für Admins)',
        orderToKitchenAfterPayment: 'Bestellung nach Bezahlung an die Küche senden',
        returnToTableAfterOrder: 'Nach der Bestellung zur Tischansicht zurückkehren',
        logoutAfterOrder: 'Nach der Bestellung ausloggen',
        returnToTableAfterPayment: 'Nach der Bezahlung zur Tischansicht zurückkehren',
        logoutAfterPayment: 'Nach der Bezahlung ausloggen',
        managerCashOut: 'Manager darf Kellner abrechnen',
        dontIncludeCustomersIdinSale: 'Kunden-ID nicht in den Verkauf aufnehmen',
        approvalDamages: 'Beschädigungen benötigen eine Genehmigung',
        mobilePos: 'Mobiles POS aktivieren',
        closeAutomatically: 'Automatisch schließen',
        transfers: 'Überweisungen',
        approveProgramClose: 'Programmschließung genehmigen',
        codeAndMakers: 'Code und Hersteller in Produkten',
        enableMinimize: 'App-Minimierung aktivieren<br/> <small>(gilt nur für dieses Gerät)</small>',
        liveTicker: 'Live-Ticker',
        liveTickerAllOrders: 'Live-Ticker: Nur Kellnerbestellungen anzeigen',
        liveTickerSalesmanAllOrders: 'Live-Ticker: Nur Verkäuferbestellungen anzeigen',
        handoutsCalculateCard: 'Verkauf mit Bank im Handzettel berechnen',
        autoStart: 'Automatischer Start (gilt nur für dieses Gerät)',
        printQuantityFromLeft: 'Menge links (Druck)',
        disableOrderComments: 'Bestellkommentare deaktivieren',
        freePaymentConfirm: 'Kostenlos mit Bestätigung',
        displays: 'Displays',
        onlyFiscal: 'Nur fiskalisch',
        isService: 'Ist Service',
        serviceClient: 'Kinderspielplatz',
        directOnlyFiscal: 'Direkt fiskalisch'
      },
      reportsLabels: {
        salesTypeReport: 'Verkaufsart-Bericht',
        businessDayClose: 'Tagesabschluss'
      },
      weekdays: {
        monday: 'Montag',
        tuesday: 'Dienstag',
        wednesday: 'Mittwoch',
        thursday: 'Donnerstag',
        friday: 'Freitag',
        saturday: 'Samstag',
        sunday: 'Sonntag'
      }
    },
    mainMenu: {
      reports: {
        tableTransfers: 'Transfers',
        name: 'Berichte',
        sales: 'Verkäufe',
        productSales: 'Produktverkäufe',
        hourlySales: 'Stundenverkäufe',
        purchases: 'Einkäufe',
        stockChanges: 'Lageränderungen',
        handovers: 'Übergaben',
        waiterRankings: 'Rangliste der Kellner',
        delivery: 'Lieferung',
        ingredients: 'Zutaten',
        damages: 'Schäden',
        clients: 'Kunden',
        startEndSalesDay: 'Start/Ende Verkaufstag',
        categorySales: 'Kategorieverkäufe',
        staff: 'Personal',
        salesByMaker: 'Verkäufe nach Hersteller',
        deliveryClients: 'Lieferkunden',
        productByCompoundItemsSales: 'Verkäufe nach Add-Ons',
        salesBook: 'Verkaufsbuch',
        purchaseBook: 'Einkaufsbuch',
        regularInvoices: 'Reguläre Rechnungen',
        productSalesInterval: 'Produktverkaufsintervall',
        paymentMethods: 'Zahlungsmethoden',
        vatSales: 'MwSt.-Verkäufe',
        purchaseProducts: 'Einkaufsprodukte',
        duePayments: 'Ausstehende Zahlungen',
        returnedProducts: 'Returned products',
        reservations: 'Reservations'
      },
      menu: 'Menü',
      categories: 'Kategorien',
      products: 'Produkte',
      priceList: 'Preislisten',
      floorPlan: 'Grundriss',
      stock: {
        name: 'Lager',
        changeStock: 'Lagerbestand ändern',
        stockCutoff: 'Lagerabschnitt',
        inventoryLocations: 'Lagerorte',
        stockThreshold: 'Lagergrenzwert',
        transactions: 'Produkttransaktionen',
        transactionsPeriod: 'Product transactions period'
      },
      purchases: 'Einkäufe',
      config: {
        name: 'Einstellungen',
        printers: 'Drucker',
        measuringUnits: 'Maßeinheiten',
        vat: 'MwSt.',
        users: 'Benutzer',
        vendors: 'Lieferanten',
        discounts: 'Rabatte',
        clients: 'Kunden',
        accessPoints: 'Zugangspunkte',
        makers: 'Hersteller',
        audit: 'Audit',
        license: 'Lizenz',
        displays: 'Anzeigen',
        invoiceClients: 'Kontakte',
        reservationClients: 'Reservation clients'
      }
    },
    exportFiles: {
      raporti_transfereve_tavolinave: 'table_transfers_report',
      raporti_shitjeve: 'Verkaufsbericht',
      raporti_klientave: 'Kundenbericht',
      raporti_barazimeve: 'Übergabebuch',
      raporti_perberesave: 'Zutatenbericht',
      raporti_demtimeve: 'Schadensbericht',
      raporti_delivery: 'Lieferbericht',
      raporti_kamarierave: 'Kellnerbericht',
      raporti_shitjeve_produkt_sipas_ores: 'Stundenweise Verkaufsbericht für Produkte',
      raporti_shitjeve_produkt: 'Verkaufsbericht für Produkte',
      raporti_blerjeve: 'Einkaufsbericht',
      raporti_shitjeve_kategorise: 'Verkaufsbericht nach Kategorie',
      raporti_shitjeve_prodhuesit: 'Verkaufsbericht nach Hersteller',
      raporti_staf: 'Mitarbeiterbericht',
      raporti_fillimit_mbarimit: 'Bericht für den Verkaufsstart/-abschluss des Tages',
      raporti_ndryshimit_stokut: 'Lageränderungsbericht',
      raporti_stokut: 'Lagerbericht',
      prerja_stokut: 'Lagerreset',
      product_transactions: 'Produkttransaktionsbericht',
      raporti_faturave_rregullta: 'Bericht für reguläre Rechnungen',
      raporti_shitje_produkt_interval: 'Bericht für den Produktverkaufsintervall',
      lista_produkteve: 'Liste der Produkte',
      raporti_shitjeve_produkt_interval_ores: 'Bericht für den Produktverkaufsintervall nach Stunden',
      raporti_shitjeve_menyres_pageses: 'Bericht für die Verkaufsmethoden',
      raporti_shitjeve_tvsh: 'MwSt.-Verkaufsbericht',
      raporti_blerjeve_produktet: 'Bericht für Einkaufsprodukte',
      raporti_borxhit: 'due_payments_report',
      raporti_kthimit_mallit: 'returned_products_report',
      raporti_rezervimeve: 'reservations_report',
      raporti_auditimit: 'audit_report'
    },
    licenseMessages: {
      LICENSESUCCESS: 'Lizenz erfolgreich aktiviert.',
      INVALIDSIGNATURE: 'Die Lizenz wurde geändert und ist ungültig!',
      INVALIDLICENCETOTHISDEVICE: 'Die Lizenz ist nicht für dieses Gerät gültig!',
      INVALIDLICENCE: 'Die Lizenz ist abgelaufen!',
      LICENCECONVERTERROR: 'Der Text der Lizenz wurde geändert, die Lizenz ist ungültig!',
      NOLICENSEFOUND: 'Dieses Gerät ist nicht lizenziert! Bitte kontaktieren Sie STOM LLC unter +383 46 333 444!',
      licenseWarning: 'Die Anwendungslizenz läuft in |daysLicenseExpire| Tagen ab, am |expireDate|. ' +
        'Bitte aktivieren Sie die Lizenz rechtzeitig, um die Anwendung nach dem Ablaufdatum der Lizenz weiter nutzen zu können. ' +
        'Um die Lizenz zu aktivieren, kontaktieren Sie STOM shpk unter +383 49 313 526.'
    }
  }
}

export default messages



// WEBPACK FOOTER //
// ./src/lang/lang.js